var catalog_section =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(285);
	__webpack_require__(204);
	__webpack_require__(210);
	__webpack_require__(212);
	__webpack_require__(130);
	__webpack_require__(149);
	__webpack_require__(189);
	__webpack_require__(161);
	__webpack_require__(151);
	__webpack_require__(346);
	__webpack_require__(215);
	__webpack_require__(155);
	__webpack_require__(168);
	__webpack_require__(318);
	__webpack_require__(348);
	__webpack_require__(296);

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(50);
	
	jQuery(function () {
	    module.exports.params = {
	        infinite: true,
	        adaptiveHeight: true,
	        slidesToScroll: 1,
	        speed: 400
	    };
	
	    module.exports.paramsCssAnim = {
	        cssEase: 'ease',
	        useTransform: true,
	        speed: 600
	    };
	});

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	    // Returns a function, that, as long as it continues to be invoked, will not
	    // be triggered. The function will be called after it stops being called for
	    // N milliseconds. If `immediate` is passed, trigger the function on the
	    // leading edge, instead of the trailing.
	    debounce: function debounce(func, wait, immediate) {
	        var timeout;
	        return function () {
	            var context = this,
	                args = arguments;
	            var later = function later() {
	                timeout = null;
	                if (!immediate) func.apply(context, args);
	            };
	            var callNow = immediate && !timeout;
	            clearTimeout(timeout);
	            timeout = setTimeout(later, wait);
	            if (callNow) func.apply(context, args);
	        };
	    },
	
	    setResizeDebounce: function setResizeDebounce(func, wait, immediate) {
	        wait = wait || 250;
	        immediate = immediate || false;
	        var thisD = this;
	        var debouncedFunc = thisD.debounce(func, wait, immediate);
	        $(window).resize(debouncedFunc);
	    }
	};

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$defineProperties = __webpack_require__(56)['default'];
	
	module.exports = _Object$defineProperties({}, {
	    defaultFontSize: {
	        get: function get() {
	            var defaultFontSize = parseInt($('html').css('font-size'));
	            if (isNaN(defaultFontSize)) defaultFontSize = 16;
	            return defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    mobile: {
	        get: function get() {
	            return 20 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    mobileBig: {
	        get: function get() {
	            return 28 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    tablet: {
	        get: function get() {
	            return 48 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    tabletBig: {
	        get: function get() {
	            return 60 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    desktop: {
	        get: function get() {
	            return 76.5 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    }
	});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(57), __esModule: true };

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(58);
	var $Object = __webpack_require__(61).Object;
	module.exports = function defineProperties(T, D) {
	  return $Object.defineProperties(T, D);
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(59);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(69), 'Object', { defineProperties: __webpack_require__(75) });


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(60);
	var core = __webpack_require__(61);
	var ctx = __webpack_require__(62);
	var hide = __webpack_require__(64);
	var has = __webpack_require__(74);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(63);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(65);
	var createDesc = __webpack_require__(73);
	module.exports = __webpack_require__(69) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(66);
	var IE8_DOM_DEFINE = __webpack_require__(68);
	var toPrimitive = __webpack_require__(72);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(69) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(67);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(69) && !__webpack_require__(70)(function () {
	  return Object.defineProperty(__webpack_require__(71)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(70)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(67);
	var document = __webpack_require__(60).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(67);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(65);
	var anObject = __webpack_require__(66);
	var getKeys = __webpack_require__(76);
	
	module.exports = __webpack_require__(69) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(77);
	var enumBugKeys = __webpack_require__(90);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(74);
	var toIObject = __webpack_require__(78);
	var arrayIndexOf = __webpack_require__(82)(false);
	var IE_PROTO = __webpack_require__(86)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(79);
	var defined = __webpack_require__(81);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(80);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(78);
	var toLength = __webpack_require__(83);
	var toAbsoluteIndex = __webpack_require__(85);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(84);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(84);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(87)('keys');
	var uid = __webpack_require__(89);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(61);
	var global = __webpack_require__(60);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(88) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 88 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(112);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(113);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(114), __esModule: true };

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(115);
	var $Object = __webpack_require__(61).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(59);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(69), 'Object', { defineProperty: __webpack_require__(65).f });


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(117);

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(119);

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};

/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports) {

	module.exports = $;

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerEvents = __webpack_require__(131);
	
	var _trackerEvents2 = _interopRequireDefault(_trackerEvents);
	
	__webpack_require__(147);
	
	var event = new _trackerEvents2['default']();
	event.onShowProductCard();
	
	$('#toogle_open').click(function () {
	    $('.li_toogle').css('display', 'list-item');
	    $('.li_toogle').addClass('li_toogle_close');
	    $('#toogle_open').css('display', 'none');
	    $('#toogle_close').css('display', 'block');
	});
	$('#toogle_close').click(function () {
	    $('.li_toogle').css('display', 'none');
	    $('.li_toogle').removeClass('li_toogle_close');
	    $('#toogle_open').css('display', 'block');
	    $('#toogle_close').css('display', 'none');
	});

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _extends = __webpack_require__(132)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _tracker = __webpack_require__(140);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	Element.prototype.parents = function (selector) {
	    var elements = [];
	    var elem = this;
	    var ishaveselector = selector !== undefined;
	
	    while ((elem = elem.parentElement) !== null) {
	        if (elem.nodeType !== Node.ELEMENT_NODE) {
	            continue;
	        }
	
	        if (!ishaveselector || elem.matches(selector)) {
	            elements.push(elem);
	        }
	    }
	
	    return elements;
	};
	
	var Events = (function () {
	    function Events() {
	        _classCallCheck(this, Events);
	
	        this.searchData = [];
	    }
	
	    _createClass(Events, [{
	        key: 'init',
	        value: function init() {
	            var self = this;
	            this.onClickSoc();
	            this.onClickCity();
	            this.onClickSocIcon();
	            this.onClickProductTabs();
	            this.onClickProductPdf();
	            this.onClickPhone();
	            this.onClickTabs();
	            this.showMainBanner();
	            this.showSpecBanner();
	            this.onClickMainPromo();
	            this.onShowWatched();
	            this.onShowAnalog();
	            this.onClickProductCatalogBlock();
	            this.onClickWatched();
	            this.onClickAnalog();
	            this.onShowCatalogProducts();
	
	            setTimeout(function () {
	                self.onShowNewProducts();
	                self.onClickNewProducts();
	            }, 1000);
	        }
	    }, {
	        key: 'onClickSoc',
	        value: function onClickSoc() {
	            $('body').on('click', '.footer__column--social a', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent(data);
	            });
	        }
	    }, {
	        key: 'onClickTabs',
	        value: function onClickTabs() {
	            $('body').on('click', '.tabs__tab--cloud', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent(data);
	            });
	        }
	    }, {
	        key: 'onClickPhone',
	        value: function onClickPhone() {
	            $('body').on('click', '.city-data-block__phones-link', function (e) {
	                var trackers = new _tracker2['default']();
	                trackers.onPMbtnTel();
	            });
	        }
	    }, {
	        key: 'onClickProductTabs',
	        value: function onClickProductTabs() {
	            $('body').on('click', '.product-card__tabs .tabs__tab', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent(data);
	            });
	        }
	    }, {
	        key: 'onClickProductPdf',
	        value: function onClickProductPdf() {
	            $('body').on('click', '.product-card__previews-item--pdf', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickPdf(data);
	            });
	        }
	    }, {
	        key: 'onClickSocIcon',
	        value: function onClickSocIcon() {
	            $('body').on('click', '.bottom-menu__text-contacts-icon', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent(data);
	            });
	        }
	    }, {
	        key: 'onClickCity',
	        value: function onClickCity() {
	            $('body').on('click', '.cities-list .cities-list__item a', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent({
	                    event: 'PMbtnSelectCity',
	                    param: data.code
	                });
	            });
	        }
	
	        /**
	         * ловим события баннера на главной странице
	         */
	    }, {
	        key: 'showMainBanner',
	        value: function showMainBanner() {
	            var localBanners = [];
	            var self = this;
	            $('.js-slick-fullwidth-slider').on('init', function (event, slick) {
	                var activeBanner = document.querySelectorAll('.fullwidth-slider .slick-track .slick-active');
	                var bannerId = self.sendItemBanner(localBanners, activeBanner[0].dataset, 'indexTopSlider');
	                localBanners.push(bannerId);
	            }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
	                var activeBanner = document.querySelectorAll('.fullwidth-slider .slick-track .slick-active');
	                var bannerId = self.sendItemBanner(localBanners, activeBanner[0].dataset, 'indexTopSlider');
	                localBanners.push(bannerId);
	            });
	        }
	    }, {
	        key: 'showSpecBanner',
	        value: function showSpecBanner() {
	            var localBanners = [];
	            var specBanners = document.querySelectorAll('.block-list--promos a.tiles__item--promo');
	            var self = this;
	
	            specBanners.forEach(function (element, index) {
	                var banner = {
	                    id: element.dataset.id,
	                    name: element.dataset.name,
	
	                    position: 'slot' + index
	                };
	                var bannerId = self.sendItemBanner(localBanners, banner, 'indexBannerSpec');
	                localBanners.push(bannerId);
	            });
	        }
	    }, {
	        key: 'sendItemBanner',
	        value: function sendItemBanner(localBanners, activeBanner, name) {
	            if (activeBanner !== undefined) {
	                if (localBanners.indexOf(activeBanner.id) === -1) {
	                    var _trackers = new _tracker2['default']();
	                    _trackers.onViewPromo({
	                        promoView: {
	                            promotions: [{
	                                id: activeBanner.id,
	                                name: name,
	                                creative: activeBanner.name,
	                                position: activeBanner.position
	                            }]
	                        }
	                    });
	                    localBanners.push(activeBanner.id);
	                    return activeBanner.id;
	                }
	            }
	        }
	    }, {
	        key: 'onClickMainPromo',
	        value: function onClickMainPromo() {
	            $('body').on('click', '.block-list.block-list--promos a', function (e) {
	                var dataId = this.getAttribute('data-id');
	                var dataName = this.getAttribute('data-name');
	                var trackers = new _tracker2['default']();
	                var dataNumber = 0;
	                if (this.parentNode.classList.contains('tiles__item--action-content')) {
	                    dataNumber = parseInt($(this.parentNode.parentNode).index()) + 1;
	                } else {
	                    dataNumber = parseInt($(this).index()) + 1;
	                }
	                trackers.onClickPromo({
	                    promoClick: {
	                        promotions: [{
	                            id: dataId,
	                            name: dataName,
	                            creative: 'banner' + dataNumber,
	                            position: 'slot' + dataNumber
	                        }]
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'onShowNewProducts',
	        value: function onShowNewProducts() {
	            var productData = [];
	            var self = this;
	            var products = document.querySelectorAll('.products-slider .products-slider__item');
	            products.forEach(function (item, index) {
	                var productsData = self.prepareData(item);
	                var product = _extends({
	                    list: 'newProducts',
	                    position: index
	                }, productsData);
	
	                productData.push(product);
	            });
	
	            var trackers = new _tracker2['default']();
	
	            if (productData.length > 0) {
	                trackers.onShowNewProducts({
	                    impressions: productData
	                });
	            }
	        }
	    }, {
	        key: 'onShowWatched',
	        value: function onShowWatched() {
	            var productData = [];
	            var self = this;
	            var products = document.querySelectorAll('.also-viewed .grid__item');
	            products.forEach(function (item, index) {
	                var productsData = self.prepareData(item);
	                var product = _extends({
	                    list: 'WatchedProducts',
	                    position: index
	                }, productsData);
	
	                productData.push(product);
	            });
	
	            var trackers = new _tracker2['default']();
	
	            if (productData.length > 0) {
	                trackers.onShowWatchedProducts({
	                    impressions: productData
	                });
	            }
	        }
	    }, {
	        key: 'onShowAnalog',
	        value: function onShowAnalog() {
	            var productData = [];
	            var self = this;
	            var products = document.querySelectorAll('.site-block .tabs__content .grid__item');
	            products.forEach(function (item, index) {
	                var productsData = self.prepareData(item);
	                var product = _extends({
	                    list: 'AnalogProducts',
	                    position: index
	                }, productsData);
	
	                productData.push(product);
	            });
	
	            var trackers = new _tracker2['default']();
	
	            if (productData.length > 0) {
	                trackers.onShowAnalogProducts({
	                    impressions: productData
	                });
	            }
	        }
	
	        /**
	         * отображение каталога, отправляем пачками по 8 элементов. Когда появляется 1ый из группы
	         */
	    }, {
	        key: 'onShowCatalogProducts',
	        value: function onShowCatalogProducts() {
	            var products = [];
	            var productNodes = document.querySelectorAll('.catalog #catalog__products .grid__item');
	            var self = this;
	
	            productNodes.forEach(function (item, index) {
	                if (index % 8 === 0) {
	                    new Waypoint.Inview({
	                        element: item,
	                        enter: function enter() {
	                            if (products.indexOf(index) === -1) {
	                                (function () {
	                                    var productsArr = Array.prototype.slice.call(productNodes).slice(index, index + 8);
	                                    var productsList = [];
	
	                                    products.push(index);
	
	                                    productsArr.forEach(function (elem, i) {
	                                        var productData = self.prepareData(elem);
	                                        productsList.push(_extends({
	                                            list: 'catalogProducts',
	                                            position: index + i + 1
	                                        }, productData));
	                                    });
	                                    var trackers = new _tracker2['default']();
	
	                                    if (productsList.length > 0) {
	                                        trackers.onShowcatalogProducts({
	                                            impressions: productsList
	                                        });
	                                    }
	                                })();
	                            }
	                        }
	                    });
	                }
	            });
	        }
	
	        /**
	         * отображение каталога в поиске, отправляем пачками по 10 элементов. Когда появляется 1ый из группы
	         */
	    }, {
	        key: 'onShowSearchProducts',
	        value: function onShowSearchProducts() {
	            var productNodes = document.querySelectorAll('.search_container #catalog__products .grid__item');
	            var self = this;
	
	            productNodes.forEach(function (item, index) {
	                if (index % 10 === 0) {
	                    new Waypoint.Inview({
	                        element: item,
	                        enter: function enter() {
	                            if (self.searchData.indexOf(index) === -1) {
	                                (function () {
	                                    var productsArr = Array.prototype.slice.call(productNodes).slice(index, index + 10);
	                                    var productsList = [];
	
	                                    self.searchData.push(index);
	
	                                    productsArr.forEach(function (elem, i) {
	                                        var productData = self.prepareData(elem);
	                                        productsList.push(_extends({
	                                            list: 'searchProducts',
	                                            position: index + i + 1
	                                        }, productData));
	                                    });
	                                    var trackers = new _tracker2['default']();
	
	                                    if (productsList.length > 0) {
	                                        trackers.onShowcatalogProducts({
	                                            impressions: productsList
	                                        });
	                                    }
	                                })();
	                            }
	                        }
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'onClickProductCatalogBlock',
	        value: function onClickProductCatalogBlock() {
	            var self = this;
	
	            $('.grid.catalog .product').on('click', 'a', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.grid__item')[0]).index('#catalog__products .grid__item') + 1;
	                var product = _extends({
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'catalogProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickCatalogProducts({
	                    click: {
	                        actionField: {
	                            list: 'catalogProducts'
	                        }
	                    },
	                    products: [product]
	                });
	            });
	        }
	    }, {
	        key: 'onClickProductSearchBlock',
	        value: function onClickProductSearchBlock() {
	            var self = this;
	            $('.search_container .grid .product').on('click', 'a', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.grid__item')[0]).index('#catalog__products .grid__item') + 1;
	                var product = _extends({
	                    list: 'searchProducts',
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'searchProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickCatalogProducts({
	                    click: {
	                        actionField: {
	                            list: 'searchProducts'
	                        }
	                    },
	                    products: [product]
	                });
	            });
	        }
	    }, {
	        key: 'onClickWatched',
	        value: function onClickWatched() {
	            var self = this;
	            $('.also-viewed.grid .product').on('click', 'a, img', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.grid__item')[0]).index('.also-viewed .grid__item') + 1;
	                var product = _extends({
	                    list: 'WatchedProducts',
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'WatchedProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickWatched({
	                    click: {
	                        actionField: {
	                            list: 'WatchedProducts'
	                        }
	                    },
	                    products: [product]
	                });
	            });
	        }
	    }, {
	        key: 'onClickAnalog',
	        value: function onClickAnalog() {
	            var self = this;
	            $('.site-block .tabs__content .grid__item .product').on('click', 'a', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.grid__item')[0]).index('.site-block .tabs__content .grid__item') + 1;
	                var product = _extends({
	                    list: 'AnalogProducts',
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'AnalogProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickAnalog({
	                    click: {
	                        actionField: {
	                            list: 'AnalogProducts'
	                        }
	                    },
	                    products: [product]
	                });
	            });
	        }
	    }, {
	        key: 'onClickNewProducts',
	        value: function onClickNewProducts() {
	            var self = this;
	            $('.products-slider .products-slider__item .product').on('click', 'a', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.products-slider__item')[0]).index('.products-slider .products-slider__item') + 1;
	                var product = _extends({
	                    list: 'newProducts',
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'newProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickNewProducts({
	                    click: {
	                        actionField: {
	                            list: 'newProducts'
	                        }
	                    },
	                    products: [product]
	                });
	            });
	        }
	    }, {
	        key: 'onShowProductCard',
	        value: function onShowProductCard() {
	            var self = this;
	            if ($('.product-card').length > 0) {
	                var productDom = $('.product-card')[0];
	                var _productData = self.prepareData(productDom);
	                var product = _extends({}, _productData);
	
	                var _trackers2 = new _tracker2['default']();
	                _trackers2.onShowProductCard({
	                    detail: {
	                        actionField: {
	                            list: localStorage.getItem('list')
	                        }
	                    },
	                    products: [product]
	                });
	            }
	        }
	    }, {
	        key: 'onShowProductCardPopup',
	        value: function onShowProductCardPopup() {
	            var self = this;
	            var productDom = $('.product-card')[0];
	            var productData = self.prepareData(productDom);
	            var product = _extends({}, productData);
	
	            var trackers = new _tracker2['default']();
	            trackers.onShowProductCardPopup({
	                detail: {
	                    actionField: {
	                        list: localStorage.getItem('list')
	                    }
	                },
	                products: [product]
	            });
	        }
	    }, {
	        key: 'onAddToCardProduct',
	        value: function onAddToCardProduct(elem) {
	            //проверяем откуда клик на добавление в корзину (карточка, списки)
	            if (elem.hasClass('product-card__btn')) {
	                this.addToCardFromCard(elem);
	            } else {
	                this.addToCardFromList(elem);
	            }
	        }
	    }, {
	        key: 'addToCardFromCard',
	        value: function addToCardFromCard(elem) {
	            var self = this;
	            var productDom = elem.parents('.product-card')[0];
	            var productData = self.prepareData(productDom);
	            var product = _extends({
	                quantity: 1
	            }, productData);
	            var trackers = new _tracker2['default']();
	            trackers.addToCardFromCard({
	                add: {
	                    products: [product]
	                }
	            });
	        }
	    }, {
	        key: 'addToCardFromList',
	        value: function addToCardFromList(elem) {
	            var self = this;
	            var productDom = elem.parents('.product')[0];
	            var position = 0;
	            var list = '';
	            var productData = self.prepareData(productDom);
	
	            if (elem.parents('.catalog #catalog__products').length > 0) {
	                list = 'catalogProducts';
	                position = $(elem.parents('.grid__item')).index('#catalog__products .grid__item') + 1;
	            } else if (elem.parents('.slick-track').length > 0) {
	                list = 'newProducts';
	                position = $(elem.parents('.products-slider__item')).index('.slick-track .products-slider__item') + 1;
	            } else if (elem.parents('div[data-tab="analogs"]').length > 0) {
	                list = 'AnalogProducts';
	                position = $(elem.parents('.grid__item')).index('div[data-tab="analogs"] .grid__item') + 1;
	            } else if (elem.parents('.also-viewed').length > 0) {
	                list = 'WatchedProducts';
	                position = $(elem.parents('.grid__item')).index('.also-viewed .grid__item') + 1;
	            } else if (elem.parents('.search_container').length > 0) {
	                list = 'searchProducts';
	                position = $(elem.parents('.grid__item')).index('.search_container .grid__item') + 1;
	            }
	            var trackers = new _tracker2['default']();
	
	            var product = _extends({
	                list: list,
	                position: position
	            }, productData);
	
	            trackers.onClickCatalogProducts({
	                click: {
	                    actionField: {
	                        list: list
	                    }
	                },
	                products: [product]
	            });
	
	            product = _extends({}, productData);
	
	            trackers.onShowProductCard({
	                detail: {
	                    actionField: {
	                        list: list
	                    }
	                },
	                products: [product]
	            });
	
	            product = _extends({
	                quantity: 1
	            }, productData);
	
	            trackers.addToCardFromList({
	                add: {
	                    products: [product]
	                }
	            });
	        }
	    }, {
	        key: 'onClickCartAddProduct',
	        value: function onClickCartAddProduct(dataProductId, quantityOld, quantityChange) {
	            var product = document.querySelectorAll('div[data-product-id="' + dataProductId + '"]');
	
	            var productData = [];
	            var trackers = new _tracker2['default']();
	
	            var dataName = product[0].getAttribute('data-product-name');
	            var dataPrice = product[0].getAttribute('data-product-price');
	            var dataBrand = product[0].getAttribute('data-product-brand');
	            var dataCategory = product[0].getAttribute('data-product-category');
	
	            var products = {
	                name: dataName,
	                id: dataProductId,
	                price: dataPrice,
	                brand: dataBrand,
	                category: dataCategory,
	                quantity: quantityChange - quantityOld
	            };
	
	            productData.push(products);
	
	            if (productData.length > 0) {
	                trackers.onClickAddProduct({
	                    add: {
	                        products: productData
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'onClickCartRemoveProduct',
	        value: function onClickCartRemoveProduct(dataProductId, quantityOld, quantityChange) {
	            var product = document.querySelectorAll('div[data-product-id="' + dataProductId + '"]');
	
	            var productData = [];
	            var trackers = new _tracker2['default']();
	
	            var dataName = product[0].getAttribute('data-product-name');
	            var dataPrice = product[0].getAttribute('data-product-price');
	            var dataBrand = product[0].getAttribute('data-product-brand');
	            var dataCategory = product[0].getAttribute('data-product-category');
	
	            var products = {
	                name: dataName,
	                id: dataProductId,
	                price: dataPrice,
	                brand: dataBrand,
	                category: dataCategory,
	                quantity: quantityOld - quantityChange
	            };
	
	            productData.push(products);
	
	            if (productData.length > 0) {
	                trackers.onClickRemoveProduct({
	                    remove: productData
	                });
	            }
	        }
	    }, {
	        key: 'onShowOrderCartStep1',
	        value: function onShowOrderCartStep1(data) {
	            var productData = [];
	            var trackers = new _tracker2['default']();
	
	            for (var productItem in data.PRODUCTS) {
	                var item = data.PRODUCTS[productItem];
	
	                var product = {
	                    name: item.NAME,
	                    id: item.ID,
	                    price: item.PRICE,
	                    brand: data.BRANDS[item.PROPERTY_BREND_VALUE],
	                    category: item.CATEGORY,
	                    quantity: item.QUANTITY
	                };
	                productData.push(product);
	            }
	            if (productData.length > 0) {
	                trackers.onShowOrderCartStep1({
	                    checkout: {
	                        actionField: {
	                            step: 1
	                        },
	                        products: productData
	                    }
	                });
	            }
	        }
	
	        /**
	         * подгоовка данных
	         * @param elem
	         * @returns {{price: number, name: string, category: number, brand: number}}
	         */
	    }, {
	        key: 'prepareData',
	        value: function prepareData(elem) {
	            var name = '';
	            if (elem.querySelector('[data-name]') !== null && elem.querySelector('[data-name]').dataset.name !== undefined) {
	                name = elem.querySelector('[data-name]').dataset.name;
	            }
	
	            var productId = '';
	            if (elem.querySelector('[data-product-id]') !== null && elem.querySelector('[data-product-id]').dataset.productId !== undefined) {
	                productId = elem.querySelector('[data-product-id]').dataset.productId;
	            }
	
	            var price = 0;
	            if (elem.querySelector('[data-price]') !== null && elem.querySelector('[data-price]').dataset.price !== undefined) {
	                price = elem.querySelector('[data-price]').dataset.price;
	            }
	
	            var brand = 0;
	            if (elem.querySelector('[data-brand]') !== null && elem.querySelector('[data-brand]').dataset.brand !== undefined) {
	                brand = elem.querySelector('[data-brand]').dataset.brand;
	            }
	
	            var category = 0;
	            if (elem.querySelector('[data-category]') !== null && elem.querySelector('[data-category]').dataset.category !== undefined) {
	                category = elem.querySelector('[data-category]').dataset.category;
	            }
	
	            return {
	                name: name,
	                price: price,
	                brand: brand,
	                category: category,
	                id: productId
	            };
	            for (var productItem in data.PRODUCTS) {
	                var item = data.PRODUCTS[productItem];
	
	                var product = {
	                    name: item.NAME,
	                    id: item.ID,
	                    price: item.PRICE,
	                    brand: data.BRANDS[item.PROPERTY_BREND_VALUE],
	                    category: item.CATEGORY,
	                    quantity: item.QUANTITY
	                };
	                productData.push(product);
	            }
	            if (productData.length > 0) {
	                trackers.onShowOrderCartStep1({
	                    checkout: {
	                        actionField: {
	                            step: 1
	                        },
	                        products: productData
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'onShowOrderStep',
	        value: function onShowOrderStep(param) {
	            var step = 1;
	            if (param) {
	                step = param;
	            }
	            var productData = [];
	            var trackers = new _tracker2['default']();
	
	            var products = document.querySelectorAll('.cart .cart__item.basket__cart__item.cart__item--checkout');
	            products.forEach(function (item, index) {
	                var name = '';
	                if (item.getAttribute('data-product-name') !== null && item.getAttribute('data-product-name') !== undefined) {
	                    name = item.getAttribute('data-product-name');
	                }
	
	                var price = 0;
	                if (item.getAttribute('data-product-price') !== null && item.getAttribute('data-product-price') !== undefined) {
	                    price = item.getAttribute('data-product-price');
	                }
	
	                var brand = 0;
	                if (item.getAttribute('data-product-brand') !== null && item.getAttribute('data-product-brand') !== undefined) {
	                    brand = item.getAttribute('data-product-brand');
	                }
	
	                var category = 0;
	                if (item.getAttribute('data-product-category') !== null && item.getAttribute('data-product-category') !== undefined) {
	                    category = item.getAttribute('data-product-category');
	                }
	
	                var quantity = 0;
	                if (item.querySelectorAll('.quantity__value')[0].value !== null && item.querySelectorAll('.quantity__value')[0].value !== undefined) {
	                    quantity = item.querySelectorAll('.quantity__value')[0].value;
	                }
	
	                var product = {
	                    name: name,
	                    id: item.getAttribute('data-product-id'),
	                    price: price,
	                    brand: brand,
	                    category: category,
	                    quantity: quantity
	                };
	
	                productData.push(product);
	            });
	
	            if (productData.length > 0) {
	                trackers.onShowOrderStep({
	                    checkout: {
	                        actionField: {
	                            step: step
	                        },
	                        products: productData
	                    }
	                });
	            }
	        }
	    }]);
	
	    return Events;
	})();
	
	exports['default'] = Events;
	module.exports = exports['default'];

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(133);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(134), __esModule: true };

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(135);
	module.exports = __webpack_require__(61).Object.assign;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(59);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(136) });


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(69);
	var getKeys = __webpack_require__(76);
	var gOPS = __webpack_require__(137);
	var pIE = __webpack_require__(138);
	var toObject = __webpack_require__(139);
	var IObject = __webpack_require__(79);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(70)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(81);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _gtm = __webpack_require__(141);
	
	var _gtm2 = _interopRequireDefault(_gtm);
	
	var _fbpixel = __webpack_require__(142);
	
	var _fbpixel2 = _interopRequireDefault(_fbpixel);
	
	var _mailru = __webpack_require__(143);
	
	var _yandexMetrika = __webpack_require__(144);
	
	__webpack_require__(145);
	__webpack_require__(146);
	
	var Trackers = (function () {
	    function Trackers() {
	        var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	        _classCallCheck(this, Trackers);
	
	        this.yandexMetrika = new _yandexMetrika.YandexMetrika();
	
	        this.instances = {
	            gtm: new _gtm2['default'](),
	            fbpixel: new _fbpixel2['default']()
	        };
	        if (!arg.onlyTrackers) {
	            return;
	        }
	
	        for (var track in this.instances) {
	            if (arg.onlyTrackers.indexOf(track) === -1 && this.instances.hasOwnProperty(track)) {
	                delete this.instances[track];
	            }
	        }
	    }
	
	    _createClass(Trackers, [{
	        key: 'backendPageViewed',
	        value: function backendPageViewed() {
	            this.mailru = new _mailru.MailRuTracker();
	            var route = $('.main-container').data('route');
	
	            switch (route) {
	                case 'index':
	                    this.indexPageViewed();
	                    break;
	                case 'catalog.section':
	                    this.categoryPageViewed();
	                    break;
	                case 'catalog.product':
	                    this.productPageViewed();
	                    break;
	                case 'cart':
	                    this.basketPageViewed();
	                    break;
	                case 'order':
	                    this.orderPageViewed();
	                    break;
	                case 'search':
	                    this.searchPageViewed();
	                    break;
	                default:
	                    this.otherPageViewed();
	                    break;
	            }
	        }
	    }, {
	        key: 'userAuthorized',
	        value: function userAuthorized(user) {
	            this.yandexMetrika.userAuthorized(user);
	        }
	    }, {
	        key: 'clientTimeSite',
	        value: function clientTimeSite() {
	            var time = arguments.length <= 0 || arguments[0] === undefined ? 190000 : arguments[0];
	
	            var _self = this;
	            setTimeout(function () {
	                _self.yandexMetrika.timeClient();
	            }, time);
	        }
	    }, {
	        key: 'trigger',
	        value: function trigger(evType, arg) {
	            for (var instName in this.instances) {
	                if (typeof this.instances[instName][evType] === 'function' && this.instances.hasOwnProperty(instName)) {
	                    this.instances[instName][evType](arg[instName]);
	                }
	            }
	        }
	    }, {
	        key: 'getTracker',
	        value: function getTracker(tracker) {
	            return this.instances[tracker];
	        }
	    }, {
	        key: 'onAddToCart',
	        value: function onAddToCart() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAddToCart', arg);
	        }
	    }, {
	        key: 'onAddToFav',
	        value: function onAddToFav() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAddToFav', arg);
	        }
	    }, {
	        key: 'onSearch',
	        value: function onSearch() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSearch', arg);
	        }
	    }, {
	        key: 'onContentView',
	        value: function onContentView() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onContentView', arg);
	        }
	    }, {
	        key: 'onSignUp',
	        value: function onSignUp() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSignUp', arg);
	        }
	    }, {
	        key: 'onSignUpEnd',
	        value: function onSignUpEnd() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSignUpEnd', arg);
	        }
	    }, {
	        key: 'onCheckoutStart',
	        value: function onCheckoutStart() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCheckoutStart', arg);
	        }
	    }, {
	        key: 'onCheckoutEnd',
	        value: function onCheckoutEnd() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCheckoutEnd', arg);
	        }
	    }, {
	        key: 'onAdviserWindow',
	        value: function onAdviserWindow() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAdviserWindow', arg);
	        }
	    }, {
	        key: 'onAdviserReply',
	        value: function onAdviserReply() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAdviserReply', arg);
	        }
	    }, {
	        key: 'onFeedbackSend',
	        value: function onFeedbackSend() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('claimButton', arg);
	        }
	    }, {
	        key: 'onTabClick',
	        value: function onTabClick() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onTabClick', arg);
	        }
	    }, {
	        key: 'onSubscribe',
	        value: function onSubscribe() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSubscribe', arg);
	        }
	    }, {
	        key: 'onSubscriptionDone',
	        value: function onSubscriptionDone() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSubscriptionDone', arg);
	            this.trigger('onPMfrmSubscribe', arg);
	        }
	    }, {
	        key: 'onCallBackFormShow',
	        value: function onCallBackFormShow() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCallBackFormShow', arg);
	        }
	    }, {
	        key: 'onCallBackButton',
	        value: function onCallBackButton() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCallBackButton', arg);
	        }
	    }, {
	        key: 'onCallBackRequestSend',
	        value: function onCallBackRequestSend() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCallBackRequestSend', arg);
	        }
	    }, {
	        key: 'onBasketRefresh',
	        value: function onBasketRefresh() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onBasketRefresh', arg);
	        }
	    }, {
	        key: 'onOneClickBuyButton',
	        value: function onOneClickBuyButton() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onOneClickBuyButton', arg);
	        }
	    }, {
	        key: 'onOneClickBuyEnd',
	        value: function onOneClickBuyEnd() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onOneClickBuyEnd', arg);
	        }
	    }, {
	        key: 'onPMbtnTel',
	        value: function onPMbtnTel() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnTel', arg);
	        }
	    }, {
	        key: 'onPMbtnFilter',
	        value: function onPMbtnFilter() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnFilter', arg);
	        }
	    }, {
	        key: 'onClickEvent',
	        value: function onClickEvent() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger(arg.event, { gtm: { param1: arg.param } });
	        }
	    }, {
	        key: 'onClickPdf',
	        value: function onClickPdf() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger(arg.event, { gtm: { param1: arg.param1, param2: arg.param2 } });
	        }
	    }, {
	        key: 'onPMbtnFavorite',
	        value: function onPMbtnFavorite() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnFavorite', { gtm: { param1: arg.param } });
	        }
	    }, {
	        key: 'onPMbtnAddToCart',
	        value: function onPMbtnAddToCart() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnAddToCart', { gtm: { param1: arg.param } });
	        }
	    }, {
	        key: 'onPMbtn1Click',
	        value: function onPMbtn1Click() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtn1Click', { gtm: { param1: arg.param1, param2: arg.param2 } });
	        }
	    }, {
	        key: 'onPMfrm1Click',
	        value: function onPMfrm1Click() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrm1Click', { gtm: { param1: arg.param1, param2: arg.param2 } });
	        }
	    }, {
	        key: 'onPMbtnFAQ',
	        value: function onPMbtnFAQ() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnFAQ', arg);
	        }
	    }, {
	        key: 'onPMfrmCallMeContact',
	        value: function onPMfrmCallMeContact() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmCallMeContact', arg);
	        }
	    }, {
	        key: 'onPMfrmFAQ',
	        value: function onPMfrmFAQ() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmFAQ', arg);
	        }
	    }, {
	        key: 'onPMbtnCallMe',
	        value: function onPMbtnCallMe() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnCallMe', arg);
	        }
	    }, {
	        key: 'onPMfrmCallMe',
	        value: function onPMfrmCallMe() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmCallMe', arg);
	        }
	    }, {
	        key: 'onPMfrmReg',
	        value: function onPMfrmReg() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmReg', arg);
	        }
	    }, {
	        key: 'onPMbtnReg',
	        value: function onPMbtnReg() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnReg', arg);
	        }
	    }, {
	        key: 'onPMbtnComment',
	        value: function onPMbtnComment() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnComment', arg);
	        }
	    }, {
	        key: 'onPMfrmComment',
	        value: function onPMfrmComment() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmComment', arg);
	        }
	    }, {
	        key: 'onPMbtnAskQuestion',
	        value: function onPMbtnAskQuestion() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnAskQuestion', arg);
	        }
	    }, {
	        key: 'onPMfrmAskQuestion',
	        value: function onPMfrmAskQuestion() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmAskQuestion', arg);
	        }
	    }, {
	        key: 'onClickPromo',
	        value: function onClickPromo() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommercePromoClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onViewPromo',
	        value: function onViewPromo() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommercePromoView', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowNewProducts',
	        value: function onShowNewProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowWatchedProducts',
	        value: function onShowWatchedProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowAnalogProducts',
	        value: function onShowAnalogProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickAddProduct',
	        value: function onClickAddProduct() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceAdd', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickRemoveProduct',
	        value: function onClickRemoveProduct() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceRemove', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowOrderCartStep1',
	        value: function onShowOrderCartStep1() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceCheckout', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowOrderStep',
	        value: function onShowOrderStep() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceCheckout', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowcatalogProducts',
	        value: function onShowcatalogProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickCatalogProducts',
	        value: function onClickCatalogProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickWatched',
	        value: function onClickWatched() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickAnalog',
	        value: function onClickAnalog() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickNewProducts',
	        value: function onClickNewProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowProductCard',
	        value: function onShowProductCard() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceDetail', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowProductCardPopup',
	        value: function onShowProductCardPopup() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceDetail', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'addToCardFromCard',
	        value: function addToCardFromCard() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceAdd', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'addToCardFromList',
	        value: function addToCardFromList() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceAdd', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'completeRegistration',
	        value: function completeRegistration() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('CompleteRegistration', arg);
	        }
	    }, {
	        key: 'indexPageViewed',
	        value: function indexPageViewed() {
	            this.mailru.indexPageView();
	        }
	    }, {
	        key: 'categoryPageViewed',
	        value: function categoryPageViewed() {
	            this.mailru.categoryPageView();
	        }
	    }, {
	        key: 'productPageViewed',
	        value: function productPageViewed() {
	            this.mailru.productPageView($('.product-detail__action-btn').data('product-id'), $('.product-detail__price-sum').data('price'));
	        }
	    }, {
	        key: 'otherPageViewed',
	        value: function otherPageViewed() {
	            this.mailru.otherPageView();
	        }
	    }, {
	        key: 'searchPageViewed',
	        value: function searchPageViewed() {
	            this.mailru.searchPageView();
	        }
	    }, {
	        key: 'orderPageViewed',
	        value: function orderPageViewed() {
	            this.mailru.orderPageView();
	        }
	    }, {
	        key: 'basketPageViewed',
	        value: function basketPageViewed() {
	            var ids = [];
	            var products = document.querySelectorAll('.cart__item .cart__item-content');
	            products.forEach(function (product) {
	                ids.push(product.getAttribute('data-product-id'));
	            });
	
	            this.mailru.basketPageView(ids, $('.basket-final-price').html());
	        }
	    }]);
	
	    return Trackers;
	})();
	
	exports['default'] = Trackers;
	module.exports = exports['default'];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _extends = __webpack_require__(132)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var GTMEvents = (function () {
	    function GTMEvents() {
	        _classCallCheck(this, GTMEvents);
	
	        this.events = {
	            registrationDone: 'Registration_Done',
	            subscriptionButton: 'Subscription_Button',
	            subscriptionDone: 'Subscription_Done',
	            PMfrmSubscribe: 'PMfrmSubscribe',
	            add2CartButton: 'Add2Cart_Button',
	            oneClickBuyButton: 'oneClick_buy_Button',
	            accessoriesTab: 'accessories_tab',
	            faqTab: 'faq_tab',
	            reviewsTab: 'reviews_tab',
	            descriptionTab: 'description_tab',
	            onlineConsultant: 'online_consultant',
	            onlineConsultantButton: 'online_consultant_button',
	            onlineConsultantSent: 'online_consultant_sent',
	            backcall: 'backcall',
	            backcallButton: 'backcall_button',
	            backcallSent: 'backcall_sent',
	            claimButton: 'claim_button',
	            claimDone: 'claim_Done',
	            basketRefresh: 'basket_refresh',
	            basketOrder: 'basket_order',
	            contactLogin: 'contact_login',
	            contact1clickBuy: 'contact_1clickBuy',
	            contactRegistration: 'contact_registration',
	            contactRegistrationContinue: 'contact_registration_continue',
	            contactLoginContinue: 'contact_login_continue',
	            contact1clickBuyContinue: 'contact_1clickBuy_continue',
	            confirmOrder: 'confirm_order',
	            PMbtnSocial: 'PMbtnSocial',
	            PMbtnFAQ: 'PMbtnFAQ',
	            PMfrmFAQ: 'PMfrmFAQ',
	            PMbtnCallMe: 'PMbtnCallMe',
	            PMfrmCallMe: 'PMfrmCallMe',
	            PMbtnReg: 'PMbtnReg',
	            PMfrmReg: 'PMfrmReg',
	            PMbtnSelectCity: 'PMbtnSelectCity',
	            PMbtnTellAbout: 'PMbtnTellAbout',
	            PMbtnContact: 'PMbtnContact',
	            PMbtnComment: 'PMbtnComment',
	            PMfrmComment: 'PMfrmComment',
	            PMbtnAskQuestion: 'PMbtnAskQuestion',
	            PMfrmAskQuestion: 'PMfrmAskQuestion',
	            PMbtn1Click: 'PMbtn1Click',
	            PMfrm1Click: 'PMfrm1Click',
	            PMbtnFavorite: 'PMbtnFavorite',
	            PMbtnAddToCart: 'PMbtnAddToCart',
	            PMbtnTabs: 'PMbtnTabs',
	            PMbtnTel: 'PMbtnTel',
	            PMfrmCallMeContact: 'PMfrmCallMeContact',
	            PMbtnVariant: 'PMbtnVariant',
	            PMbtnFilter: 'PMbtnFilter',
	            ecommercePromoClick: 'ecommercePromoClick',
	            ecommercePromoView: 'ecommercePromoView',
	            ecommerceImpressions: 'ecommerceImpressions',
	            ecommerceClick: 'ecommerceClick',
	            ecommerceDetail: 'ecommerceDetail',
	            ecommerceAdd: 'ecommerceAdd',
	            ecommerceRemove: 'ecommerceRemove',
	            ecommerceCheckout: 'ecommerceCheckout',
	            completeRegistration: 'CompleteRegistration'
	        };
	    }
	
	    _createClass(GTMEvents, [{
	        key: 'onAddToCart',
	        value: function onAddToCart(arg) {
	            if (arg) {
	                this.push(_extends({
	                    event: 'addToCart'
	                }, arg));
	                return;
	            }
	            this.pushEvent('add2CartButton');
	        }
	    }, {
	        key: 'onSignUpEnd',
	        value: function onSignUpEnd(event) {
	            this.pushEvent(event);
	        }
	    }, {
	        key: 'onCheckoutEnd',
	        value: function onCheckoutEnd() {
	            this.pushEvent('confirmOrder');
	        }
	    }, {
	        key: 'onAdviserWindow',
	        value: function onAdviserWindow() {
	            this.pushEvent('onlineConsultant');
	        }
	    }, {
	        key: 'onAdviserReply',
	        value: function onAdviserReply() {
	            this.pushEvent('onlineConsultantButton');
	        }
	    }, {
	        key: 'onFeedbackSend',
	        value: function onFeedbackSend() {
	            this.pushEvent('claimButton');
	        }
	    }, {
	        key: 'onTabClick',
	        value: function onTabClick(tab) {
	            var tabMap = {
	                descr: 'descriptionTab',
	                reviews: 'reviewsTab',
	                faq: 'faqTab',
	                login: 'contactLogin',
	                reg: 'contactRegistration',
	                oneclick: 'contact1clickBuy'
	            };
	
	            if (!tabMap[tab]) {
	                return;
	            }
	
	            this.pushEvent(tabMap[tab]);
	        }
	    }, {
	        key: 'onSubscribe',
	        value: function onSubscribe() {
	            this.pushEvent('subscriptionButton');
	        }
	    }, {
	        key: 'onSubscriptionDone',
	        value: function onSubscriptionDone() {
	            this.pushEvent('subscriptionDone');
	        }
	    }, {
	        key: 'onPMfrmSubscribe',
	        value: function onPMfrmSubscribe() {
	            this.pushEvent('PMfrmSubscribe');
	        }
	    }, {
	        key: 'PMbtnTel',
	        value: function PMbtnTel() {
	            this.pushEvent('PMbtnTel');
	        }
	    }, {
	        key: 'onCallBackFormShow',
	        value: function onCallBackFormShow() {
	            this.pushEvent('backcall');
	        }
	    }, {
	        key: 'onCallBackButton',
	        value: function onCallBackButton() {
	            this.pushEvent('backcallButton');
	        }
	    }, {
	        key: 'onCallBackRequestSend',
	        value: function onCallBackRequestSend() {
	            this.pushEvent('backcallSent');
	        }
	    }, {
	        key: 'onCheckoutStart',
	        value: function onCheckoutStart() {
	            this.pushEvent('basketOrder');
	        }
	    }, {
	        key: 'onBasketRefresh',
	        value: function onBasketRefresh() {
	            this.pushEvent('basketRefresh');
	        }
	    }, {
	        key: 'onOneClickBuyButton',
	        value: function onOneClickBuyButton() {
	            this.pushEvent('oneClickBuyButton');
	        }
	    }, {
	        key: 'onOneClickBuyEnd',
	        value: function onOneClickBuyEnd() {
	            this.pushEvent('contact1clickBuyContinue');
	        }
	    }, {
	        key: 'PMbtnSocial',
	        value: function PMbtnSocial(arg) {
	            this.push(_extends({
	                event: 'PMbtnSocial'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnVariant',
	        value: function PMbtnVariant(arg) {
	            this.push(_extends({
	                event: 'PMbtnVariant'
	            }, arg));
	        }
	    }, {
	        key: 'PMfrmCallMeContact',
	        value: function PMfrmCallMeContact(arg) {
	            this.push(_extends({
	                event: 'PMfrmCallMeContact'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnTabs',
	        value: function PMbtnTabs(arg) {
	            this.push(_extends({
	                event: 'PMbtnTabs'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnAddToCart',
	        value: function PMbtnAddToCart(arg) {
	            this.push(_extends({
	                event: 'PMbtnAddToCart'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnSelectCity',
	        value: function PMbtnSelectCity(arg) {
	            this.push(_extends({
	                event: 'PMbtnSelectCity'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnTellAbout',
	        value: function PMbtnTellAbout(arg) {
	            this.push(_extends({
	                event: 'PMbtnTellAbout'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtn1Click',
	        value: function PMbtn1Click() {
	            this.push({
	                event: 'PMbtn1Click'
	            });
	        }
	    }, {
	        key: 'PMfrm1Click',
	        value: function PMfrm1Click(arg) {
	            this.push(_extends({
	                event: 'PMfrm1Click'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnFavorite',
	        value: function PMbtnFavorite(arg) {
	            this.push(_extends({
	                event: 'PMbtnFavorite'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnContact',
	        value: function PMbtnContact(arg) {
	            this.push(_extends({
	                event: 'PMbtnContact'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnFAQ',
	        value: function PMbtnFAQ() {
	            this.push({
	                event: 'PMbtnFAQ'
	            });
	        }
	    }, {
	        key: 'PMfrmFAQ',
	        value: function PMfrmFAQ() {
	            this.push({
	                event: 'PMfrmFAQ'
	            });
	        }
	    }, {
	        key: 'PMbtnCallMe',
	        value: function PMbtnCallMe() {
	            this.push({
	                event: 'PMbtnCallMe'
	            });
	        }
	    }, {
	        key: 'PMfrmCallMe',
	        value: function PMfrmCallMe() {
	            this.push({
	                event: 'PMfrmCallMe'
	            });
	        }
	    }, {
	        key: 'PMbtnFilter',
	        value: function PMbtnFilter() {
	            this.push({
	                event: 'PMbtnFilter'
	            });
	        }
	    }, {
	        key: 'PMbtnReg',
	        value: function PMbtnReg() {
	            this.push({
	                event: 'PMbtnReg'
	            });
	        }
	    }, {
	        key: 'PMfrmReg',
	        value: function PMfrmReg() {
	            this.push({
	                event: 'PMfrmReg'
	            });
	        }
	    }, {
	        key: 'PMbtnComment',
	        value: function PMbtnComment() {
	            this.push({
	                event: 'PMbtnComment'
	            });
	        }
	    }, {
	        key: 'PMfrmComment',
	        value: function PMfrmComment() {
	            this.push({
	                event: 'PMfrmComment'
	            });
	        }
	    }, {
	        key: 'PMbtnAskQuestion',
	        value: function PMbtnAskQuestion() {
	            this.push({
	                event: 'PMbtnAskQuestion'
	            });
	        }
	    }, {
	        key: 'PMfrmAskQuestion',
	        value: function PMfrmAskQuestion() {
	            this.push({
	                event: 'PMfrmAskQuestion'
	            });
	        }
	    }, {
	        key: 'pushEvent',
	        value: function pushEvent(eventName) {
	            if (this.events[eventName] !== undefined) {
	                this.push({
	                    event: this.events[eventName]
	                });
	            }
	        }
	    }, {
	        key: 'ecommercePromoClick',
	        value: function ecommercePromoClick(arg) {
	            this.push(_extends({
	                event: 'ecommercePromoClick'
	            }, arg));
	        }
	    }, {
	        key: 'ecommercePromoView',
	        value: function ecommercePromoView(arg) {
	            this.push(_extends({
	                event: 'ecommercePromoView'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceImpressions',
	        value: function ecommerceImpressions(arg) {
	            this.push(_extends({
	                event: 'ecommerceImpressions'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceClick',
	        value: function ecommerceClick(arg) {
	            this.push(_extends({
	                event: 'ecommerceClick'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceDetail',
	        value: function ecommerceDetail(arg) {
	            this.push(_extends({
	                event: 'ecommerceDetail'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceAdd',
	        value: function ecommerceAdd(arg) {
	            this.push(_extends({
	                event: 'ecommerceAdd'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceRemove',
	        value: function ecommerceRemove(arg) {
	            this.push(_extends({
	                event: 'ecommerceRemove'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceCheckout',
	        value: function ecommerceCheckout(arg) {
	            this.push(_extends({
	                event: 'ecommerceCheckout'
	            }, arg));
	        }
	    }, {
	        key: 'push',
	        value: function push(params) {
	            window.dataLayer.push(params);
	        }
	    }]);
	
	    return GTMEvents;
	})();
	
	exports['default'] = GTMEvents;
	module.exports = exports['default'];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _extends = __webpack_require__(132)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var FBPixel = (function () {
	    function FBPixel() {
	        _classCallCheck(this, FBPixel);
	
	        var pageTitle = document.querySelector('h1');
	        this.title = pageTitle ? pageTitle.textContent : '';
	    }
	
	    _createClass(FBPixel, [{
	        key: 'track',
	        value: function track(type, args) {
	            if (typeof window.fbq !== 'function') {
	                return;
	            }
	            window.fbq('track', type, args);
	        }
	    }, {
	        key: 'onContentView',
	        value: function onContentView(location) {
	            var locations = ['categories', 'product', 'articles'];
	
	            if (locations.indexOf(location) === -1) {
	                return;
	            }
	
	            this.track('ViewContent', {
	                content_name: this.title
	            });
	        }
	    }, {
	        key: 'onCheckoutStart',
	        value: function onCheckoutStart(args) {
	            this.withCurrency('InitiateCheckout', args);
	        }
	    }, {
	        key: 'onCheckoutEnd',
	        value: function onCheckoutEnd(args) {
	            this.withCurrency('Purchase', args);
	        }
	    }, {
	        key: 'onOneClickBuyEnd',
	        value: function onOneClickBuyEnd(args) {
	            this.onCheckoutEnd(args);
	        }
	    }, {
	        key: 'onSearch',
	        value: function onSearch(args) {
	            this.track('Search', args);
	        }
	    }, {
	        key: 'onSignUp',
	        value: function onSignUp() {
	            this.track('Lead');
	        }
	    }, {
	        key: 'onSignUpEnd',
	        value: function onSignUpEnd() {
	            this.withCurrency('CompleteRegistration', {
	                value: 100
	            });
	        }
	    }, {
	        key: 'onAddToCart',
	        value: function onAddToCart(args) {
	            this.withCurrency('AddToCart', args);
	        }
	    }, {
	        key: 'onAddToFav',
	        value: function onAddToFav(args) {
	            this.withCurrency('AddToWishlist', _extends({}, args, {
	                content_name: this.title
	            }));
	        }
	    }, {
	        key: 'withCurrency',
	        value: function withCurrency(type) {
	            var args = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	            this.track(type, _extends({}, args, {
	                currency: 'RUB'
	            }));
	        }
	    }]);
	
	    return FBPixel;
	})();
	
	exports['default'] = FBPixel;
	module.exports = exports['default'];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _Object$assign = __webpack_require__(133)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var MailRuTracker = (function () {
	    function MailRuTracker() {
	        _classCallCheck(this, MailRuTracker);
	
	        this.init();
	    }
	
	    _createClass(MailRuTracker, [{
	        key: 'init',
	        value: function init() {
	            window._tmr = window._tmr || [];
	            return window._tmr;
	        }
	    }, {
	        key: 'push',
	        value: function push(query) {
	            window._tmr.push(query);
	        }
	    }, {
	        key: 'indexPageView',
	        value: function indexPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), { pagetype: 'home' }));
	        }
	    }, {
	        key: 'otherPageView',
	        value: function otherPageView() {
	            this.push(this.getQueryTemplate());
	        }
	    }, {
	        key: 'categoryPageView',
	        value: function categoryPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'category',
	                productid: '',
	                totalvalue: ''
	            }));
	        }
	    }, {
	        key: 'basketPageView',
	        value: function basketPageView(ids, totalPrice) {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'cart',
	                productid: ids,
	                totalvalue: totalPrice
	            }));
	        }
	    }, {
	        key: 'productPageView',
	        value: function productPageView(id, price) {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'product',
	                productid: id,
	                totalvalue: parseFloat(price)
	            }));
	        }
	    }, {
	        key: 'orderPageView',
	        value: function orderPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'purchase'
	            }));
	        }
	    }, {
	        key: 'searchPageView',
	        value: function searchPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'searchresults'
	            }));
	        }
	    }, {
	        key: 'getQueryTemplate',
	        value: function getQueryTemplate() {
	            return {
	                id: '3241057',
	                type: 'itemView',
	                productid: '',
	                pagetype: 'other',
	                totalvalue: '',
	                list: '3'
	            };
	        }
	    }]);
	
	    return MailRuTracker;
	})();

	exports.MailRuTracker = MailRuTracker;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var YandexMetrika = (function () {
	    function YandexMetrika() {
	        _classCallCheck(this, YandexMetrika);
	    }
	
	    _createClass(YandexMetrika, [{
	        key: 'track',
	        value: function track(code, eventCode) {
	            try {
	                window.ym(911516, code, eventCode);
	            } catch (e) {
	                //console.log('Ошибка ' + e.name + ':' + e.message + '\n' + e.stack);
	            }
	        }
	    }, {
	        key: 'timeClient',
	        value: function timeClient() {
	            this.track('reachGoal', 'time_more_than_x');
	        }
	    }, {
	        key: 'orderComplete',
	        value: function orderComplete() {
	            this.track('reachGoal', 'order_complete');
	        }
	    }, {
	        key: 'notFountPage',
	        value: function notFountPage() {
	            this.track('reachGoal', 'mn_error_404');
	        }
	    }, {
	        key: 'userAuthorized',
	        value: function userAuthorized(user) {
	            var userParams = { userId: user.USER_ID };
	            this.track('userParams', userParams);
	            this.track('params', userParams);
	            this.track('setUserID', user.USER_ID);
	        }
	    }]);
	
	    return YandexMetrika;
	})();

	exports.YandexMetrika = YandexMetrika;

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	/*!
	Waypoints - 4.0.1
	Copyright © 2011-2016 Caleb Troughton
	Licensed under the MIT license.
	https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
	*/
	!function(){"use strict";function t(o){if(!o)throw new Error("No options passed to Waypoint constructor");if(!o.element)throw new Error("No element option passed to Waypoint constructor");if(!o.handler)throw new Error("No handler option passed to Waypoint constructor");this.key="waypoint-"+e,this.options=t.Adapter.extend({},t.defaults,o),this.element=this.options.element,this.adapter=new t.Adapter(this.element),this.callback=o.handler,this.axis=this.options.horizontal?"horizontal":"vertical",this.enabled=this.options.enabled,this.triggerPoint=null,this.group=t.Group.findOrCreate({name:this.options.group,axis:this.axis}),this.context=t.Context.findOrCreateByElement(this.options.context),t.offsetAliases[this.options.offset]&&(this.options.offset=t.offsetAliases[this.options.offset]),this.group.add(this),this.context.add(this),i[this.key]=this,e+=1}var e=0,i={};t.prototype.queueTrigger=function(t){this.group.queueTrigger(this,t)},t.prototype.trigger=function(t){this.enabled&&this.callback&&this.callback.apply(this,t)},t.prototype.destroy=function(){this.context.remove(this),this.group.remove(this),delete i[this.key]},t.prototype.disable=function(){return this.enabled=!1,this},t.prototype.enable=function(){return this.context.refresh(),this.enabled=!0,this},t.prototype.next=function(){return this.group.next(this)},t.prototype.previous=function(){return this.group.previous(this)},t.invokeAll=function(t){var e=[];for(var o in i)e.push(i[o]);for(var n=0,r=e.length;r>n;n++)e[n][t]()},t.destroyAll=function(){t.invokeAll("destroy")},t.disableAll=function(){t.invokeAll("disable")},t.enableAll=function(){t.Context.refreshAll();for(var e in i)i[e].enabled=!0;return this},t.refreshAll=function(){t.Context.refreshAll()},t.viewportHeight=function(){return window.innerHeight||document.documentElement.clientHeight},t.viewportWidth=function(){return document.documentElement.clientWidth},t.adapters=[],t.defaults={context:window,continuous:!0,enabled:!0,group:"default",horizontal:!1,offset:0},t.offsetAliases={"bottom-in-view":function(){return this.context.innerHeight()-this.adapter.outerHeight()},"right-in-view":function(){return this.context.innerWidth()-this.adapter.outerWidth()}},window.Waypoint=t}(),function(){"use strict";function t(t){window.setTimeout(t,1e3/60)}function e(t){this.element=t,this.Adapter=n.Adapter,this.adapter=new this.Adapter(t),this.key="waypoint-context-"+i,this.didScroll=!1,this.didResize=!1,this.oldScroll={x:this.adapter.scrollLeft(),y:this.adapter.scrollTop()},this.waypoints={vertical:{},horizontal:{}},t.waypointContextKey=this.key,o[t.waypointContextKey]=this,i+=1,n.windowContext||(n.windowContext=!0,n.windowContext=new e(window)),this.createThrottledScrollHandler(),this.createThrottledResizeHandler()}var i=0,o={},n=window.Waypoint,r=window.onload;e.prototype.add=function(t){var e=t.options.horizontal?"horizontal":"vertical";this.waypoints[e][t.key]=t,this.refresh()},e.prototype.checkEmpty=function(){var t=this.Adapter.isEmptyObject(this.waypoints.horizontal),e=this.Adapter.isEmptyObject(this.waypoints.vertical),i=this.element==this.element.window;t&&e&&!i&&(this.adapter.off(".waypoints"),delete o[this.key])},e.prototype.createThrottledResizeHandler=function(){function t(){e.handleResize(),e.didResize=!1}var e=this;this.adapter.on("resize.waypoints",function(){e.didResize||(e.didResize=!0,n.requestAnimationFrame(t))})},e.prototype.createThrottledScrollHandler=function(){function t(){e.handleScroll(),e.didScroll=!1}var e=this;this.adapter.on("scroll.waypoints",function(){(!e.didScroll||n.isTouch)&&(e.didScroll=!0,n.requestAnimationFrame(t))})},e.prototype.handleResize=function(){n.Context.refreshAll()},e.prototype.handleScroll=function(){var t={},e={horizontal:{newScroll:this.adapter.scrollLeft(),oldScroll:this.oldScroll.x,forward:"right",backward:"left"},vertical:{newScroll:this.adapter.scrollTop(),oldScroll:this.oldScroll.y,forward:"down",backward:"up"}};for(var i in e){var o=e[i],n=o.newScroll>o.oldScroll,r=n?o.forward:o.backward;for(var s in this.waypoints[i]){var a=this.waypoints[i][s];if(null!==a.triggerPoint){var l=o.oldScroll<a.triggerPoint,h=o.newScroll>=a.triggerPoint,p=l&&h,u=!l&&!h;(p||u)&&(a.queueTrigger(r),t[a.group.id]=a.group)}}}for(var c in t)t[c].flushTriggers();this.oldScroll={x:e.horizontal.newScroll,y:e.vertical.newScroll}},e.prototype.innerHeight=function(){return this.element==this.element.window?n.viewportHeight():this.adapter.innerHeight()},e.prototype.remove=function(t){delete this.waypoints[t.axis][t.key],this.checkEmpty()},e.prototype.innerWidth=function(){return this.element==this.element.window?n.viewportWidth():this.adapter.innerWidth()},e.prototype.destroy=function(){var t=[];for(var e in this.waypoints)for(var i in this.waypoints[e])t.push(this.waypoints[e][i]);for(var o=0,n=t.length;n>o;o++)t[o].destroy()},e.prototype.refresh=function(){var t,e=this.element==this.element.window,i=e?void 0:this.adapter.offset(),o={};this.handleScroll(),t={horizontal:{contextOffset:e?0:i.left,contextScroll:e?0:this.oldScroll.x,contextDimension:this.innerWidth(),oldScroll:this.oldScroll.x,forward:"right",backward:"left",offsetProp:"left"},vertical:{contextOffset:e?0:i.top,contextScroll:e?0:this.oldScroll.y,contextDimension:this.innerHeight(),oldScroll:this.oldScroll.y,forward:"down",backward:"up",offsetProp:"top"}};for(var r in t){var s=t[r];for(var a in this.waypoints[r]){var l,h,p,u,c,d=this.waypoints[r][a],f=d.options.offset,w=d.triggerPoint,y=0,g=null==w;d.element!==d.element.window&&(y=d.adapter.offset()[s.offsetProp]),"function"==typeof f?f=f.apply(d):"string"==typeof f&&(f=parseFloat(f),d.options.offset.indexOf("%")>-1&&(f=Math.ceil(s.contextDimension*f/100))),l=s.contextScroll-s.contextOffset,d.triggerPoint=Math.floor(y+l-f),h=w<s.oldScroll,p=d.triggerPoint>=s.oldScroll,u=h&&p,c=!h&&!p,!g&&u?(d.queueTrigger(s.backward),o[d.group.id]=d.group):!g&&c?(d.queueTrigger(s.forward),o[d.group.id]=d.group):g&&s.oldScroll>=d.triggerPoint&&(d.queueTrigger(s.forward),o[d.group.id]=d.group)}}return n.requestAnimationFrame(function(){for(var t in o)o[t].flushTriggers()}),this},e.findOrCreateByElement=function(t){return e.findByElement(t)||new e(t)},e.refreshAll=function(){for(var t in o)o[t].refresh()},e.findByElement=function(t){return o[t.waypointContextKey]},window.onload=function(){r&&r(),e.refreshAll()},n.requestAnimationFrame=function(e){var i=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||t;i.call(window,e)},n.Context=e}(),function(){"use strict";function t(t,e){return t.triggerPoint-e.triggerPoint}function e(t,e){return e.triggerPoint-t.triggerPoint}function i(t){this.name=t.name,this.axis=t.axis,this.id=this.name+"-"+this.axis,this.waypoints=[],this.clearTriggerQueues(),o[this.axis][this.name]=this}var o={vertical:{},horizontal:{}},n=window.Waypoint;i.prototype.add=function(t){this.waypoints.push(t)},i.prototype.clearTriggerQueues=function(){this.triggerQueues={up:[],down:[],left:[],right:[]}},i.prototype.flushTriggers=function(){for(var i in this.triggerQueues){var o=this.triggerQueues[i],n="up"===i||"left"===i;o.sort(n?e:t);for(var r=0,s=o.length;s>r;r+=1){var a=o[r];(a.options.continuous||r===o.length-1)&&a.trigger([i])}}this.clearTriggerQueues()},i.prototype.next=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints),o=i===this.waypoints.length-1;return o?null:this.waypoints[i+1]},i.prototype.previous=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints);return i?this.waypoints[i-1]:null},i.prototype.queueTrigger=function(t,e){this.triggerQueues[e].push(t)},i.prototype.remove=function(t){var e=n.Adapter.inArray(t,this.waypoints);e>-1&&this.waypoints.splice(e,1)},i.prototype.first=function(){return this.waypoints[0]},i.prototype.last=function(){return this.waypoints[this.waypoints.length-1]},i.findOrCreate=function(t){return o[t.axis][t.name]||new i(t)},n.Group=i}(),function(){"use strict";function t(t){this.$element=e(t)}var e=window.jQuery,i=window.Waypoint;e.each(["innerHeight","innerWidth","off","offset","on","outerHeight","outerWidth","scrollLeft","scrollTop"],function(e,i){t.prototype[i]=function(){var t=Array.prototype.slice.call(arguments);return this.$element[i].apply(this.$element,t)}}),e.each(["extend","inArray","isEmptyObject"],function(i,o){t[o]=e[o]}),i.adapters.push({name:"jquery",Adapter:t}),i.Adapter=t}(),function(){"use strict";function t(t){return function(){var i=[],o=arguments[0];return t.isFunction(arguments[0])&&(o=t.extend({},arguments[1]),o.handler=arguments[0]),this.each(function(){var n=t.extend({},o,{element:this});"string"==typeof n.context&&(n.context=t(this).closest(n.context)[0]),i.push(new e(n))}),i}}var e=window.Waypoint;window.jQuery&&(window.jQuery.fn.waypoint=t(window.jQuery)),window.Zepto&&(window.Zepto.fn.waypoint=t(window.Zepto))}();

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	/*!
	Waypoints Inview Shortcut - 4.0.1
	Copyright © 2011-2016 Caleb Troughton
	Licensed under the MIT license.
	https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
	*/
	(function() {
	  'use strict'
	
	  function noop() {}
	
	  var Waypoint = window.Waypoint
	
	  /* http://imakewebthings.com/waypoints/shortcuts/inview */
	  function Inview(options) {
	    this.options = Waypoint.Adapter.extend({}, Inview.defaults, options)
	    this.axis = this.options.horizontal ? 'horizontal' : 'vertical'
	    this.waypoints = []
	    this.element = this.options.element
	    this.createWaypoints()
	  }
	
	  /* Private */
	  Inview.prototype.createWaypoints = function() {
	    var configs = {
	      vertical: [{
	        down: 'enter',
	        up: 'exited',
	        offset: '100%'
	      }, {
	        down: 'entered',
	        up: 'exit',
	        offset: 'bottom-in-view'
	      }, {
	        down: 'exit',
	        up: 'entered',
	        offset: 0
	      }, {
	        down: 'exited',
	        up: 'enter',
	        offset: function() {
	          return -this.adapter.outerHeight()
	        }
	      }],
	      horizontal: [{
	        right: 'enter',
	        left: 'exited',
	        offset: '100%'
	      }, {
	        right: 'entered',
	        left: 'exit',
	        offset: 'right-in-view'
	      }, {
	        right: 'exit',
	        left: 'entered',
	        offset: 0
	      }, {
	        right: 'exited',
	        left: 'enter',
	        offset: function() {
	          return -this.adapter.outerWidth()
	        }
	      }]
	    }
	
	    for (var i = 0, end = configs[this.axis].length; i < end; i++) {
	      var config = configs[this.axis][i]
	      this.createWaypoint(config)
	    }
	  }
	
	  /* Private */
	  Inview.prototype.createWaypoint = function(config) {
	    var self = this
	    this.waypoints.push(new Waypoint({
	      context: this.options.context,
	      element: this.options.element,
	      enabled: this.options.enabled,
	      handler: (function(config) {
	        return function(direction) {
	          self.options[config[direction]].call(self, direction)
	        }
	      }(config)),
	      offset: config.offset,
	      horizontal: this.options.horizontal
	    }))
	  }
	
	  /* Public */
	  Inview.prototype.destroy = function() {
	    for (var i = 0, end = this.waypoints.length; i < end; i++) {
	      this.waypoints[i].destroy()
	    }
	    this.waypoints = []
	  }
	
	  Inview.prototype.disable = function() {
	    for (var i = 0, end = this.waypoints.length; i < end; i++) {
	      this.waypoints[i].disable()
	    }
	  }
	
	  Inview.prototype.enable = function() {
	    for (var i = 0, end = this.waypoints.length; i < end; i++) {
	      this.waypoints[i].enable()
	    }
	  }
	
	  Inview.defaults = {
	    context: window,
	    enabled: true,
	    enter: noop,
	    entered: noop,
	    exit: noop,
	    exited: noop
	  }
	
	  Waypoint.Inview = Inview
	}())
	;

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */,
/* 149 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */,
/* 151 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var _trackerEvents = __webpack_require__(131);
	
	var _trackerEvents2 = _interopRequireDefault(_trackerEvents);
	
	__webpack_require__(149);
	__webpack_require__(156);
	__webpack_require__(161);
	
	jQuery(function () {
	    var $objItemListContainer = $('.js-products-container');
	
	    /** при изменении кол-ва товаров на странице */
	    $(document).on('change', '.pagination__size form select', function () {
	        var params = getSupportData();
	        params['count'] = $(this).val();
	        window.mxLoader && window.mxLoader.show();
	        updateListAfterFilter(params);
	    });
	
	    /** при изменении сортировки */
	    $(document).on('change', 'form #catalog-sort', function () {
	        var params = getSupportData();
	        params['sort'] = $(this).val();
	        window.mxLoader && window.mxLoader.show();
	        updateListAfterFilter(params);
	    });
	
	    /** при переходе в постраничной навигации */
	    $(document).on('click', '.pagination__item', function (e) {
	        var params = getSupportData();
	        e.preventDefault();
	        window.mxLoader && window.mxLoader.show();
	        params['history-link'] = params['history-link'].replace(/&page=([\d]+)/, '');
	        params['page_url'] = $(this).attr('href');
	        if (params['page_url'].indexOf('?') + 1) {
	            updateListAfterFilter(params, true);
	        } else {
	            updateListAfterFilter(params, false);
	        }
	    });
	
	    /** при изменении значений фильтра (инпутов) */
	    $(document).on('change', '.filter input', function (e) {
	        e.preventDefault();
	        var params = getSupportData();
	        var position = $(this).offset();
	        $.ajax({
	            url: '/ajax/action/catalog_filter/ajaxFilter/',
	            data: $('form.js-section-filter').serialize() + '&top=' + position.top + '&' + params['price_filter'],
	            success: function success(result) {
	                disableCheckbox(result.data['PROPS_ACTIVE']);
	                showPopup(result.html);
	                updateFilterSubmitButton(result.data);
	            }
	        });
	    });
	
	    /** при клике по фильтру цены */
	    $(document).on('click', '.filter .priceslider__line', function (e) {
	        e.preventDefault();
	        var params = getSupportData();
	        var position = $(this).offset();
	        $.ajax({
	            url: '/ajax/action/catalog_filter/ajaxFilter/',
	            data: $('form.js-section-filter').serialize() + '&top=' + position.top + '&' + params['price_filter'],
	            success: function success(result) {
	                disableCheckbox(result.data['PROPS_ACTIVE']);
	                showPopup(result.html);
	                updateFilterSubmitButton(result.data);
	            }
	        });
	    });
	
	    /** Если зажата мышка и мы покидаем облость фильтра цены */
	    $(document).on('mouseleave', '.filter .priceslider__line', function (e) {
	        if (e.which == 1) {
	            e.preventDefault();
	            var $this = $(this);
	            /* На таймаут, чтобы сработало гарантированно позже события click - иначе вознникает конкуренция и в рез-те в фильтр передаются неверные значения */
	            window.setTimeout(function () {
	                var params = getSupportData();
	                var position = $this.offset();
	                $.ajax({
	                    url: '/ajax/action/catalog_filter/ajaxFilter/',
	                    data: $('form.js-section-filter').serialize() + '&top=' + position.top + '&' + params['price_filter'],
	                    success: function success(result) {
	                        disableCheckbox(result.data['PROPS_ACTIVE']);
	                        showPopup(result.html);
	                        updateFilterSubmitButton(result.data);
	                    }
	                });
	            }, 500);
	        }
	    });
	
	    /** При клике применить фильтр */
	    $(document).on('click', '.js-filter-apply', function (e) {
	        var params = getSupportData();
	        params['filter'] = $(this).data('filter');
	        params['history-link'] = $(this).data('history-link');
	        params['filter_props'] = '';
	        e.preventDefault();
	        window.mxLoader && window.mxLoader.show();
	        updateListAfterFilter(params);
	        var trackers = new _trackerTracker2['default']();
	        trackers.onPMbtnFilter();
	    });
	
	    $(document).on('click', 'form.js-section-filter input[type="submit"]', function (e) {
	        var params = getSupportData();
	        params['filter'] = $(this).data('filter');
	        params['history-link'] = $(this).data('history-link');
	        params['filter_props'] = '';
	        e.preventDefault();
	        window.mxLoader && window.mxLoader.show();
	        updateListAfterFilter(params);
	    });
	
	    $(document).on('change', '.js-price-filter-apply', function (e) {
	        e.preventDefault();
	        var params = getSupportData();
	        params['price_filter'] = $('form.js-price-filter').serialize();
	
	        /* проверка - если есть фильтр на странице */
	        var smartFilter = false;
	        if ($('.catalog__filter-column').length > 0) {
	            smartFilter = true;
	        }
	        window.mxLoader && window.mxLoader.show();
	        if (smartFilter) {
	            /* применяем фильтр */
	            $.ajax({
	                url: '/ajax/action/catalog_filter/ajaxFilter/',
	                data: $('form.js-section-filter').serialize() + '&' + params['price_filter'],
	                success: function success(result) {
	                    params['filter'] = result.data['ELEMENT_ID_LIST'];
	                    params['history-link'] = result.data['HISTORY_LINK'];
	                    updateFilterSubmitButton(result.data);
	                    /* обновляем список товаров*/
	                    updateListAfterFilter(params);
	                }
	            });
	        } else {
	            updateListAfterFilter(params);
	        }
	    });
	
	    function disableCheckbox(propData) {
	        $.each($('form.js-section-filter input[type="checkbox"]'), function (e, propValue) {
	            if (!$(propValue).is(':checked')) {
	                var propertyID = $(propValue).data('prop-id');
	                if (propData[propertyID] === undefined) {
	                    $(propValue).attr('disabled', true);
	                    $(propValue).parent().find('label').addClass('styledbox__label--disabled');
	                } else if (propData[propertyID][propValue.value] === undefined) {
	                    $(propValue).attr('disabled', true);
	                    $(propValue).parent().find('label').addClass('styledbox__label--disabled');
	                } else {
	                    $(propValue).attr('disabled', false);
	                    $(propValue).parent().find('label').removeClass('styledbox__label--disabled');
	                }
	            }
	        });
	    }
	
	    /**
	     * убирает старое окно с данными о фильтрации, показывает новое окно
	     * @param data - вертска окна
	     */
	    function showPopup(data) {
	        $('.js-filter-popup').remove();
	        $(data).appendTo('body');
	    }
	
	    /**
	     * Устаналивает ссылку в браузере
	     */
	    function setHistoryLink() {
	        var $objSupportBlock = $('.js-catalog-data');
	        history.replaceState(null, null, $objSupportBlock.data('url'));
	    }
	
	    /**
	     * Обновлаяет значение кнопки применить форму
	     * @param data
	     */
	    function updateFilterSubmitButton(data) {
	        var $submitBtn = $('form.js-section-filter input[type="submit"]');
	        if (data['ELEMENT_COUNT'] > 0) {
	            $submitBtn.attr('disabled', false);
	        } else {
	            $submitBtn.attr('disabled', true);
	        }
	        $submitBtn.data('filter', data['ELEMENT_ID_LIST']);
	        $submitBtn.data('history', data['HISTORY_LINK']);
	    }
	
	    /**
	     * Получение вспомогательной информации из атрибутов
	     * @returns {*}
	     */
	    function getSupportData() {
	        var $objSupportBlock = $('.js-catalog-data');
	        var params = [];
	        params['sort'] = $objSupportBlock.data('sort');
	        params['section'] = $objSupportBlock.data('section');
	        params['count'] = $objSupportBlock.data('count');
	        params['history-link'] = $objSupportBlock.data('url');
	        params['filter'] = $objSupportBlock.data('filter');
	        params['filter_props'] = $objSupportBlock.data('filter_props');
	        params['template_url'] = $objSupportBlock.data('template_url');
	        params['page_url'] = $objSupportBlock.data('page_url');
	        params['section_path'] = $objSupportBlock.data('section_code_path');
	        params['price_filter'] = $('form.js-price-filter').serialize();
	        return params;
	    }
	
	    //Объявляем стилизацию селекта
	    var styleSelects = function styleSelects($select) {
	        $select.each(function () {
	            var $this = $(this);
	            $this.select2({
	                language: 'ru',
	                minimumResultsForSearch: Infinity,
	                dropdownParent: $this.parent()
	            }).on('select2:open', function () {
	                var $options = $this.parent().find('.select2-container--default .select2-results > .select2-results__options');
	                $options.mCustomScrollbar('destroy');
	                $options.mCustomScrollbar('update');
	                setTimeout(function () {
	                    $options.mCustomScrollbar({
	                        axis: 'y',
	                        scrollbarPosition: 'inside',
	                        advanced: {
	                            updateOnContentResize: true
	                        },
	                        live: true
	                    });
	                }, 0);
	            });
	        });
	    };
	
	    styleSelects($('.js-styled-select'));
	
	    function updateListAfterFilter(params, href) {
	        var queryData;
	        if (href === true) {
	            queryData = params['page_url'] + '&' + params['history-link'] + '&' + params['price_filter'] + '&' + params['filter_props'];
	        } else {
	            queryData = params['page_url'] + '?' + params['history-link'] + '&' + params['price_filter'] + '&' + params['filter_props'];
	        }
	        $.ajax({
	            type: 'POST',
	            url: ('/ajax/component/' + params['template_url'] + queryData).replace(/\/\/+/g, '/'),
	            data: {
	                ELEMENT_COUNT: params['count'],
	                SECTION_CODE: params['section'],
	                SECTION_CODE_PATH: params['section_path'],
	                sort: params['sort'],
	                FILTER: params['filter']
	            },
	            success: function success(result) {
	                $('.js-filter-popup').remove();
	                window.mxLoader && window.mxLoader.hide(0);
	                $objItemListContainer.html(result.html);
	                setHistoryLink();
	                $('html,body').animate({ scrollTop: $objItemListContainer.offset().top }, 500);
	                styleSelects($('.js-styled-select'));
	                var event = new _trackerEvents2['default']();
	                event.init();
	            }
	        });
	    }
	});

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(157);
	__webpack_require__(159);
	__webpack_require__(160);

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(158);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(47)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./jquery.loader.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./jquery.loader.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".mx-loader{display:none;position:fixed;z-index:9999;width:100%;height:100%;left:0;top:0;background:hsla(0,0%,100%,.5)}.mx-loader:after{content:\"\";display:block;z-index:9999;position:absolute;margin:auto;top:0;right:0;bottom:0;left:0;background:url(" + __webpack_require__(159) + ") no-repeat 50%;width:64px;height:64px}", ""]);
	
	// exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "plugins/jquery.loader/img/jquery.loader.gif";

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	'use strict';
	
	(function ($) {
	    var mxLoader = function mxLoader(options) {
	        var self, _init;
	        var $element, $loader;
	        var defaults = {
	            speed: 200,
	            selector: 'body',
	            block: '<div class="mx-loader"></div>',
	            'class': ''
	        };
	
	        if ($.isPlainObject(options)) {
	            defaults = $.extend(true, defaults, options);
	        }
	
	        self = {
	            init: function init() {
	                if (!_init) {
	                    $element = $(defaults.selector);
	                    $loader = $(defaults.block);
	
	                    defaults = $.extend(true, defaults, options);
	                    isString(defaults['class'], true) && $loader.addClass(defaults['class']);
	
	                    _init = true;
	                }
	
	                return _init;
	            },
	
	            show: function show(speed) {
	                if (self.init()) {
	                    speed = self.speed(speed);
	                    $element.append($loader);
	                    $loader.stop(true).fadeIn(speed);
	                }
	            },
	
	            hide: function hide(speed) {
	                if (self.init()) {
	                    speed = self.speed(speed);
	                    $loader.stop(true).fadeOut(speed, function () {
	                        $loader.detach();
	                    });
	                }
	            },
	
	            speed: function speed(_speed) {
	                return $.isNumeric(_speed) ? parseInt(_speed) | 0 : defaults.speed;
	            }
	        };
	
	        return self;
	    };
	
	    /**
	     * Проверка, является ли переменная строкой
	     * Проверка на не пустаую строку
	     */
	
	    var isString = function isString(variable, noEmpty) {
	        var answer = !!(variable === '' || variable && variable.split);
	        if (noEmpty === true) {
	            answer = answer && variable.length > 0;
	        }
	
	        return answer;
	    };
	
	    window.mxLoader = new mxLoader();
	})(jQuery);

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var noUiSlider = __webpack_require__(162);
	var functions = __webpack_require__(163);
	
	__webpack_require__(165);
	
	jQuery(function () {
	    $('.js-priceslider').each(function () {
	        var $this = $(this);
	
	        var $line = $this.find('.priceslider__line');
	        var $inputFrom = $this.find('.priceslider__input--from');
	        var $inputTo = $this.find('.priceslider__input--to');
	
	        setPriceSlider($line, $inputFrom, $inputTo);
	
	        $inputFrom.add($inputTo).change(function () {
	            $line[0].noUiSlider.set([$inputFrom.val(), $inputTo.val()]);
	        });
	    });
	});
	
	function setPriceSlider($line, $inputFrom, $inputTo) {
	    noUiSlider.create($line[0], {
	        start: [$line.data('curmin'), $line.data('curmax')],
	        connect: true,
	        margin: $line.data('margin'),
	        step: $line.data('step'),
	        range: {
	            min: $line.data('min'),
	            max: $line.data('max')
	        }
	    });
	
	    $line[0].noUiSlider.on('update', function (values) {
	        $inputFrom.val(functions.number_format(values[0], 0, '.', ' '));
	        $inputTo.val(functions.number_format(values[1], 0, '.', ' '));
	    });
	}
	
	exports.setPriceSlider = setPriceSlider;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! nouislider - 8.5.1 - 2016-04-24 16:00:29 */
	
	(function (factory) {
	
	    if ( true ) {
	
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	    } else if ( typeof exports === 'object' ) {
	
	        // Node/CommonJS
	        module.exports = factory();
	
	    } else {
	
	        // Browser globals
	        window.noUiSlider = factory();
	    }
	
	}(function( ){
	
		'use strict';
	
	
		// Removes duplicates from an array.
		function unique(array) {
			return array.filter(function(a){
				return !this[a] ? this[a] = true : false;
			}, {});
		}
	
		// Round a value to the closest 'to'.
		function closest ( value, to ) {
			return Math.round(value / to) * to;
		}
	
		// Current position of an element relative to the document.
		function offset ( elem ) {
	
		var rect = elem.getBoundingClientRect(),
			doc = elem.ownerDocument,
			docElem = doc.documentElement,
			pageOffset = getPageOffset();
	
			// getBoundingClientRect contains left scroll in Chrome on Android.
			// I haven't found a feature detection that proves this. Worst case
			// scenario on mis-match: the 'tap' feature on horizontal sliders breaks.
			if ( /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) ) {
				pageOffset.x = 0;
			}
	
			return {
				top: rect.top + pageOffset.y - docElem.clientTop,
				left: rect.left + pageOffset.x - docElem.clientLeft
			};
		}
	
		// Checks whether a value is numerical.
		function isNumeric ( a ) {
			return typeof a === 'number' && !isNaN( a ) && isFinite( a );
		}
	
		// Sets a class and removes it after [duration] ms.
		function addClassFor ( element, className, duration ) {
			addClass(element, className);
			setTimeout(function(){
				removeClass(element, className);
			}, duration);
		}
	
		// Limits a value to 0 - 100
		function limit ( a ) {
			return Math.max(Math.min(a, 100), 0);
		}
	
		// Wraps a variable as an array, if it isn't one yet.
		function asArray ( a ) {
			return Array.isArray(a) ? a : [a];
		}
	
		// Counts decimals
		function countDecimals ( numStr ) {
			var pieces = numStr.split(".");
			return pieces.length > 1 ? pieces[1].length : 0;
		}
	
		// http://youmightnotneedjquery.com/#add_class
		function addClass ( el, className ) {
			if ( el.classList ) {
				el.classList.add(className);
			} else {
				el.className += ' ' + className;
			}
		}
	
		// http://youmightnotneedjquery.com/#remove_class
		function removeClass ( el, className ) {
			if ( el.classList ) {
				el.classList.remove(className);
			} else {
				el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
			}
		}
	
		// https://plainjs.com/javascript/attributes/adding-removing-and-testing-for-classes-9/
		function hasClass ( el, className ) {
			return el.classList ? el.classList.contains(className) : new RegExp('\\b' + className + '\\b').test(el.className);
		}
	
		// https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY#Notes
		function getPageOffset ( ) {
	
			var supportPageOffset = window.pageXOffset !== undefined,
				isCSS1Compat = ((document.compatMode || "") === "CSS1Compat"),
				x = supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft,
				y = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
	
			return {
				x: x,
				y: y
			};
		}
	
		// we provide a function to compute constants instead
		// of accessing window.* as soon as the module needs it
		// so that we do not compute anything if not needed
		function getActions ( ) {
	
			// Determine the events to bind. IE11 implements pointerEvents without
			// a prefix, which breaks compatibility with the IE10 implementation.
			return window.navigator.pointerEnabled ? {
				start: 'pointerdown',
				move: 'pointermove',
				end: 'pointerup'
			} : window.navigator.msPointerEnabled ? {
				start: 'MSPointerDown',
				move: 'MSPointerMove',
				end: 'MSPointerUp'
			} : {
				start: 'mousedown touchstart',
				move: 'mousemove touchmove',
				end: 'mouseup touchend'
			};
		}
	
	
	// Value calculation
	
		// Determine the size of a sub-range in relation to a full range.
		function subRangeRatio ( pa, pb ) {
			return (100 / (pb - pa));
		}
	
		// (percentage) How many percent is this value of this range?
		function fromPercentage ( range, value ) {
			return (value * 100) / ( range[1] - range[0] );
		}
	
		// (percentage) Where is this value on this range?
		function toPercentage ( range, value ) {
			return fromPercentage( range, range[0] < 0 ?
				value + Math.abs(range[0]) :
					value - range[0] );
		}
	
		// (value) How much is this percentage on this range?
		function isPercentage ( range, value ) {
			return ((value * ( range[1] - range[0] )) / 100) + range[0];
		}
	
	
	// Range conversion
	
		function getJ ( value, arr ) {
	
			var j = 1;
	
			while ( value >= arr[j] ){
				j += 1;
			}
	
			return j;
		}
	
		// (percentage) Input a value, find where, on a scale of 0-100, it applies.
		function toStepping ( xVal, xPct, value ) {
	
			if ( value >= xVal.slice(-1)[0] ){
				return 100;
			}
	
			var j = getJ( value, xVal ), va, vb, pa, pb;
	
			va = xVal[j-1];
			vb = xVal[j];
			pa = xPct[j-1];
			pb = xPct[j];
	
			return pa + (toPercentage([va, vb], value) / subRangeRatio (pa, pb));
		}
	
		// (value) Input a percentage, find where it is on the specified range.
		function fromStepping ( xVal, xPct, value ) {
	
			// There is no range group that fits 100
			if ( value >= 100 ){
				return xVal.slice(-1)[0];
			}
	
			var j = getJ( value, xPct ), va, vb, pa, pb;
	
			va = xVal[j-1];
			vb = xVal[j];
			pa = xPct[j-1];
			pb = xPct[j];
	
			return isPercentage([va, vb], (value - pa) * subRangeRatio (pa, pb));
		}
	
		// (percentage) Get the step that applies at a certain value.
		function getStep ( xPct, xSteps, snap, value ) {
	
			if ( value === 100 ) {
				return value;
			}
	
			var j = getJ( value, xPct ), a, b;
	
			// If 'snap' is set, steps are used as fixed points on the slider.
			if ( snap ) {
	
				a = xPct[j-1];
				b = xPct[j];
	
				// Find the closest position, a or b.
				if ((value - a) > ((b-a)/2)){
					return b;
				}
	
				return a;
			}
	
			if ( !xSteps[j-1] ){
				return value;
			}
	
			return xPct[j-1] + closest(
				value - xPct[j-1],
				xSteps[j-1]
			);
		}
	
	
	// Entry parsing
	
		function handleEntryPoint ( index, value, that ) {
	
			var percentage;
	
			// Wrap numerical input in an array.
			if ( typeof value === "number" ) {
				value = [value];
			}
	
			// Reject any invalid input, by testing whether value is an array.
			if ( Object.prototype.toString.call( value ) !== '[object Array]' ){
				throw new Error("noUiSlider: 'range' contains invalid value.");
			}
	
			// Covert min/max syntax to 0 and 100.
			if ( index === 'min' ) {
				percentage = 0;
			} else if ( index === 'max' ) {
				percentage = 100;
			} else {
				percentage = parseFloat( index );
			}
	
			// Check for correct input.
			if ( !isNumeric( percentage ) || !isNumeric( value[0] ) ) {
				throw new Error("noUiSlider: 'range' value isn't numeric.");
			}
	
			// Store values.
			that.xPct.push( percentage );
			that.xVal.push( value[0] );
	
			// NaN will evaluate to false too, but to keep
			// logging clear, set step explicitly. Make sure
			// not to override the 'step' setting with false.
			if ( !percentage ) {
				if ( !isNaN( value[1] ) ) {
					that.xSteps[0] = value[1];
				}
			} else {
				that.xSteps.push( isNaN(value[1]) ? false : value[1] );
			}
		}
	
		function handleStepPoint ( i, n, that ) {
	
			// Ignore 'false' stepping.
			if ( !n ) {
				return true;
			}
	
			// Factor to range ratio
			that.xSteps[i] = fromPercentage([
				 that.xVal[i]
				,that.xVal[i+1]
			], n) / subRangeRatio (
				that.xPct[i],
				that.xPct[i+1] );
		}
	
	
	// Interface
	
		// The interface to Spectrum handles all direction-based
		// conversions, so the above values are unaware.
	
		function Spectrum ( entry, snap, direction, singleStep ) {
	
			this.xPct = [];
			this.xVal = [];
			this.xSteps = [ singleStep || false ];
			this.xNumSteps = [ false ];
	
			this.snap = snap;
			this.direction = direction;
	
			var index, ordered = [ /* [0, 'min'], [1, '50%'], [2, 'max'] */ ];
	
			// Map the object keys to an array.
			for ( index in entry ) {
				if ( entry.hasOwnProperty(index) ) {
					ordered.push([entry[index], index]);
				}
			}
	
			// Sort all entries by value (numeric sort).
			if ( ordered.length && typeof ordered[0][0] === "object" ) {
				ordered.sort(function(a, b) { return a[0][0] - b[0][0]; });
			} else {
				ordered.sort(function(a, b) { return a[0] - b[0]; });
			}
	
	
			// Convert all entries to subranges.
			for ( index = 0; index < ordered.length; index++ ) {
				handleEntryPoint(ordered[index][1], ordered[index][0], this);
			}
	
			// Store the actual step values.
			// xSteps is sorted in the same order as xPct and xVal.
			this.xNumSteps = this.xSteps.slice(0);
	
			// Convert all numeric steps to the percentage of the subrange they represent.
			for ( index = 0; index < this.xNumSteps.length; index++ ) {
				handleStepPoint(index, this.xNumSteps[index], this);
			}
		}
	
		Spectrum.prototype.getMargin = function ( value ) {
			return this.xPct.length === 2 ? fromPercentage(this.xVal, value) : false;
		};
	
		Spectrum.prototype.toStepping = function ( value ) {
	
			value = toStepping( this.xVal, this.xPct, value );
	
			// Invert the value if this is a right-to-left slider.
			if ( this.direction ) {
				value = 100 - value;
			}
	
			return value;
		};
	
		Spectrum.prototype.fromStepping = function ( value ) {
	
			// Invert the value if this is a right-to-left slider.
			if ( this.direction ) {
				value = 100 - value;
			}
	
			return fromStepping( this.xVal, this.xPct, value );
		};
	
		Spectrum.prototype.getStep = function ( value ) {
	
			// Find the proper step for rtl sliders by search in inverse direction.
			// Fixes issue #262.
			if ( this.direction ) {
				value = 100 - value;
			}
	
			value = getStep(this.xPct, this.xSteps, this.snap, value );
	
			if ( this.direction ) {
				value = 100 - value;
			}
	
			return value;
		};
	
		Spectrum.prototype.getApplicableStep = function ( value ) {
	
			// If the value is 100%, return the negative step twice.
			var j = getJ(value, this.xPct), offset = value === 100 ? 2 : 1;
			return [this.xNumSteps[j-2], this.xVal[j-offset], this.xNumSteps[j-offset]];
		};
	
		// Outside testing
		Spectrum.prototype.convert = function ( value ) {
			return this.getStep(this.toStepping(value));
		};
	
	/*	Every input option is tested and parsed. This'll prevent
		endless validation in internal methods. These tests are
		structured with an item for every option available. An
		option can be marked as required by setting the 'r' flag.
		The testing function is provided with three arguments:
			- The provided value for the option;
			- A reference to the options object;
			- The name for the option;
	
		The testing function returns false when an error is detected,
		or true when everything is OK. It can also modify the option
		object, to make sure all values can be correctly looped elsewhere. */
	
		var defaultFormatter = { 'to': function( value ){
			return value !== undefined && value.toFixed(2);
		}, 'from': Number };
	
		function testStep ( parsed, entry ) {
	
			if ( !isNumeric( entry ) ) {
				throw new Error("noUiSlider: 'step' is not numeric.");
			}
	
			// The step option can still be used to set stepping
			// for linear sliders. Overwritten if set in 'range'.
			parsed.singleStep = entry;
		}
	
		function testRange ( parsed, entry ) {
	
			// Filter incorrect input.
			if ( typeof entry !== 'object' || Array.isArray(entry) ) {
				throw new Error("noUiSlider: 'range' is not an object.");
			}
	
			// Catch missing start or end.
			if ( entry.min === undefined || entry.max === undefined ) {
				throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
			}
	
			// Catch equal start or end.
			if ( entry.min === entry.max ) {
				throw new Error("noUiSlider: 'range' 'min' and 'max' cannot be equal.");
			}
	
			parsed.spectrum = new Spectrum(entry, parsed.snap, parsed.dir, parsed.singleStep);
		}
	
		function testStart ( parsed, entry ) {
	
			entry = asArray(entry);
	
			// Validate input. Values aren't tested, as the public .val method
			// will always provide a valid location.
			if ( !Array.isArray( entry ) || !entry.length || entry.length > 2 ) {
				throw new Error("noUiSlider: 'start' option is incorrect.");
			}
	
			// Store the number of handles.
			parsed.handles = entry.length;
	
			// When the slider is initialized, the .val method will
			// be called with the start options.
			parsed.start = entry;
		}
	
		function testSnap ( parsed, entry ) {
	
			// Enforce 100% stepping within subranges.
			parsed.snap = entry;
	
			if ( typeof entry !== 'boolean' ){
				throw new Error("noUiSlider: 'snap' option must be a boolean.");
			}
		}
	
		function testAnimate ( parsed, entry ) {
	
			// Enforce 100% stepping within subranges.
			parsed.animate = entry;
	
			if ( typeof entry !== 'boolean' ){
				throw new Error("noUiSlider: 'animate' option must be a boolean.");
			}
		}
	
		function testAnimationDuration ( parsed, entry ) {
	
			parsed.animationDuration = entry;
	
			if ( typeof entry !== 'number' ){
				throw new Error("noUiSlider: 'animationDuration' option must be a number.");
			}
		}
	
		function testConnect ( parsed, entry ) {
	
			if ( entry === 'lower' && parsed.handles === 1 ) {
				parsed.connect = 1;
			} else if ( entry === 'upper' && parsed.handles === 1 ) {
				parsed.connect = 2;
			} else if ( entry === true && parsed.handles === 2 ) {
				parsed.connect = 3;
			} else if ( entry === false ) {
				parsed.connect = 0;
			} else {
				throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
			}
		}
	
		function testOrientation ( parsed, entry ) {
	
			// Set orientation to an a numerical value for easy
			// array selection.
			switch ( entry ){
			  case 'horizontal':
				parsed.ort = 0;
				break;
			  case 'vertical':
				parsed.ort = 1;
				break;
			  default:
				throw new Error("noUiSlider: 'orientation' option is invalid.");
			}
		}
	
		function testMargin ( parsed, entry ) {
	
			if ( !isNumeric(entry) ){
				throw new Error("noUiSlider: 'margin' option must be numeric.");
			}
	
			// Issue #582
			if ( entry === 0 ) {
				return;
			}
	
			parsed.margin = parsed.spectrum.getMargin(entry);
	
			if ( !parsed.margin ) {
				throw new Error("noUiSlider: 'margin' option is only supported on linear sliders.");
			}
		}
	
		function testLimit ( parsed, entry ) {
	
			if ( !isNumeric(entry) ){
				throw new Error("noUiSlider: 'limit' option must be numeric.");
			}
	
			parsed.limit = parsed.spectrum.getMargin(entry);
	
			if ( !parsed.limit ) {
				throw new Error("noUiSlider: 'limit' option is only supported on linear sliders.");
			}
		}
	
		function testDirection ( parsed, entry ) {
	
			// Set direction as a numerical value for easy parsing.
			// Invert connection for RTL sliders, so that the proper
			// handles get the connect/background classes.
			switch ( entry ) {
			  case 'ltr':
				parsed.dir = 0;
				break;
			  case 'rtl':
				parsed.dir = 1;
				parsed.connect = [0,2,1,3][parsed.connect];
				break;
			  default:
				throw new Error("noUiSlider: 'direction' option was not recognized.");
			}
		}
	
		function testBehaviour ( parsed, entry ) {
	
			// Make sure the input is a string.
			if ( typeof entry !== 'string' ) {
				throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
			}
	
			// Check if the string contains any keywords.
			// None are required.
			var tap = entry.indexOf('tap') >= 0,
				drag = entry.indexOf('drag') >= 0,
				fixed = entry.indexOf('fixed') >= 0,
				snap = entry.indexOf('snap') >= 0,
				hover = entry.indexOf('hover') >= 0;
	
			// Fix #472
			if ( drag && !parsed.connect ) {
				throw new Error("noUiSlider: 'drag' behaviour must be used with 'connect': true.");
			}
	
			parsed.events = {
				tap: tap || snap,
				drag: drag,
				fixed: fixed,
				snap: snap,
				hover: hover
			};
		}
	
		function testTooltips ( parsed, entry ) {
	
			var i;
	
			if ( entry === false ) {
				return;
			} else if ( entry === true ) {
	
				parsed.tooltips = [];
	
				for ( i = 0; i < parsed.handles; i++ ) {
					parsed.tooltips.push(true);
				}
	
			} else {
	
				parsed.tooltips = asArray(entry);
	
				if ( parsed.tooltips.length !== parsed.handles ) {
					throw new Error("noUiSlider: must pass a formatter for all handles.");
				}
	
				parsed.tooltips.forEach(function(formatter){
					if ( typeof formatter !== 'boolean' && (typeof formatter !== 'object' || typeof formatter.to !== 'function') ) {
						throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
					}
				});
			}
		}
	
		function testFormat ( parsed, entry ) {
	
			parsed.format = entry;
	
			// Any object with a to and from method is supported.
			if ( typeof entry.to === 'function' && typeof entry.from === 'function' ) {
				return true;
			}
	
			throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
		}
	
		function testCssPrefix ( parsed, entry ) {
	
			if ( entry !== undefined && typeof entry !== 'string' && entry !== false ) {
				throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
			}
	
			parsed.cssPrefix = entry;
		}
	
		function testCssClasses ( parsed, entry ) {
	
			if ( entry !== undefined && typeof entry !== 'object' ) {
				throw new Error("noUiSlider: 'cssClasses' must be an object.");
			}
	
			if ( typeof parsed.cssPrefix === 'string' ) {
				parsed.cssClasses = {};
	
				for ( var key in entry ) {
					if ( !entry.hasOwnProperty(key) ) { continue; }
	
					parsed.cssClasses[key] = parsed.cssPrefix + entry[key];
				}
			} else {
				parsed.cssClasses = entry;
			}
		}
	
		// Test all developer settings and parse to assumption-safe values.
		function testOptions ( options ) {
	
			// To prove a fix for #537, freeze options here.
			// If the object is modified, an error will be thrown.
			// Object.freeze(options);
	
			var parsed = {
				margin: 0,
				limit: 0,
				animate: true,
				animationDuration: 300,
				format: defaultFormatter
			}, tests;
	
			// Tests are executed in the order they are presented here.
			tests = {
				'step': { r: false, t: testStep },
				'start': { r: true, t: testStart },
				'connect': { r: true, t: testConnect },
				'direction': { r: true, t: testDirection },
				'snap': { r: false, t: testSnap },
				'animate': { r: false, t: testAnimate },
				'animationDuration': { r: false, t: testAnimationDuration },
				'range': { r: true, t: testRange },
				'orientation': { r: false, t: testOrientation },
				'margin': { r: false, t: testMargin },
				'limit': { r: false, t: testLimit },
				'behaviour': { r: true, t: testBehaviour },
				'format': { r: false, t: testFormat },
				'tooltips': { r: false, t: testTooltips },
				'cssPrefix': { r: false, t: testCssPrefix },
				'cssClasses': { r: false, t: testCssClasses }
			};
	
			var defaults = {
				'connect': false,
				'direction': 'ltr',
				'behaviour': 'tap',
				'orientation': 'horizontal',
				'cssPrefix' : 'noUi-',
				'cssClasses': {
					target: 'target',
					base: 'base',
					origin: 'origin',
					handle: 'handle',
					handleLower: 'handle-lower',
					handleUpper: 'handle-upper',
					horizontal: 'horizontal',
					vertical: 'vertical',
					background: 'background',
					connect: 'connect',
					ltr: 'ltr',
					rtl: 'rtl',
					draggable: 'draggable',
					drag: 'state-drag',
					tap: 'state-tap',
					active: 'active',
					stacking: 'stacking',
					tooltip: 'tooltip',
					pips: 'pips',
					pipsHorizontal: 'pips-horizontal',
					pipsVertical: 'pips-vertical',
					marker: 'marker',
					markerHorizontal: 'marker-horizontal',
					markerVertical: 'marker-vertical',
					markerNormal: 'marker-normal',
					markerLarge: 'marker-large',
					markerSub: 'marker-sub',
					value: 'value',
					valueHorizontal: 'value-horizontal',
					valueVertical: 'value-vertical',
					valueNormal: 'value-normal',
					valueLarge: 'value-large',
					valueSub: 'value-sub'
				}
			};
	
			// Run all options through a testing mechanism to ensure correct
			// input. It should be noted that options might get modified to
			// be handled properly. E.g. wrapping integers in arrays.
			Object.keys(tests).forEach(function( name ){
	
				// If the option isn't set, but it is required, throw an error.
				if ( options[name] === undefined && defaults[name] === undefined ) {
	
					if ( tests[name].r ) {
						throw new Error("noUiSlider: '" + name + "' is required.");
					}
	
					return true;
				}
	
				tests[name].t( parsed, options[name] === undefined ? defaults[name] : options[name] );
			});
	
			// Forward pips options
			parsed.pips = options.pips;
	
			// Pre-define the styles.
			parsed.style = parsed.ort ? 'top' : 'left';
	
			return parsed;
		}
	
	
	function closure ( target, options, originalOptions ){
		var
			actions = getActions( ),
			// All variables local to 'closure' are prefixed with 'scope_'
			scope_Target = target,
			scope_Locations = [-1, -1],
			scope_Base,
			scope_Handles,
			scope_Spectrum = options.spectrum,
			scope_Values = [],
			scope_Events = {},
			scope_Self;
	
	
		// Delimit proposed values for handle positions.
		function getPositions ( a, b, delimit ) {
	
			// Add movement to current position.
			var c = a + b[0], d = a + b[1];
	
			// Only alter the other position on drag,
			// not on standard sliding.
			if ( delimit ) {
				if ( c < 0 ) {
					d += Math.abs(c);
				}
				if ( d > 100 ) {
					c -= ( d - 100 );
				}
	
				// Limit values to 0 and 100.
				return [limit(c), limit(d)];
			}
	
			return [c,d];
		}
	
		// Provide a clean event with standardized offset values.
		function fixEvent ( e, pageOffset ) {
	
			// Prevent scrolling and panning on touch events, while
			// attempting to slide. The tap event also depends on this.
			e.preventDefault();
	
			// Filter the event to register the type, which can be
			// touch, mouse or pointer. Offset changes need to be
			// made on an event specific basis.
			var touch = e.type.indexOf('touch') === 0,
				mouse = e.type.indexOf('mouse') === 0,
				pointer = e.type.indexOf('pointer') === 0,
				x,y, event = e;
	
			// IE10 implemented pointer events with a prefix;
			if ( e.type.indexOf('MSPointer') === 0 ) {
				pointer = true;
			}
	
			if ( touch ) {
				// noUiSlider supports one movement at a time,
				// so we can select the first 'changedTouch'.
				x = e.changedTouches[0].pageX;
				y = e.changedTouches[0].pageY;
			}
	
			pageOffset = pageOffset || getPageOffset();
	
			if ( mouse || pointer ) {
				x = e.clientX + pageOffset.x;
				y = e.clientY + pageOffset.y;
			}
	
			event.pageOffset = pageOffset;
			event.points = [x, y];
			event.cursor = mouse || pointer; // Fix #435
	
			return event;
		}
	
		// Append a handle to the base.
		function addHandle ( direction, index ) {
	
			var origin = document.createElement('div'),
				handle = document.createElement('div'),
				classModifier = [options.cssClasses.handleLower, options.cssClasses.handleUpper];
	
			if ( direction ) {
				classModifier.reverse();
			}
	
			addClass(handle, options.cssClasses.handle);
			addClass(handle, classModifier[index]);
	
			addClass(origin, options.cssClasses.origin);
			origin.appendChild(handle);
	
			return origin;
		}
	
		// Add the proper connection classes.
		function addConnection ( connect, target, handles ) {
	
			// Apply the required connection classes to the elements
			// that need them. Some classes are made up for several
			// segments listed in the class list, to allow easy
			// renaming and provide a minor compression benefit.
			switch ( connect ) {
				case 1:	addClass(target, options.cssClasses.connect);
						addClass(handles[0], options.cssClasses.background);
						break;
				case 3: addClass(handles[1], options.cssClasses.background);
						/* falls through */
				case 2: addClass(handles[0], options.cssClasses.connect);
						/* falls through */
				case 0: addClass(target, options.cssClasses.background);
						break;
			}
		}
	
		// Add handles to the slider base.
		function addHandles ( nrHandles, direction, base ) {
	
			var index, handles = [];
	
			// Append handles.
			for ( index = 0; index < nrHandles; index += 1 ) {
	
				// Keep a list of all added handles.
				handles.push( base.appendChild(addHandle( direction, index )) );
			}
	
			return handles;
		}
	
		// Initialize a single slider.
		function addSlider ( direction, orientation, target ) {
	
			// Apply classes and data to the target.
			addClass(target, options.cssClasses.target);
	
			if ( direction === 0 ) {
				addClass(target, options.cssClasses.ltr);
			} else {
				addClass(target, options.cssClasses.rtl);
			}
	
			if ( orientation === 0 ) {
				addClass(target, options.cssClasses.horizontal);
			} else {
				addClass(target, options.cssClasses.vertical);
			}
	
			var div = document.createElement('div');
			addClass(div, options.cssClasses.base);
			target.appendChild(div);
			return div;
		}
	
	
		function addTooltip ( handle, index ) {
	
			if ( !options.tooltips[index] ) {
				return false;
			}
	
			var element = document.createElement('div');
			element.className = options.cssClasses.tooltip;
			return handle.firstChild.appendChild(element);
		}
	
		// The tooltips option is a shorthand for using the 'update' event.
		function tooltips ( ) {
	
			if ( options.dir ) {
				options.tooltips.reverse();
			}
	
			// Tooltips are added with options.tooltips in original order.
			var tips = scope_Handles.map(addTooltip);
	
			if ( options.dir ) {
				tips.reverse();
				options.tooltips.reverse();
			}
	
			bindEvent('update', function(f, o, r) {
				if ( tips[o] ) {
					tips[o].innerHTML = options.tooltips[o] === true ? f[o] : options.tooltips[o].to(r[o]);
				}
			});
		}
	
	
		function getGroup ( mode, values, stepped ) {
	
			// Use the range.
			if ( mode === 'range' || mode === 'steps' ) {
				return scope_Spectrum.xVal;
			}
	
			if ( mode === 'count' ) {
	
				// Divide 0 - 100 in 'count' parts.
				var spread = ( 100 / (values-1) ), v, i = 0;
				values = [];
	
				// List these parts and have them handled as 'positions'.
				while ((v=i++*spread) <= 100 ) {
					values.push(v);
				}
	
				mode = 'positions';
			}
	
			if ( mode === 'positions' ) {
	
				// Map all percentages to on-range values.
				return values.map(function( value ){
					return scope_Spectrum.fromStepping( stepped ? scope_Spectrum.getStep( value ) : value );
				});
			}
	
			if ( mode === 'values' ) {
	
				// If the value must be stepped, it needs to be converted to a percentage first.
				if ( stepped ) {
	
					return values.map(function( value ){
	
						// Convert to percentage, apply step, return to value.
						return scope_Spectrum.fromStepping( scope_Spectrum.getStep( scope_Spectrum.toStepping( value ) ) );
					});
	
				}
	
				// Otherwise, we can simply use the values.
				return values;
			}
		}
	
		function generateSpread ( density, mode, group ) {
	
			function safeIncrement(value, increment) {
				// Avoid floating point variance by dropping the smallest decimal places.
				return (value + increment).toFixed(7) / 1;
			}
	
			var originalSpectrumDirection = scope_Spectrum.direction,
				indexes = {},
				firstInRange = scope_Spectrum.xVal[0],
				lastInRange = scope_Spectrum.xVal[scope_Spectrum.xVal.length-1],
				ignoreFirst = false,
				ignoreLast = false,
				prevPct = 0;
	
			// This function loops the spectrum in an ltr linear fashion,
			// while the toStepping method is direction aware. Trick it into
			// believing it is ltr.
			scope_Spectrum.direction = 0;
	
			// Create a copy of the group, sort it and filter away all duplicates.
			group = unique(group.slice().sort(function(a, b){ return a - b; }));
	
			// Make sure the range starts with the first element.
			if ( group[0] !== firstInRange ) {
				group.unshift(firstInRange);
				ignoreFirst = true;
			}
	
			// Likewise for the last one.
			if ( group[group.length - 1] !== lastInRange ) {
				group.push(lastInRange);
				ignoreLast = true;
			}
	
			group.forEach(function ( current, index ) {
	
				// Get the current step and the lower + upper positions.
				var step, i, q,
					low = current,
					high = group[index+1],
					newPct, pctDifference, pctPos, type,
					steps, realSteps, stepsize;
	
				// When using 'steps' mode, use the provided steps.
				// Otherwise, we'll step on to the next subrange.
				if ( mode === 'steps' ) {
					step = scope_Spectrum.xNumSteps[ index ];
				}
	
				// Default to a 'full' step.
				if ( !step ) {
					step = high-low;
				}
	
				// Low can be 0, so test for false. If high is undefined,
				// we are at the last subrange. Index 0 is already handled.
				if ( low === false || high === undefined ) {
					return;
				}
	
				// Find all steps in the subrange.
				for ( i = low; i <= high; i = safeIncrement(i, step) ) {
	
					// Get the percentage value for the current step,
					// calculate the size for the subrange.
					newPct = scope_Spectrum.toStepping( i );
					pctDifference = newPct - prevPct;
	
					steps = pctDifference / density;
					realSteps = Math.round(steps);
	
					// This ratio represents the ammount of percentage-space a point indicates.
					// For a density 1 the points/percentage = 1. For density 2, that percentage needs to be re-devided.
					// Round the percentage offset to an even number, then divide by two
					// to spread the offset on both sides of the range.
					stepsize = pctDifference/realSteps;
	
					// Divide all points evenly, adding the correct number to this subrange.
					// Run up to <= so that 100% gets a point, event if ignoreLast is set.
					for ( q = 1; q <= realSteps; q += 1 ) {
	
						// The ratio between the rounded value and the actual size might be ~1% off.
						// Correct the percentage offset by the number of points
						// per subrange. density = 1 will result in 100 points on the
						// full range, 2 for 50, 4 for 25, etc.
						pctPos = prevPct + ( q * stepsize );
						indexes[pctPos.toFixed(5)] = ['x', 0];
					}
	
					// Determine the point type.
					type = (group.indexOf(i) > -1) ? 1 : ( mode === 'steps' ? 2 : 0 );
	
					// Enforce the 'ignoreFirst' option by overwriting the type for 0.
					if ( !index && ignoreFirst ) {
						type = 0;
					}
	
					if ( !(i === high && ignoreLast)) {
						// Mark the 'type' of this point. 0 = plain, 1 = real value, 2 = step value.
						indexes[newPct.toFixed(5)] = [i, type];
					}
	
					// Update the percentage count.
					prevPct = newPct;
				}
			});
	
			// Reset the spectrum.
			scope_Spectrum.direction = originalSpectrumDirection;
	
			return indexes;
		}
	
		function addMarking ( spread, filterFunc, formatter ) {
	
			var element = document.createElement('div'),
				out = '',
				valueSizeClasses = [
					options.cssClasses.valueNormal,
					options.cssClasses.valueLarge,
					options.cssClasses.valueSub
				],
				markerSizeClasses = [
					options.cssClasses.markerNormal,
					options.cssClasses.markerLarge,
					options.cssClasses.markerSub
				],
				valueOrientationClasses = [
					options.cssClasses.valueHorizontal,
					options.cssClasses.valueVertical
				],
				markerOrientationClasses = [
					options.cssClasses.markerHorizontal,
					options.cssClasses.markerVertical
				];
	
			addClass(element, options.cssClasses.pips);
			addClass(element, options.ort === 0 ? options.cssClasses.pipsHorizontal : options.cssClasses.pipsVertical);
	
			function getClasses( type, source ){
				var a = source === options.cssClasses.value,
					orientationClasses = a ? valueOrientationClasses : markerOrientationClasses,
					sizeClasses = a ? valueSizeClasses : markerSizeClasses;
	
				return source + ' ' + orientationClasses[options.ort] + ' ' + sizeClasses[type];
			}
	
			function getTags( offset, source, values ) {
				return 'class="' + getClasses(values[1], source) + '" style="' + options.style + ': ' + offset + '%"';
			}
	
			function addSpread ( offset, values ){
	
				if ( scope_Spectrum.direction ) {
					offset = 100 - offset;
				}
	
				// Apply the filter function, if it is set.
				values[1] = (values[1] && filterFunc) ? filterFunc(values[0], values[1]) : values[1];
	
				// Add a marker for every point
				out += '<div ' + getTags(offset, options.cssClasses.marker, values) + '></div>';
	
				// Values are only appended for points marked '1' or '2'.
				if ( values[1] ) {
					out += '<div ' + getTags(offset, options.cssClasses.value, values) + '>' + formatter.to(values[0]) + '</div>';
				}
			}
	
			// Append all points.
			Object.keys(spread).forEach(function(a){
				addSpread(a, spread[a]);
			});
	
			element.innerHTML = out;
	
			return element;
		}
	
		function pips ( grid ) {
	
		var mode = grid.mode,
			density = grid.density || 1,
			filter = grid.filter || false,
			values = grid.values || false,
			stepped = grid.stepped || false,
			group = getGroup( mode, values, stepped ),
			spread = generateSpread( density, mode, group ),
			format = grid.format || {
				to: Math.round
			};
	
			return scope_Target.appendChild(addMarking(
				spread,
				filter,
				format
			));
		}
	
	
		// Shorthand for base dimensions.
		function baseSize ( ) {
			var rect = scope_Base.getBoundingClientRect(), alt = 'offset' + ['Width', 'Height'][options.ort];
			return options.ort === 0 ? (rect.width||scope_Base[alt]) : (rect.height||scope_Base[alt]);
		}
	
		// External event handling
		function fireEvent ( event, handleNumber, tap ) {
	
			var i;
	
			// During initialization, do not fire events.
			for ( i = 0; i < options.handles; i++ ) {
				if ( scope_Locations[i] === -1 ) {
					return;
				}
			}
	
			if ( handleNumber !== undefined && options.handles !== 1 ) {
				handleNumber = Math.abs(handleNumber - options.dir);
			}
	
			Object.keys(scope_Events).forEach(function( targetEvent ) {
	
				var eventType = targetEvent.split('.')[0];
	
				if ( event === eventType ) {
					scope_Events[targetEvent].forEach(function( callback ) {
	
						callback.call(
							// Use the slider public API as the scope ('this')
							scope_Self,
							// Return values as array, so arg_1[arg_2] is always valid.
							asArray(valueGet()),
							// Handle index, 0 or 1
							handleNumber,
							// Unformatted slider values
							asArray(inSliderOrder(Array.prototype.slice.call(scope_Values))),
							// Event is fired by tap, true or false
							tap || false,
							// Left offset of the handle, in relation to the slider
							scope_Locations
						);
					});
				}
			});
		}
	
		// Returns the input array, respecting the slider direction configuration.
		function inSliderOrder ( values ) {
	
			// If only one handle is used, return a single value.
			if ( values.length === 1 ){
				return values[0];
			}
	
			if ( options.dir ) {
				return values.reverse();
			}
	
			return values;
		}
	
	
		// Handler for attaching events trough a proxy.
		function attach ( events, element, callback, data ) {
	
			// This function can be used to 'filter' events to the slider.
			// element is a node, not a nodeList
	
			var method = function ( e ){
	
				if ( scope_Target.hasAttribute('disabled') ) {
					return false;
				}
	
				// Stop if an active 'tap' transition is taking place.
				if ( hasClass(scope_Target, options.cssClasses.tap) ) {
					return false;
				}
	
				e = fixEvent(e, data.pageOffset);
	
				// Ignore right or middle clicks on start #454
				if ( events === actions.start && e.buttons !== undefined && e.buttons > 1 ) {
					return false;
				}
	
				// Ignore right or middle clicks on start #454
				if ( data.hover && e.buttons ) {
					return false;
				}
	
				e.calcPoint = e.points[ options.ort ];
	
				// Call the event handler with the event [ and additional data ].
				callback ( e, data );
	
			}, methods = [];
	
			// Bind a closure on the target for every event type.
			events.split(' ').forEach(function( eventName ){
				element.addEventListener(eventName, method, false);
				methods.push([eventName, method]);
			});
	
			return methods;
		}
	
		// Handle movement on document for handle and range drag.
		function move ( event, data ) {
	
			// Fix #498
			// Check value of .buttons in 'start' to work around a bug in IE10 mobile (data.buttonsProperty).
			// https://connect.microsoft.com/IE/feedback/details/927005/mobile-ie10-windows-phone-buttons-property-of-pointermove-event-always-zero
			// IE9 has .buttons and .which zero on mousemove.
			// Firefox breaks the spec MDN defines.
			if ( navigator.appVersion.indexOf("MSIE 9") === -1 && event.buttons === 0 && data.buttonsProperty !== 0 ) {
				return end(event, data);
			}
	
			var handles = data.handles || scope_Handles, positions, state = false,
				proposal = ((event.calcPoint - data.start) * 100) / data.baseSize,
				handleNumber = handles[0] === scope_Handles[0] ? 0 : 1, i;
	
			// Calculate relative positions for the handles.
			positions = getPositions( proposal, data.positions, handles.length > 1);
	
			state = setHandle ( handles[0], positions[handleNumber], handles.length === 1 );
	
			if ( handles.length > 1 ) {
	
				state = setHandle ( handles[1], positions[handleNumber?0:1], false ) || state;
	
				if ( state ) {
					// fire for both handles
					for ( i = 0; i < data.handles.length; i++ ) {
						fireEvent('slide', i);
					}
				}
			} else if ( state ) {
				// Fire for a single handle
				fireEvent('slide', handleNumber);
			}
		}
	
		// Unbind move events on document, call callbacks.
		function end ( event, data ) {
	
			// The handle is no longer active, so remove the class.
			var active = scope_Base.querySelector( '.' + options.cssClasses.active ),
				handleNumber = data.handles[0] === scope_Handles[0] ? 0 : 1;
	
			if ( active !== null ) {
				removeClass(active, options.cssClasses.active);
			}
	
			// Remove cursor styles and text-selection events bound to the body.
			if ( event.cursor ) {
				document.body.style.cursor = '';
				document.body.removeEventListener('selectstart', document.body.noUiListener);
			}
	
			var d = document.documentElement;
	
			// Unbind the move and end events, which are added on 'start'.
			d.noUiListeners.forEach(function( c ) {
				d.removeEventListener(c[0], c[1]);
			});
	
			// Remove dragging class.
			removeClass(scope_Target, options.cssClasses.drag);
	
			// Fire the change and set events.
			fireEvent('set', handleNumber);
			fireEvent('change', handleNumber);
	
			// If this is a standard handle movement, fire the end event.
			if ( data.handleNumber !== undefined ) {
				fireEvent('end', data.handleNumber);
			}
		}
	
		// Fire 'end' when a mouse or pen leaves the document.
		function documentLeave ( event, data ) {
			if ( event.type === "mouseout" && event.target.nodeName === "HTML" && event.relatedTarget === null ){
				end ( event, data );
			}
		}
	
		// Bind move events on document.
		function start ( event, data ) {
	
			var d = document.documentElement;
	
			// Mark the handle as 'active' so it can be styled.
			if ( data.handles.length === 1 ) {
				// Support 'disabled' handles
				if ( data.handles[0].hasAttribute('disabled') ) {
					return false;
				}
	
				addClass(data.handles[0].children[0], options.cssClasses.active);
			}
	
			// Fix #551, where a handle gets selected instead of dragged.
			event.preventDefault();
	
			// A drag should never propagate up to the 'tap' event.
			event.stopPropagation();
	
			// Attach the move and end events.
			var moveEvent = attach(actions.move, d, move, {
				start: event.calcPoint,
				baseSize: baseSize(),
				pageOffset: event.pageOffset,
				handles: data.handles,
				handleNumber: data.handleNumber,
				buttonsProperty: event.buttons,
				positions: [
					scope_Locations[0],
					scope_Locations[scope_Handles.length - 1]
				]
			}), endEvent = attach(actions.end, d, end, {
				handles: data.handles,
				handleNumber: data.handleNumber
			});
	
			var outEvent = attach("mouseout", d, documentLeave, {
				handles: data.handles,
				handleNumber: data.handleNumber
			});
	
			d.noUiListeners = moveEvent.concat(endEvent, outEvent);
	
			// Text selection isn't an issue on touch devices,
			// so adding cursor styles can be skipped.
			if ( event.cursor ) {
	
				// Prevent the 'I' cursor and extend the range-drag cursor.
				document.body.style.cursor = getComputedStyle(event.target).cursor;
	
				// Mark the target with a dragging state.
				if ( scope_Handles.length > 1 ) {
					addClass(scope_Target, options.cssClasses.drag);
				}
	
				var f = function(){
					return false;
				};
	
				document.body.noUiListener = f;
	
				// Prevent text selection when dragging the handles.
				document.body.addEventListener('selectstart', f, false);
			}
	
			if ( data.handleNumber !== undefined ) {
				fireEvent('start', data.handleNumber);
			}
		}
	
		// Move closest handle to tapped location.
		function tap ( event ) {
	
			var location = event.calcPoint, total = 0, handleNumber, to;
	
			// The tap event shouldn't propagate up and cause 'edge' to run.
			event.stopPropagation();
	
			// Add up the handle offsets.
			scope_Handles.forEach(function(a){
				total += offset(a)[ options.style ];
			});
	
			// Find the handle closest to the tapped position.
			handleNumber = ( location < total/2 || scope_Handles.length === 1 ) ? 0 : 1;
	
			// Check if handler is not disablet if yes set number to the next handler
			if (scope_Handles[handleNumber].hasAttribute('disabled')) {
				handleNumber = handleNumber ? 0 : 1;
			}
	
			location -= offset(scope_Base)[ options.style ];
	
			// Calculate the new position.
			to = ( location * 100 ) / baseSize();
	
			if ( !options.events.snap ) {
				// Flag the slider as it is now in a transitional state.
				// Transition takes a configurable amount of ms (default 300). Re-enable the slider after that.
				addClassFor( scope_Target, options.cssClasses.tap, options.animationDuration );
			}
	
			// Support 'disabled' handles
			if ( scope_Handles[handleNumber].hasAttribute('disabled') ) {
				return false;
			}
	
			// Find the closest handle and calculate the tapped point.
			// The set handle to the new position.
			setHandle( scope_Handles[handleNumber], to );
	
			fireEvent('slide', handleNumber, true);
			fireEvent('set', handleNumber, true);
			fireEvent('change', handleNumber, true);
	
			if ( options.events.snap ) {
				start(event, { handles: [scope_Handles[handleNumber]] });
			}
		}
	
		// Fires a 'hover' event for a hovered mouse/pen position.
		function hover ( event ) {
	
			var location = event.calcPoint - offset(scope_Base)[ options.style ],
				to = scope_Spectrum.getStep(( location * 100 ) / baseSize()),
				value = scope_Spectrum.fromStepping( to );
	
			Object.keys(scope_Events).forEach(function( targetEvent ) {
				if ( 'hover' === targetEvent.split('.')[0] ) {
					scope_Events[targetEvent].forEach(function( callback ) {
						callback.call( scope_Self, value );
					});
				}
			});
		}
	
		// Attach events to several slider parts.
		function events ( behaviour ) {
	
			// Attach the standard drag event to the handles.
			if ( !behaviour.fixed ) {
	
				scope_Handles.forEach(function( handle, index ){
	
					// These events are only bound to the visual handle
					// element, not the 'real' origin element.
					attach ( actions.start, handle.children[0], start, {
						handles: [ handle ],
						handleNumber: index
					});
				});
			}
	
			// Attach the tap event to the slider base.
			if ( behaviour.tap ) {
	
				attach ( actions.start, scope_Base, tap, {
					handles: scope_Handles
				});
			}
	
			// Fire hover events
			if ( behaviour.hover ) {
				attach ( actions.move, scope_Base, hover, { hover: true } );
			}
	
			// Make the range draggable.
			if ( behaviour.drag ){
	
				var drag = [scope_Base.querySelector( '.' + options.cssClasses.connect )];
				addClass(drag[0], options.cssClasses.draggable);
	
				// When the range is fixed, the entire range can
				// be dragged by the handles. The handle in the first
				// origin will propagate the start event upward,
				// but it needs to be bound manually on the other.
				if ( behaviour.fixed ) {
					drag.push(scope_Handles[(drag[0] === scope_Handles[0] ? 1 : 0)].children[0]);
				}
	
				drag.forEach(function( element ) {
					attach ( actions.start, element, start, {
						handles: scope_Handles
					});
				});
			}
		}
	
	
		// Test suggested values and apply margin, step.
		function setHandle ( handle, to, noLimitOption ) {
	
			var trigger = handle !== scope_Handles[0] ? 1 : 0,
				lowerMargin = scope_Locations[0] + options.margin,
				upperMargin = scope_Locations[1] - options.margin,
				lowerLimit = scope_Locations[0] + options.limit,
				upperLimit = scope_Locations[1] - options.limit;
	
			// For sliders with multiple handles,
			// limit movement to the other handle.
			// Apply the margin option by adding it to the handle positions.
			if ( scope_Handles.length > 1 ) {
				to = trigger ? Math.max( to, lowerMargin ) : Math.min( to, upperMargin );
			}
	
			// The limit option has the opposite effect, limiting handles to a
			// maximum distance from another. Limit must be > 0, as otherwise
			// handles would be unmoveable. 'noLimitOption' is set to 'false'
			// for the .val() method, except for pass 4/4.
			if ( noLimitOption !== false && options.limit && scope_Handles.length > 1 ) {
				to = trigger ? Math.min ( to, lowerLimit ) : Math.max( to, upperLimit );
			}
	
			// Handle the step option.
			to = scope_Spectrum.getStep( to );
	
			// Limit percentage to the 0 - 100 range
			to = limit(to);
	
			// Return false if handle can't move
			if ( to === scope_Locations[trigger] ) {
				return false;
			}
	
			// Set the handle to the new position.
			// Use requestAnimationFrame for efficient painting.
			// No significant effect in Chrome, Edge sees dramatic
			// performace improvements.
			if ( window.requestAnimationFrame ) {
				window.requestAnimationFrame(function(){
					handle.style[options.style] = to + '%';
				});
			} else {
				handle.style[options.style] = to + '%';
			}
	
			// Force proper handle stacking
			if ( !handle.previousSibling ) {
				removeClass(handle, options.cssClasses.stacking);
				if ( to > 50 ) {
					addClass(handle, options.cssClasses.stacking);
				}
			}
	
			// Update locations.
			scope_Locations[trigger] = to;
	
			// Convert the value to the slider stepping/range.
			scope_Values[trigger] = scope_Spectrum.fromStepping( to );
	
			fireEvent('update', trigger);
	
			return true;
		}
	
		// Loop values from value method and apply them.
		function setValues ( count, values ) {
	
			var i, trigger, to;
	
			// With the limit option, we'll need another limiting pass.
			if ( options.limit ) {
				count += 1;
			}
	
			// If there are multiple handles to be set run the setting
			// mechanism twice for the first handle, to make sure it
			// can be bounced of the second one properly.
			for ( i = 0; i < count; i += 1 ) {
	
				trigger = i%2;
	
				// Get the current argument from the array.
				to = values[trigger];
	
				// Setting with null indicates an 'ignore'.
				// Inputting 'false' is invalid.
				if ( to !== null && to !== false ) {
	
					// If a formatted number was passed, attemt to decode it.
					if ( typeof to === 'number' ) {
						to = String(to);
					}
	
					to = options.format.from( to );
	
					// Request an update for all links if the value was invalid.
					// Do so too if setting the handle fails.
					if ( to === false || isNaN(to) || setHandle( scope_Handles[trigger], scope_Spectrum.toStepping( to ), i === (3 - options.dir) ) === false ) {
						fireEvent('update', trigger);
					}
				}
			}
		}
	
		// Set the slider value.
		function valueSet ( input, fireSetEvent ) {
	
			var count, values = asArray( input ), i;
	
			// Event fires by default
			fireSetEvent = (fireSetEvent === undefined ? true : !!fireSetEvent);
	
			// The RTL settings is implemented by reversing the front-end,
			// internal mechanisms are the same.
			if ( options.dir && options.handles > 1 ) {
				values.reverse();
			}
	
			// Animation is optional.
			// Make sure the initial values where set before using animated placement.
			if ( options.animate && scope_Locations[0] !== -1 ) {
				addClassFor( scope_Target, options.cssClasses.tap, options.animationDuration );
			}
	
			// Determine how often to set the handles.
			count = scope_Handles.length > 1 ? 3 : 1;
	
			if ( values.length === 1 ) {
				count = 1;
			}
	
			setValues ( count, values );
	
			// Fire the 'set' event for both handles.
			for ( i = 0; i < scope_Handles.length; i++ ) {
	
				// Fire the event only for handles that received a new value, as per #579
				if ( values[i] !== null && fireSetEvent ) {
					fireEvent('set', i);
				}
			}
		}
	
		// Get the slider value.
		function valueGet ( ) {
	
			var i, retour = [];
	
			// Get the value from all handles.
			for ( i = 0; i < options.handles; i += 1 ){
				retour[i] = options.format.to( scope_Values[i] );
			}
	
			return inSliderOrder( retour );
		}
	
		// Removes classes from the root and empties it.
		function destroy ( ) {
	
			for ( var key in options.cssClasses ) {
				if ( !options.cssClasses.hasOwnProperty(key) ) { continue; }
				removeClass(scope_Target, options.cssClasses[key]);
			}
	
			while (scope_Target.firstChild) {
				scope_Target.removeChild(scope_Target.firstChild);
			}
	
			delete scope_Target.noUiSlider;
		}
	
		// Get the current step size for the slider.
		function getCurrentStep ( ) {
	
			// Check all locations, map them to their stepping point.
			// Get the step point, then find it in the input list.
			var retour = scope_Locations.map(function( location, index ){
	
				var step = scope_Spectrum.getApplicableStep( location ),
	
					// As per #391, the comparison for the decrement step can have some rounding issues.
					// Round the value to the precision used in the step.
					stepDecimals = countDecimals(String(step[2])),
	
					// Get the current numeric value
					value = scope_Values[index],
	
					// To move the slider 'one step up', the current step value needs to be added.
					// Use null if we are at the maximum slider value.
					increment = location === 100 ? null : step[2],
	
					// Going 'one step down' might put the slider in a different sub-range, so we
					// need to switch between the current or the previous step.
					prev = Number((value - step[2]).toFixed(stepDecimals)),
	
					// If the value fits the step, return the current step value. Otherwise, use the
					// previous step. Return null if the slider is at its minimum value.
					decrement = location === 0 ? null : (prev >= step[1]) ? step[2] : (step[0] || false);
	
				return [decrement, increment];
			});
	
			// Return values in the proper order.
			return inSliderOrder( retour );
		}
	
		// Attach an event to this slider, possibly including a namespace
		function bindEvent ( namespacedEvent, callback ) {
			scope_Events[namespacedEvent] = scope_Events[namespacedEvent] || [];
			scope_Events[namespacedEvent].push(callback);
	
			// If the event bound is 'update,' fire it immediately for all handles.
			if ( namespacedEvent.split('.')[0] === 'update' ) {
				scope_Handles.forEach(function(a, index){
					fireEvent('update', index);
				});
			}
		}
	
		// Undo attachment of event
		function removeEvent ( namespacedEvent ) {
	
			var event = namespacedEvent && namespacedEvent.split('.')[0],
				namespace = event && namespacedEvent.substring(event.length);
	
			Object.keys(scope_Events).forEach(function( bind ){
	
				var tEvent = bind.split('.')[0],
					tNamespace = bind.substring(tEvent.length);
	
				if ( (!event || event === tEvent) && (!namespace || namespace === tNamespace) ) {
					delete scope_Events[bind];
				}
			});
		}
	
		// Updateable: margin, limit, step, range, animate, snap
		function updateOptions ( optionsToUpdate, fireSetEvent ) {
	
			// Spectrum is created using the range, snap, direction and step options.
			// 'snap' and 'step' can be updated, 'direction' cannot, due to event binding.
			// If 'snap' and 'step' are not passed, they should remain unchanged.
			var v = valueGet(), newOptions = testOptions({
				start: [0, 0],
				margin: optionsToUpdate.margin,
				limit: optionsToUpdate.limit,
				step: optionsToUpdate.step === undefined ? options.singleStep : optionsToUpdate.step,
				range: optionsToUpdate.range,
				animate: optionsToUpdate.animate,
				snap: optionsToUpdate.snap === undefined ? options.snap : optionsToUpdate.snap
			});
	
			['margin', 'limit', 'range', 'animate'].forEach(function(name){
	
				// Only change options that we're actually passed to update.
				if ( optionsToUpdate[name] !== undefined ) {
					options[name] = optionsToUpdate[name];
				}
			});
	
			// Save current spectrum direction as testOptions in testRange call
			// doesn't rely on current direction
			newOptions.spectrum.direction = scope_Spectrum.direction;
			scope_Spectrum = newOptions.spectrum;
	
			// Invalidate the current positioning so valueSet forces an update.
			scope_Locations = [-1, -1];
			valueSet(optionsToUpdate.start || v, fireSetEvent);
		}
	
	
		// Throw an error if the slider was already initialized.
		if ( scope_Target.noUiSlider ) {
			throw new Error('Slider was already initialized.');
		}
	
		// Create the base element, initialise HTML and set classes.
		// Add handles and links.
		scope_Base = addSlider( options.dir, options.ort, scope_Target );
		scope_Handles = addHandles( options.handles, options.dir, scope_Base );
	
		// Set the connect classes.
		addConnection ( options.connect, scope_Target, scope_Handles );
	
		if ( options.pips ) {
			pips(options.pips);
		}
	
		if ( options.tooltips ) {
			tooltips();
		}
	
		scope_Self = {
			destroy: destroy,
			steps: getCurrentStep,
			on: bindEvent,
			off: removeEvent,
			get: valueGet,
			set: valueSet,
			updateOptions: updateOptions,
			options: originalOptions, // Issue #600
			target: scope_Target, // Issue #597
			pips: pips // Issue #594
		};
	
		// Attach user events.
		events( options.events );
	
		return scope_Self;
	
	}
	
	
		// Run the standard initializer
		function initialize ( target, originalOptions ) {
	
			if ( !target.nodeName ) {
				throw new Error('noUiSlider.create requires a single element.');
			}
	
			// Test the options and create the slider environment;
			var options = testOptions( originalOptions, target ),
				slider = closure( target, options, originalOptions );
	
			// Use the public value method to set the start values.
			slider.set(options.start);
	
			target.noUiSlider = slider;
			return slider;
		}
	
		// Use an object instead of a function for future expansibility;
		return {
			create: initialize
		};
	
	}));

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	    isIOS: function isIOS() {
	        return navigator.userAgent.match(/iPhone|iPad|iPod/i) != null;
	    },
	    getBodyScrollTop: function getBodyScrollTop() {
	        return self.pageYOffset || document.documentElement && document.documentElement.scrollTop || document.body && document.body.scrollTop;
	    },
	    getBodyMiddlePos: function getBodyMiddlePos() {
	        return this.getBodyScrollTop() + document.documentElement.clientHeight * 0.5;
	    },
	    //узнать настоящую полную высоту блока с заданным max-height
	    getTrueHeight: function getTrueHeight($block) {
	        var el = $block.clone().css({
	            height: 'auto',
	            width: $block.width(),
	            overflow: 'hidden',
	            'max-height': 'none'
	        }).insertAfter($block);
	
	        var trueHeight = el.outerHeight(true);
	        el.remove();
	
	        return trueHeight;
	    },
	    number_format: __webpack_require__(164),
	
	    setMaskedPhone: function setMaskedPhone($element) {
	        $element.mask('+7(999)999-99-99', { autoclear: false });
	    },
	    setMaskedPhoneCity: function setMaskedPhoneCity($element) {
	        $element.mask('+7(999)999-99-99 (городской)', { autoclear: false });
	    },
	    setMaskedPhoneMobile: function setMaskedPhoneMobile($element) {
	        $element.mask('+7(999)999-99-99 (мобильный)', { autoclear: false });
	    },
	
	    getCookie: function getCookie(name) {
	        var matches = document.cookie.match('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)');
	        return matches ? decodeURIComponent(matches[1]) : undefined;
	    },
	
	    setCookie: function setCookie(name, value, options) {
	        options = options || {};
	
	        var expires = options.expires;
	
	        if (typeof expires == 'number' && expires) {
	            var d = new Date();
	            d.setTime(d.getTime() + expires * 1000);
	            expires = options.expires = d;
	        }
	        if (expires && expires.toUTCString) {
	            options.expires = expires.toUTCString();
	        }
	
	        value = encodeURIComponent(value);
	
	        var updatedCookie = name + '=' + value;
	
	        for (var propName in options) {
	            updatedCookie += '; ' + propName;
	            var propValue = options[propName];
	            if (propValue !== true) {
	                updatedCookie += '=' + propValue;
	            }
	        }
	
	        document.cookie = updatedCookie;
	    },
	    deleteCookie: function deleteCookie(name) {
	        var cookie_date = new Date();
	        cookie_date.setTime(cookie_date.getTime() - 1);
	        document.cookie = name += "=; expires=" + cookie_date.toGMTString();
	    }
	};

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function number_format(number, decimals, decPoint, thousandsSep) {
	  // eslint-disable-line camelcase
	  //  discuss at: https://locutus.io/php/number_format/
	  // original by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
	  // improved by: Kevin van Zonneveld (https://kvz.io)
	  // improved by: davook
	  // improved by: Brett Zamir (https://brett-zamir.me)
	  // improved by: Brett Zamir (https://brett-zamir.me)
	  // improved by: Theriault (https://github.com/Theriault)
	  // improved by: Kevin van Zonneveld (https://kvz.io)
	  // bugfixed by: Michael White (https://getsprink.com)
	  // bugfixed by: Benjamin Lupton
	  // bugfixed by: Allan Jensen (https://www.winternet.no)
	  // bugfixed by: Howard Yeend
	  // bugfixed by: Diogo Resende
	  // bugfixed by: Rival
	  // bugfixed by: Brett Zamir (https://brett-zamir.me)
	  //  revised by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
	  //  revised by: Luke Smith (https://lucassmith.name)
	  //    input by: Kheang Hok Chin (https://www.distantia.ca/)
	  //    input by: Jay Klehr
	  //    input by: Amir Habibi (https://www.residence-mixte.com/)
	  //    input by: Amirouche
	  //   example 1: number_format(1234.56)
	  //   returns 1: '1,235'
	  //   example 2: number_format(1234.56, 2, ',', ' ')
	  //   returns 2: '1 234,56'
	  //   example 3: number_format(1234.5678, 2, '.', '')
	  //   returns 3: '1234.57'
	  //   example 4: number_format(67, 2, ',', '.')
	  //   returns 4: '67,00'
	  //   example 5: number_format(1000)
	  //   returns 5: '1,000'
	  //   example 6: number_format(67.311, 2)
	  //   returns 6: '67.31'
	  //   example 7: number_format(1000.55, 1)
	  //   returns 7: '1,000.6'
	  //   example 8: number_format(67000, 5, ',', '.')
	  //   returns 8: '67.000,00000'
	  //   example 9: number_format(0.9, 0)
	  //   returns 9: '1'
	  //  example 10: number_format('1.20', 2)
	  //  returns 10: '1.20'
	  //  example 11: number_format('1.20', 4)
	  //  returns 11: '1.2000'
	  //  example 12: number_format('1.2000', 3)
	  //  returns 12: '1.200'
	  //  example 13: number_format('1 000,50', 2, '.', ' ')
	  //  returns 13: '100 050.00'
	  //  example 14: number_format(1e-8, 8, '.', '')
	  //  returns 14: '0.00000001'
	
	  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
	  var n = !isFinite(+number) ? 0 : +number;
	  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
	  var sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
	  var dec = typeof decPoint === 'undefined' ? '.' : decPoint;
	  var s = '';
	
	  var toFixedFix = function toFixedFix(n, prec) {
	    if (('' + n).indexOf('e') === -1) {
	      return +(Math.round(n + 'e+' + prec) + 'e-' + prec);
	    } else {
	      var arr = ('' + n).split('e');
	      var sig = '';
	      if (+arr[1] + prec > 0) {
	        sig = '+';
	      }
	      return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec);
	    }
	  };
	
	  // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
	  s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.');
	  if (s[0].length > 3) {
	    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	  }
	  if ((s[1] || '').length < prec) {
	    s[1] = s[1] || '';
	    s[1] += new Array(prec - s[1].length + 1).join('0');
	  }
	
	  return s.join(dec);
	};
	//# sourceMappingURL=number_format.js.map

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */,
/* 170 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debounce = __webpack_require__(52);
	__webpack_require__(170);
	
	var size = __webpack_require__(55);
	var functions = __webpack_require__(163);
	
	jQuery(function () {
	    var $filter = $('#js-filter');
	    var $container = $filter.closest('.main-container');
	    var $overlay = $('#overlay').addClass('overlay--filter');
	
	    //при ресете формы вручную вызвать change у инпутов ценыт от/до,
	    //чтобы заставить сработать смену визуальной части слайдера цен.
	    $filter.find('form input[type=reset]').click(function () {
	        var $form = $(this).closest('form');
	        setTimeout(function () {
	            $form.find('.priceslider__input').change();
	        }, 100);
	    });
	
	    //развернуть скрытые варианты фильтра
	    $(document).on('click', '.js-expand-filter-variants', function () {
	        var $this = $(this);
	        var $variantsBlock = $this.closest('.filter__variants');
	        var $hiddenVarsBlock = $variantsBlock.find('.filter__hidden-variants');
	
	        if ($variantsBlock.hasClass('filter__variants--full')) {
	            $hiddenVarsBlock.css('max-height', 0);
	            $variantsBlock.removeClass('filter__variants--full');
	        } else {
	            var trueHeight = functions.getTrueHeight($hiddenVarsBlock);
	
	            $hiddenVarsBlock.css('max-height', trueHeight + 'px');
	            $variantsBlock.addClass('filter__variants--full');
	        }
	    });
	
	    //скрыть весь блок фильтра при клике по заголовку
	    $(document).on('click', '.js-filter-title-expandable', function () {
	        var $this = $(this);
	
	        if ($this.hasClass('js-filter-title-inactive')) return;
	
	        var $filterBlock = $this.closest('.filter__param');
	        var $filterVariants = $filterBlock.find('.filter__variants');
	        $filterVariants.css('max-height', $filterVariants.height() + 'px');
	        var trueHeight = functions.getTrueHeight($filterVariants);
	
	        if ($this.hasClass('filter__title--collapse')) {
	            $filterVariants.css('max-height', trueHeight + 'px');
	            $this.removeClass('filter__title--collapse');
	            $filterBlock.removeClass('filter__param--collapsed');
	            setTimeout(function () {
	                $filterVariants.css('max-height', 'none');
	            }, 500);
	        } else {
	            $filterVariants.css('max-height', trueHeight + 'px');
	            setTimeout(function () {
	                $filterVariants.css('max-height', 0);
	                $this.addClass('filter__title--collapse');
	                $filterBlock.addClass('filter__param--collapsed');
	            }, 20);
	        }
	    });
	
	    //кнопка, показывающая фильтр
	    $(document).on('click', '#js-btn-filter', function () {
	        showFilter($(this));
	    });
	
	    //кнопка, скрывающая фильтр
	    $(document).on('click', '.js-hide-filter', function (e) {
	        e.preventDefault();
	        $('.js-filter-popup').remove();
	        hideFilter();
	    });
	
	    //показать фильтр (мобильная и планшетная версии)
	    function showFilter($btn) {
	        if (window.innerWidth >= size.desktop) {
	            //в десктопе такой кнопки нету
	        } else if (window.innerWidth >= size.tablet) {
	                $overlay.show(20, function () {
	                    $overlay.addClass('overlay--shown');
	                });
	
	                var pos = $btn.offset().top + $btn.innerHeight();
	                $filter.css('top', pos + 'px');
	
	                $filter.show(20, function () {
	                    $filter.addClass('filter--shown');
	                    $filter.find('.filter__common-title').width($btn.outerWidth() + 'px');
	                });
	            } else {
	                $filter.addClass('filter--shown');
	                $container.addClass('main-container--shifted-left');
	
	                $filter.addClass('filter--autoheight');
	                if ($filter.height() > $container.height()) $container.css('min-height', $filter.height() + 'px');
	                $filter.removeClass('filter--autoheight');
	            }
	    }
	
	    //скрытие фильтра
	    function hideFilter() {
	        if (window.innerWidth >= size.tablet) {
	            $overlay.removeClass('overlay--shown');
	            setTimeout(function () {
	                $overlay.hide();
	            }, 350);
	            $filter.removeClass('filter--shown');
	        } else {
	            $container.removeClass('main-container--shifted-left');
	            $container.css('min-height', '0');
	
	            $filter.removeClass('filter--shown');
	        }
	    }
	
	    //настройка фильтра при смене разрешения,
	    //очищение от стилей и классов, нужных только для других  разрешениях
	    function setUpFilter() {
	        var $desktopHolder = $('#js-filter-desktop-holder');
	
	        if (window.innerWidth >= size.tablet) {
	            if ($filter.hasClass('filter--mobile')) {
	                $filter.removeClass('filter--mobile filter--shown');
	                $container.removeClass('main-container--shifted-left');
	            }
	
	            $filter.find('.js-filter-title-expandable').addClass('js-filter-title-inactive');
	            $filter.find('.filter__title--collapse').removeClass('filter__title--collapse');
	            $filter.find('.filter__param--collapsed').removeClass('filter__param--collapsed');
	            $filter.find('.filter__variants--visible').css('max-height', 'none');
	        } else {
	            $filter.find('.js-filter-title-expandable').removeClass('js-filter-title-inactive');
	        }
	
	        if (window.innerWidth >= size.desktop) {
	            $filter.removeClass('filter--tablet filter--mobile filter--shown').show();
	            $overlay.removeClass('overlay--shown');
	            setTimeout(function () {
	                $overlay.hide();
	            }, 350);
	
	            $desktopHolder.append($filter);
	        } else if (window.innerWidth >= size.tablet) {
	            var $btn = $('#js-btn-filter');
	            $filter.find('.filter__common-title').width($btn.outerWidth() + 'px');
	            $filter.removeClass('filter--mobile');
	            $filter.addClass('filter--tablet');
	            $container.append($filter);
	        } else {
	            if ($filter.hasClass('filter--tablet')) $filter.removeClass('filter--tablet filter--shown').css('top', 0).show();
	
	            $overlay.removeClass('overlay--shown');
	            setTimeout(function () {
	                $overlay.hide();
	            }, 350);
	
	            $filter.addClass('filter--mobile');
	            $container.append($filter);
	        }
	    }
	
	    debounce.setResizeDebounce(setUpFilter);
	    setUpFilter();
	
	    //скрыть фильтр если кликнули по контенту (мобильная версия)
	    $(document).on('click', '.main-container--shifted-left .container', function (e) {
	        e.stopPropagation();
	        e.preventDefault();
	
	        $container.removeClass('main-container--shifted-left');
	        $container.css('min-height', '0');
	
	        $filter.removeClass('filter--shown');
	    });
	
	    //скрыть фильтр при клике по оверлею (планшетная версия)
	    $overlay.click(function () {
	        $overlay.removeClass('overlay--shown');
	        setTimeout(function () {
	            $overlay.hide();
	        }, 350);
	
	        if (window.innerWidth <= size.desktop) {
	            $filter.removeClass('filter--shown');
	            setTimeout(function () {
	                $filter.hide();
	            }, 350);
	        }
	    });
	});

/***/ }),
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(49);
	__webpack_require__(205);
	
	jQuery(function () {
	    $('.js-digest-mini-slider').each(function () {
	        var $this = $(this);
	
	        $this.slick($.extend({}, slickDefaults.params, {
	            slidesToShow: 1
	        }));
	    });
	
	    if ($('#section_descr').html()) {
	        $('.js-scroll-link').removeClass('digest__more-link-hidden');
	    }
	
	    $('.js-digest-video-popup').click(function () {
	        var $this = $(this);
	        var videoType = $this.data('type');
	        var videoSrc = $this.data('src');
	        var sectId = $this.data('id');
	        if (videoType === 'remote') {
	            videoSrc != '' && window.modalSectionVideo && window.modalSectionVideo(videoSrc);
	        } else {
	            (function () {
	                var url = '/ajax/action/catalog_section_digest/get_popup/';
	                var time = new Date().getTime() + 400;
	                window.mxLoader && window.mxLoader.show();
	
	                $.ajax({
	                    url: url,
	                    data: {
	                        id: sectId,
	                        src: videoSrc
	                    },
	                    type: 'post',
	                    success: function success(result) {
	                        // Ограничение минимального времени загрузки формы
	                        time = time - new Date().getTime();
	                        time = time > 0 ? time : 0;
	
	                        setTimeout(function () {
	                            window.mxLoader && window.mxLoader.hide(0);
	                            window.modalSectionVideo(result.html);
	                        }, time);
	                    }
	                });
	            })();
	        }
	    });
	
	    $(window).on('resize', function () {
	        var element = document.querySelector('.jqi--digest-video');
	        if (element) {
	            var $player = undefined,
	                player = undefined,
	                width = undefined,
	                originWidth = undefined,
	                originHeight = undefined;
	            player = element.querySelector('iframe');
	
	            if (player) {
	                $player = $(player);
	                width = $player.width();
	                originWidth = parseInt($player.attr('width')) || parseInt(player.style.width);
	                originHeight = parseInt($player.attr('height')) || parseInt(player.style.height);
	            }
	
	            if (width && width > 0 && originWidth > 0 && originHeight > 0) {
	                var ratio = originWidth / originHeight;
	                var height = width / ratio;
	
	                $player.css({ 'max-height': height + 'px' });
	            }
	        }
	    });
	});
	
	// Метод для вызова всплывающего окна, содержащего iframe видео, размещенного на youtube,
	// либо локальный видеофайл, обернутый в верстку штатного видеоплеера Битрикс
	window.modalSectionVideo = function (source) {
	    window.mxLoader = window.mxLoader || undefined;
	
	    $.prompt(source, {
	        classes: {
	            prompt: 'jqi--width-by-content jqi--digest-video'
	        }
	    });
	
	    $(window).trigger('resize');
	};

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(49);
	__webpack_require__(213);
	
	var size = __webpack_require__(55);
	
	jQuery(function () {
	    $('.js-slick-cat-slider').each(function () {
	        var $this = $(this);
	
	        $this.slick($.extend({}, slickDefaults.params, {
	            slidesToShow: 4,
	            responsive: [{
	                breakpoint: size.desktop,
	                settings: { slidesToShow: 4 }
	            }, {
	                breakpoint: size.tabletBig,
	                settings: { slidesToShow: 2, dots: true }
	            }, {
	                breakpoint: size.tablet,
	                settings: { slidesToShow: 2, dots: true }
	            }, {
	                breakpoint: size.mobileBig,
	                settings: { slidesToShow: 1, dots: true }
	            }]
	        }));
	    });
	});

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */,
/* 215 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(239)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(240)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(84);
	var defined = __webpack_require__(81);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(88);
	var $export = __webpack_require__(59);
	var redefine = __webpack_require__(241);
	var hide = __webpack_require__(64);
	var Iterators = __webpack_require__(242);
	var $iterCreate = __webpack_require__(243);
	var setToStringTag = __webpack_require__(246);
	var getPrototypeOf = __webpack_require__(248);
	var ITERATOR = __webpack_require__(247)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(64);


/***/ }),
/* 242 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(244);
	var descriptor = __webpack_require__(73);
	var setToStringTag = __webpack_require__(246);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(64)(IteratorPrototype, __webpack_require__(247)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(66);
	var dPs = __webpack_require__(75);
	var enumBugKeys = __webpack_require__(90);
	var IE_PROTO = __webpack_require__(86)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(71)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(245).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(60).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(65).f;
	var has = __webpack_require__(74);
	var TAG = __webpack_require__(247)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(87)('wks');
	var uid = __webpack_require__(89);
	var Symbol = __webpack_require__(60).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(74);
	var toObject = __webpack_require__(139);
	var IE_PROTO = __webpack_require__(86)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(254);
	var ITERATOR = __webpack_require__(247)('iterator');
	var Iterators = __webpack_require__(242);
	module.exports = __webpack_require__(61).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(80);
	var TAG = __webpack_require__(247)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(260);
	var global = __webpack_require__(60);
	var hide = __webpack_require__(64);
	var Iterators = __webpack_require__(242);
	var TO_STRING_TAG = __webpack_require__(247)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(261);
	var step = __webpack_require__(262);
	var Iterators = __webpack_require__(242);
	var toIObject = __webpack_require__(78);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(240)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 262 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * jQuery serializeObject
	 * @copyright 2014, macek <paulmacek@gmail.com>
	 * @link https://github.com/macek/jquery-serialize-object
	 * @license BSD
	 * @version 2.5.0
	 */
	(function(root, factory) {
	
	  // AMD
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(124)], __WEBPACK_AMD_DEFINE_RESULT__ = function(exports, $) {
	      return factory(exports, $);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	
	  // CommonJS
	  else if (typeof exports !== "undefined") {
	    var $ = require("jquery");
	    factory(exports, $);
	  }
	
	  // Browser
	  else {
	    factory(root, (root.jQuery || root.Zepto || root.ender || root.$));
	  }
	
	}(this, function(exports, $) {
	
	  var patterns = {
	    validate: /^[a-z_][a-z0-9_]*(?:\[(?:\d*|[a-z0-9_]+)\])*$/i,
	    key:      /[a-z0-9_]+|(?=\[\])/gi,
	    push:     /^$/,
	    fixed:    /^\d+$/,
	    named:    /^[a-z0-9_]+$/i
	  };
	
	  function FormSerializer(helper, $form) {
	
	    // private variables
	    var data     = {},
	        pushes   = {};
	
	    // private API
	    function build(base, key, value) {
	      base[key] = value;
	      return base;
	    }
	
	    function makeObject(root, value) {
	
	      var keys = root.match(patterns.key), k;
	
	      // nest, nest, ..., nest
	      while ((k = keys.pop()) !== undefined) {
	        // foo[]
	        if (patterns.push.test(k)) {
	          var idx = incrementPush(root.replace(/\[\]$/, ''));
	          value = build([], idx, value);
	        }
	
	        // foo[n]
	        else if (patterns.fixed.test(k)) {
	          value = build([], k, value);
	        }
	
	        // foo; foo[bar]
	        else if (patterns.named.test(k)) {
	          value = build({}, k, value);
	        }
	      }
	
	      return value;
	    }
	
	    function incrementPush(key) {
	      if (pushes[key] === undefined) {
	        pushes[key] = 0;
	      }
	      return pushes[key]++;
	    }
	
	    function encode(pair) {
	      switch ($('[name="' + pair.name + '"]', $form).attr("type")) {
	        case "checkbox":
	          return pair.value === "on" ? true : pair.value;
	        default:
	          return pair.value;
	      }
	    }
	
	    function addPair(pair) {
	      if (!patterns.validate.test(pair.name)) return this;
	      var obj = makeObject(pair.name, encode(pair));
	      data = helper.extend(true, data, obj);
	      return this;
	    }
	
	    function addPairs(pairs) {
	      if (!helper.isArray(pairs)) {
	        throw new Error("formSerializer.addPairs expects an Array");
	      }
	      for (var i=0, len=pairs.length; i<len; i++) {
	        this.addPair(pairs[i]);
	      }
	      return this;
	    }
	
	    function serialize() {
	      return data;
	    }
	
	    function serializeJSON() {
	      return JSON.stringify(serialize());
	    }
	
	    // public API
	    this.addPair = addPair;
	    this.addPairs = addPairs;
	    this.serialize = serialize;
	    this.serializeJSON = serializeJSON;
	  }
	
	  FormSerializer.patterns = patterns;
	
	  FormSerializer.serializeObject = function serializeObject() {
	    return new FormSerializer($, this).
	      addPairs(this.serializeArray()).
	      serialize();
	  };
	
	  FormSerializer.serializeJSON = function serializeJSON() {
	    return new FormSerializer($, this).
	      addPairs(this.serializeArray()).
	      serializeJSON();
	  };
	
	  if (typeof $.fn !== "undefined") {
	    $.fn.serializeObject = FormSerializer.serializeObject;
	    $.fn.serializeJSON   = FormSerializer.serializeJSON;
	  }
	
	  exports.FormSerializer = FormSerializer;
	
	  return FormSerializer;
	}));


/***/ }),
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	__webpack_require__(297);
	
	var form = __webpack_require__(315);
	
	jQuery(function () {
	    var addReviewFormHtml = $('.js-review-add_container').html();
	
	    var addReviewPrompt = {
	        addReview: {
	            html: addReviewFormHtml,
	            submit: function submit(e, v, m) {
	                e.preventDefault();
	                var $params = $.extend({}, form.formValidateDefaults, {
	                    rules: {
	                        review_name: { required: true },
	                        review_city: { required: true },
	                        review_activity: { required: true },
	                        review_rating: {},
	                        question_comment: {}
	                    },
	                    messages: {
	                        review_name: { required: 'Не указано имя' },
	                        review_city: { required: 'Не указан город' },
	                        review_activity: {
	                            required: 'Не указан род деятельности'
	                        }
	                    },
	                    submitHandler: function submitHandler() {
	                        $.ajax({
	                            type: 'POST',
	                            url: '/ajax/action/reviews/add/',
	                            data: $('form.jqiform').serializeArray(),
	                            success: function success(result) {
	                                var trackers = new _trackerTracker2['default']();
	                                trackers.onPMfrmComment();
	                                $.prompt.getState('addReview').find('.form').html('<p>' + result.html + '</p>');
	                            }
	                        });
	                        //т.к. изменилась высота блока, надо его подвинуть в видимую часть окна,
	                        // чтобы не казалось, будто он совсем пропал с экрана
	                        $.prompt.position();
	                    }
	                });
	                var $form = m.closest('form');
	                $form.validate($params);
	            }
	        }
	    };
	
	    var addQuestionPrompt = {
	        addQuestion: {
	            html: '',
	            submit: function submit(e, v, m) {
	                e.preventDefault();
	                var $params = $.extend({}, form.formValidateDefaults, {
	                    rules: {
	                        question_name: { required: true },
	                        question_email: { required: true, email: true },
	                        question_phone: { required: true, phoneMask: true },
	                        question_city: { required: true },
	                        question_activity: { required: true }
	                    },
	                    messages: {
	                        question_name: { required: 'Не указано имя' },
	                        question_city: { required: 'Не указан город' },
	                        question_activity: {
	                            required: 'Не указан род деятельности'
	                        },
	                        question_email: {
	                            required: $.validator.messages.EMAIL.required,
	                            email: $.validator.messages.EMAIL.email
	                        },
	                        question_phone: {
	                            required: $.validator.messages.PHONE.required,
	                            phoneMask: $.validator.messages.PHONE.phoneMask
	                        }
	                    },
	                    submitHandler: function submitHandler() {
	                        $.ajax({
	                            type: 'POST',
	                            url: '/ajax/action/questions/add/',
	                            data: $('form.jqiform').serializeArray(),
	                            success: function success(result) {
	                                var trackers = new _trackerTracker2['default']();
	                                trackers.onPMfrmAskQuestion();
	                                $.prompt.getState('addQuestion').find('.form').html('<p>' + result.html + '</p>');
	                            }
	                        });
	                        //т.к. изменилась высота блока, надо его подвинуть в видимую часть окна,
	                        // чтобы не казалось, будто он совсем пропал с экрана
	                        $.prompt.position();
	                        //$.prompt.close();
	                    }
	                });
	                var $form = m.closest('form');
	                $form.validate($params);
	            }
	        }
	    };
	
	    $(document).on('click', '.js-jqi-add-review', function (e) {
	        e.preventDefault();
	        $.prompt(addReviewPrompt);
	        var trackers = new _trackerTracker2['default']();
	        trackers.onPMbtnComment();
	    });
	
	    $(document).on('click', '.js-jqi-add-review-question', function (e) {
	        var elementID = $(this).data('element_id');
	        e.preventDefault();
	        $.ajax({
	            url: '/ajax/action/questions/showPopupForm/?element_id=' + elementID,
	            success: function success(result) {
	                addQuestionPrompt.addQuestion.html = result.html;
	                $.prompt(addQuestionPrompt);
	                var trackers = new _trackerTracker2['default']();
	                trackers.onPMbtnAskQuestion();
	            }
	        });
	    });
	});

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(298);
	__webpack_require__(299);
	
	var dropFile = __webpack_require__(303);
	var styledSelect = __webpack_require__(306);
	var ratingStars = __webpack_require__(312);
	var functions = __webpack_require__(163);
	
	jQuery(function () {
	    $.prompt.setDefaults({
	        promptspeed: 0,
	        overlayspeed: 300,
	        opacity: 0.5,
	        closeText: 'Закрыть',
	        loaded: function loaded() {
	            var $jqi = $('.jqi');
	            $jqi.addClass('shown');
	        },
	        beforeclose: function beforeclose(e) {
	            var $box = $(e.target);
	            $box.find('.jqi').removeClass('shown');
	        },
	        statechanging: function statechanging() {
	            var $form = $('.jqiform');
	
	            //выключить валидатор, чтоб не глючил в момент переключения состояний
	            $form.off('.validate').removeData('validator').find('.validate-equalTo-blur').off('.validate-equalTo').removeClass('validate-equalTo-blur');
	        },
	        statechanged: function statechanged(event, toStateName) {
	            var $jqi = $('.jqi');
	            var $form = $('.jqiform');
	            var $styledSelects = $jqi.find('.js-styled-select:visible');
	            styledSelect.styleSelects($styledSelects);
	            functions.setMaskedPhone($('.js-masked-phone'));
	
	            if ($form.find('.js-rating-stars').length > 0) {
	                ratingStars.setStars($form.find('.js-rating-stars'));
	            }
	
	            $form.find('.form__input--error').removeClass('form__input--error');
	            $form.find('.form__error-msg').remove();
	
	            if (toStateName == 'regFormStep3_specialist') dropFile.setDropFile($('#diploma-dropfile'));
	
	            if (toStateName == 'regFormStep2_organization') dropFile.setDropFile($('#requisites-dropfile'));
	        },
	        closeDelay: 350,
	        buttons: {}
	    });
	
	    $.prompt.setStateDefaults({
	        buttons: {}
	    });
	});

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(124)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			factory(root.jQuery);
		}
	}(this, function($) {
		'use strict';
	
		// ########################################################################
		// Base object
		// ########################################################################
	
		/**
		* Imp - Impromptu object - passing no params will not open, only return the instance
		* @param message String/Object - String of html or Object of states
		* @param options Object - Options to set the prompt
		* @return Imp - the instance of this Impromptu object
		*/
		var Imp = function(message, options){
			var t = this;
			t.id = Imp.count++;
	
			Imp.lifo.push(t);
	
			if(message){
				t.open(message, options);
			}
			return t;
		};
	
		// ########################################################################
		// static properties and methods
		// ########################################################################
	
		/**
		* defaults - the default options
		*/
		Imp.defaults = {
			prefix:'jqi',
			classes: {
				box: '',
				fade: '',
				prompt: '',
				form: '',
				close: '',
				title: '',
				message: '',
				buttons: '',
				button: '',
				defaultButton: ''
			},
			title: '',
			closeText: '&times;',
			buttons: {
				Ok: true
			},
			buttonTimeout: 1000,
			loaded: function(e){},
			submit: function(e,v,m,f){},
			close: function(e,v,m,f){},
			beforeclose: function(e,v,m,f){},
			statechanging: function(e, from, to){},
			statechanged: function(e, to){},
			opacity: 0.6,
			zIndex: 999,
			overlayspeed: 'slow',
			promptspeed: 'fast',
			show: 'fadeIn',
			hide: 'fadeOut',
			focus: 0,
			defaultButton: 0,
			useiframe: false,
			top: '15%',
			position: {
				container: null,
				x: null,
				y: null,
				arrow: null,
				width: null
			},
			persistent: true,
			timeout: 0,
			closeDelay: 10,
			states: {},
			initialState: 0,
			state: {
				name: null,
				title: '',
				html: '',
				buttons: {
					Ok: true
				},
				focus: 0,
				defaultButton: 0,
				position: {
					container: null,
					x: null,
					y: null,
					arrow: null,
					width: null
				},
				submit: function(e,v,m,f){
					return true;
				}
			}
		};
	
		/**
		* setDefaults - Sets the default options
		* @param o Object - Options to set as defaults
		* @return void
		*/
		Imp.setDefaults = function(o) {
			Imp.defaults = $.extend({}, Imp.defaults, o);
		};
	
		/**
		* setStateDefaults - Sets the default options for a state
		* @param o Object - Options to set as defaults
		* @return void
		*/
		Imp.setStateDefaults = function(o) {
			Imp.defaults.state = $.extend({}, Imp.defaults.state, o);
		};
	
		/**
		* @var Int - A counter used to provide a unique ID for new prompts
		*/
		Imp.count = 0;
	
		/**
		* @var Array - An array of Impromptu intances in a LIFO queue (last in first out)
		*/
		Imp.lifo = [];
	
		/**
		* getLast - get the last element from the queue (doesn't pop, just returns)
		* @return Imp - the instance of this Impromptu object or false if queue is empty
		*/
		Imp.getLast = function(){
			var l = Imp.lifo.length;
			return (l > 0)? Imp.lifo[l-1] : false;
		};
	
		/**
		* removeFromStack - remove an element from the lifo stack by its id
		* @param id int - id of the instance to remove
		* @return api - The api of the element removed from the stack or void
		*/
		Imp.removeFromStack = function(id){
			for(var i=Imp.lifo.length-1; i>=0; i--){
				if(Imp.lifo[i].id === id){
					return Imp.lifo.splice(i,1)[0];
				}
			}
		};
	
		// ########################################################################
		// extend our object instance properties and methods
		// ########################################################################
		Imp.prototype = {
	
			/**
			* @var Int - A unique id, simply an autoincremented number
			*/
			id: null,
	
			/**
			* open - Opens the prompt
			* @param message String/Object - String of html or Object of states
			* @param options Object - Options to set the prompt
			* @return Imp - the instance of this Impromptu object
			*/
			open: function(message, options) {
				var t = this;
	
				t.options = $.extend(true,{},Imp.defaults,options);
	
				// Be sure any previous timeouts are destroyed
				if(t.timeout){
					clearTimeout(t.timeout);
				}
				t.timeout = false;
	
				var opts = t.options,
					$body = $(document.body),
					$window = $(window);
	
				//build the box and fade
				var msgbox = '<div class="'+ opts.prefix +'box '+ opts.classes.box +'">';
				if(opts.useiframe && ($('object, applet').length > 0)) {
					msgbox += '<iframe src="javascript:false;" class="'+ opts.prefix +'fade '+ opts.classes.fade +'"></iframe>';
				} else {
					msgbox += '<div class="'+ opts.prefix +'fade '+ opts.classes.fade +'"></div>';
				}
				msgbox += '<div class="'+ opts.prefix +' '+ opts.classes.prompt +'">'+
							'<form action="#" class="'+ opts.prefix +'form '+ opts.classes.form +'">'+
								'<div class="'+ opts.prefix +'close '+ opts.classes.close +'">'+ opts.closeText +'</div>'+
								'<div class="'+ opts.prefix +'states"></div>'+
							'</form>'+
						'</div>'+
					'</div>';
	
				t.jqib = $(msgbox).appendTo($body);
				t.jqi = t.jqib.children('.'+ opts.prefix);
				t.jqif = t.jqib.children('.'+ opts.prefix +'fade');
	
				//if a string was passed, convert to a single state
				if(message.constructor === String){
					message = {
						state0: {
							title: opts.title,
							html: message,
							buttons: opts.buttons,
							position: opts.position,
							focus: opts.focus,
							defaultButton: opts.defaultButton,
							submit: opts.submit
						}
					};
				}
	
				//build the states
				t.options.states = {};
				var k,v;
				for(k in message){
					v = $.extend({},Imp.defaults.state,{name:k},message[k]);
					t.addState(v.name, v);
	
					if(t.currentStateName === ''){
						t.currentStateName = v.name;
					}
				}
	
				//Events
				t.jqi.on('click', '.'+ opts.prefix +'buttons button', function(e){
					var $t = $(this),
						$state = $t.parents('.'+ opts.prefix +'state'),
						statename = $state.data('jqi-name'),
						stateobj = t.options.states[statename],
						msg = $state.children('.'+ opts.prefix +'message'),
						clicked = stateobj.buttons[$t.text()] || stateobj.buttons[$t.html()],
						forminputs = {};
	
					// disable for a moment to prevent multiple clicks
					if(t.options.buttonTimeout > 0){
						t.disableStateButtons(statename);
						setTimeout(function(){
							t.enableStateButtons(statename);
						}, t.options.buttonTimeout);
					}
	
					// if for some reason we couldn't get the value
					if(clicked === undefined){
						for(var i in stateobj.buttons){
							if(stateobj.buttons[i].title === $t.text() || stateobj.buttons[i].title === $t.html()){
								clicked = stateobj.buttons[i].value;
							}
						}
					}
	
					if (clicked === undefined)
					{
						clicked = $t.val();
					}
	
					//collect all form element values from all states.
					$.each(t.jqi.children('form').serializeArray(),function(i,obj){
						if (forminputs[obj.name] === undefined) {
							forminputs[obj.name] = obj.value;
						} else if (typeof forminputs[obj.name] === Array || typeof forminputs[obj.name] === 'object') {
							forminputs[obj.name].push(obj.value);
						} else {
							forminputs[obj.name] = [forminputs[obj.name],obj.value];
						}
					});
	
					// trigger an event
					var promptsubmite = new $.Event('impromptu:submit');
					promptsubmite.stateName = stateobj.name;
					promptsubmite.state = $state;
					$state.trigger(promptsubmite, [clicked, msg, forminputs]);
	
					if(!promptsubmite.isDefaultPrevented()){
						t.close(true, clicked,msg,forminputs);
					}
				});
	
				// if the fade is clicked blink the prompt
				var fadeClicked = function(){
					if(opts.persistent){
						var offset = (opts.top.toString().indexOf('%') >= 0? ($window.height()*(parseInt(opts.top,10)/100)) : parseInt(opts.top,10)),
							top = parseInt(t.jqi.css('top').replace('px',''),10) - offset;
	
						//$window.scrollTop(top);
						$('html,body').animate({ scrollTop: top }, 'fast', function(){
							var i = 0;
							t.jqib.addClass(opts.prefix +'warning');
							var intervalid = setInterval(function(){
								t.jqib.toggleClass(opts.prefix +'warning');
								if(i++ > 1){
									clearInterval(intervalid);
									t.jqib.removeClass(opts.prefix +'warning');
								}
							}, 100);
						});
					}
					else {
						t.close(true);
					}
				};
	
				// listen for esc or tab keys
				var keyDownEventHandler = function(e){
					var key = (window.event) ? event.keyCode : e.keyCode;
	
					//escape key closes
					if(key === 27) {
						fadeClicked();
					}
	
					//enter key pressed trigger the default button if its not on it, ignore if it is a textarea
					if(key === 13){
						var $defBtn = t.getCurrentState().find('.'+ opts.prefix +'defaultbutton');
						var $tgt = $(e.target);
	
						if($tgt.is('textarea,.'+opts.prefix+'button') === false && $defBtn.length > 0){
							e.preventDefault();
							$defBtn.click();
						}
					}
	
					//constrain tabs, tabs should iterate through the state and not leave
					if (key === 9){
						var $inputels = $('input,select,textarea,button',t.getCurrentState());
						var fwd = !e.shiftKey && e.target === $inputels[$inputels.length-1];
						var back = e.shiftKey && e.target === $inputels[0];
						if (fwd || back) {
							setTimeout(function(){
								if (!$inputels){
									return;
								}
								var el = $inputels[back===true ? $inputels.length-1 : 0];
	
								if (el){
									el.focus();
								}
							},10);
							return false;
						}
					}
				};
	
				t.position();
				t.style();
	
				// store copy of the window resize function for interal use only
				t._windowResize = function(e){
					t.position(e);
				};
				$window.resize({ animate: false }, t._windowResize);
	
				t.jqif.click(fadeClicked);
				t.jqi.find('.'+ opts.prefix +'close').click(function(){ t.close(); });
				t.jqi.find('.'+ opts.prefix +'form').submit(function(){ return false; });
				t.jqib.on("keydown",keyDownEventHandler)
							.on('impromptu:loaded', opts.loaded)
							.on('impromptu:beforeclose', opts.beforeclose)
							.on('impromptu:close', opts.close)
							.on('impromptu:statechanging', opts.statechanging)
							.on('impromptu:statechanged', opts.statechanged);
	
				// Show it
				t.jqif[opts.show](opts.overlayspeed);
				t.jqi[opts.show](opts.promptspeed, function(){
	
					t.goToState(
						isNaN(opts.initialState) ? opts.initialState : 
							t.jqi.find('.'+ opts.prefix +'states .'+ opts.prefix +'state').eq(opts.initialState).data('jqi-name')
					);
	
					t.jqib.trigger('impromptu:loaded');
				});
	
				// Timeout
				if(opts.timeout > 0){
					t.timeout = setTimeout(function(){ t.close(true); },opts.timeout);
				}
	
				return t;
			},
	
			/**
			* close - Closes the prompt
			* @param callCallback Function - called when the transition is complete
			* @param clicked String - value of the button clicked (only used internally)
			* @param msg jQuery - The state message body (only used internally)
			* @param formvals Object - key/value pairs of all form field names and values (only used internally)
			* @return Imp - the instance of this Impromptu object
			*/
			close: function(callCallback, clicked, msg, formvals){
				var t = this;
				t.jqib.trigger('impromptu:beforeclose', [clicked,msg,formvals]);
	
				if(t.timeout){
					clearTimeout(t.timeout);
					t.timeout = false;
				}
				Imp.removeFromStack(t.id);
	
				setTimeout(function(){
					if(t.jqib){
	
						t.jqib[t.options.hide](t.options.promptspeed,function(){
	
							t.jqib.trigger('impromptu:close', [clicked,msg,formvals]);
	
							t.jqib.remove();
	
							$(window).off('resize', t._windowResize);
	
							if(typeof callCallback === 'function'){
								callCallback();
							}
						});
					}
	
				}, t.options.closeDelay);
	
				t.currentStateName = "";
				return t;
			},
	
			/**
			* addState - Injects a state into the prompt
			* @param statename String - Name of the state
			* @param stateobj Object - options for the state
			* @param afterState String - selector of the state to insert after
			* @return jQuery - the newly created state
			*/
			addState: function(statename, stateobj, afterState) {
				var t = this,
					state = '',
					$state = null,
					arrow = '',
					title = '',
					opts = t.options,
					pos = $.isFunction(stateobj.position) ? stateobj.position() : stateobj.position,
					$jqistates = t.jqi.find('.'+ opts.prefix +'states'),
					buttons = [],
					showHtml,defbtn,k,v,l,i=0;
	
				stateobj = $.extend({},Imp.defaults.state, {name:statename}, stateobj);
	
				if($.isPlainObject(pos) && pos.arrow !== null){
					arrow = '<div class="'+ opts.prefix + 'arrow '+ opts.prefix + 'arrow'+ pos.arrow +'"></div>';
				}
				if(stateobj.title && stateobj.title !== ''){
					title = '<div class="lead '+ opts.prefix + 'title '+ opts.classes.title +'">'+  stateobj.title +'</div>';
				}
	
				showHtml = stateobj.html;
				if (typeof stateobj.html === 'function') {
					showHtml = 'Error: html function must return text';
				}
	
				state += '<div class="'+ opts.prefix + 'state" data-jqi-name="'+ statename +'">'+
							arrow + title +
							'<div class="'+ opts.prefix +'message '+ opts.classes.message +'">' + showHtml +'</div>'+
							'<div class="'+ opts.prefix +'buttons'+ ($.isEmptyObject(stateobj.buttons)? 'hide ':' ') + opts.classes.buttons +'">';
	
				// state buttons may be in object or array, lets convert objects to arrays
				if($.isArray(stateobj.buttons)){
					buttons = stateobj.buttons;
				}
				else if($.isPlainObject(stateobj.buttons)){
					for(k in stateobj.buttons){
						if(stateobj.buttons.hasOwnProperty(k)){
							buttons.push({ title: k, value: stateobj.buttons[k] });
						}
					}
				}
	
				// iterate over each button and create them
				for(i=0, l=buttons.length; i<l; i++){
					v = buttons[i],
					defbtn = stateobj.focus === i || (isNaN(stateobj.focus) && stateobj.defaultButton === i) ? (opts.prefix + 'defaultbutton ' + opts.classes.defaultButton) : '';
	
					state += '<button class="'+ opts.classes.button +' '+ opts.prefix + 'button '+ defbtn;
	
					if(typeof v.classes !== "undefined"){
						state += ' '+ ($.isArray(v.classes)? v.classes.join(' ') : v.classes) + ' ';
					}
	
					state += '" name="' + opts.prefix + '_' + statename + '_button' + v.title.replace(/[^a-z0-9]+/gi,'') + '" value="' + v.value + '">' + v.title + '</button>';
				}
				
				state += '</div></div>';
	
				$state = $(state).css({display:'none'});
	
				$state.on('impromptu:submit', stateobj.submit);
	
				if(afterState !== undefined){
					t.getState(afterState).after($state);
				}
				else{
					$jqistates.append($state);
				}
	
				t.options.states[statename] = stateobj;
	
				return $state;
			},
	
			/**
			* removeState - Removes a state from the prompt
			* @param state String - Name of the state
			* @param newState String - Name of the state to transition to
			* @return Boolean - returns true on success, false on failure
			*/
			removeState: function(state, newState) {
				var t = this,
					$state = t.getState(state),
					rm = function(){ $state.remove(); };
	
				if($state.length === 0){
					return false;
				}
	
				// transition away from it before deleting
				if($state.css('display') !== 'none'){
					if(newState !== undefined && t.getState(newState).length > 0){
						t.goToState(newState, false, rm);
					}
					else if($state.next().length > 0){
						t.nextState(rm);
					}
					else if($state.prev().length > 0){
						t.prevState(rm);
					}
					else{
						t.close();
					}
				}
				else{
					$state.slideUp('slow', rm);
				}
	
				return true;
			},
	
			/**
			* getApi - Get the api, so you can extract it from $.prompt stack
			* @return jQuery - the prompt
			*/
			getApi: function() {
				return this;
			},
	
			/**
			* getBox - Get the box containing fade and prompt
			* @return jQuery - the prompt
			*/
			getBox: function() {
				return this.jqib;
			},
	
			/**
			* getPrompt - Get the prompt
			* @return jQuery - the prompt
			*/
			getPrompt: function() {
				return this.jqi;
			},
	
			/**
			* getState - Get the state by its name
			* @param statename String - Name of the state
			* @return jQuery - the state
			*/
			getState: function(statename) {
				return this.jqi.find('[data-jqi-name="'+ statename +'"]');
			},
	
			/**
			* getCurrentState - Get the current visible state
			* @return jQuery - the current visible state
			*/
			getCurrentState: function() {
				return this.getState(this.getCurrentStateName());
			},
	
			/**
			* getCurrentStateName - Get the name of the current visible state/substate
			* @return String - the current visible state's name
			*/
			getCurrentStateName: function() {
				return this.currentStateName;
			},
	
			/**
			* disableStateButtons - Disables the buttons in a state
			* @param statename String - Name of the state containing buttons
			* @param buttons Array - Array of button values to disable. By default all are disabled
			* @param enable Boolean - True to enable the buttons instead of disabling (internally use only)
			* @return Void
			*/
			disableStateButtons: function(statename, buttons, enable) {
				var t = this;
	
				if($.isArray(statename)){
					buttons = statename;
					statename = null;
				}
				
				t.getState(statename || t.getCurrentStateName()).find('.'+ t.options.prefix + 'button').each(function(i,btn){
					if(buttons === undefined || $.inArray(btn.value, buttons) !== -1){
						btn.disabled = !enable;
					}
				});
			},
	
			/**
			* enableStateButtons - Enables the buttons in a state
			* @param statename String - Name of the state containing buttons. Defaults to current state
			* @param buttons Array - Array of button values to enable. By default all are enabled
			* @return Void
			*/
			enableStateButtons: function(statename, buttons) {
				this.disableStateButtons(statename, buttons, true);
			},
	
			/**
			* position - Repositions the prompt (Used internally)
			* @return void
			*/
			position: function(e){
				var t = this,
					restoreFx = $.fx.off,
					$state = t.getCurrentState(),
					stateObj = t.options.states[$state.data('jqi-name')],
					pos = stateObj ? $.isFunction(stateObj.position) ? stateObj.position() : stateObj.position : undefined,
					$window = $(window),
					bodyHeight = document.body.scrollHeight, //$(document.body).outerHeight(true),
					windowHeight = $(window).height(),
					documentHeight = $(document).height(),
					height = (bodyHeight > windowHeight) ? bodyHeight : windowHeight,
					scrollTop = parseInt($window.scrollTop(),10),
					top = scrollTop + (t.options.top.toString().indexOf('%') >= 0?
							(windowHeight*(parseInt(t.options.top,10)/100)) : parseInt(t.options.top,10));
	
				// when resizing the window turn off animation
				if(e !== undefined && e.data.animate === false){
					$.fx.off = true;
				}
	
				t.jqib.css({
					position: "absolute",
					height: height,
					width: "100%",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0
				});
				t.jqif.css({
					position: "fixed",
					height: height,
					width: "100%",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0
				});
	
				// tour positioning
				if(pos && pos.container){
					var offset = $(pos.container).offset(),
						hasScrolled = false;
						
					if($.isPlainObject(offset) && offset.top !== undefined){
						top = (offset.top + pos.y) - (t.options.top.toString().indexOf('%') >= 0? (windowHeight*(parseInt(t.options.top,10)/100)) : parseInt(t.options.top,10));
	
						t.jqi.css({
							position: "absolute"
						});
						t.jqi.animate({
							top: offset.top + pos.y,
							left: offset.left + pos.x,
							marginLeft: 0,
							width: (pos.width !== undefined)? pos.width : null
						}, function(){
							// if it didn't scroll before, check that the bottom is within view. Since width 
							// is animated we must use the callback before we know the height
							if(!hasScrolled && (offset.top + pos.y + t.jqi.outerHeight(true)) > (scrollTop + windowHeight)){
								$('html,body').animate({ scrollTop: top }, 'slow', 'swing', function(){});
								hasScrolled = true;
							}
						});
	
						// scroll if the top is out of the viewing area
						if(top < scrollTop || top > scrollTop + windowHeight){
							$('html,body').animate({ scrollTop: top }, 'slow', 'swing', function(){});
							hasScrolled = true;
						}
					}
				}
				// custom state width animation
				else if(pos && pos.width){
					t.jqi.css({
							position: "absolute",
							left: '50%'
						});
					t.jqi.animate({
							top: pos.y || top,
							left: pos.x || '50%',
							marginLeft: ((pos.width/2)*-1),
							width: pos.width
						});
				}
				// standard prompt positioning
				else{
					t.jqi.css({
						position: "absolute",
						top: top,
						left: '50%',//$window.width()/2,
						marginLeft: ((t.jqi.outerWidth(false)/2)*-1)
					});
				}
	
				// restore fx settings
				if(e !== undefined && e.data.animate === false){
					$.fx.off = restoreFx;
				}
			},
	
			/**
			* style - Restyles the prompt (Used internally)
			* @return void
			*/
			style: function(){
				var t = this;
				
				t.jqif.css({
					zIndex: t.options.zIndex,
					display: "none",
					opacity: t.options.opacity
				});
				t.jqi.css({
					zIndex: t.options.zIndex+1,
					display: "none"
				});
				t.jqib.css({
					zIndex: t.options.zIndex
				});
			},
	
			/**
			* goToState - Goto the specified state
			* @param state String - name of the state to transition to
			* @param subState Boolean - true to be a sub state within the currently open state
			* @param callback Function - called when the transition is complete
			* @return jQuery - the newly active state
			*/
			goToState: function(state, subState, callback) {
				var t = this,
					$jqi = t.jqi,
					jqiopts = t.options,
					$state = t.getState(state),
					stateobj = jqiopts.states[$state.data('jqi-name')],
					promptstatechanginge = new $.Event('impromptu:statechanging'),
					opts = t.options;
	
				if(stateobj !== undefined){
	
	
					if (typeof stateobj.html === 'function') {
						var contentLaterFunc = stateobj.html;
						$state.find('.' + opts.prefix +'message ').html(contentLaterFunc());
					}
	
					// subState can be ommitted
					if(typeof subState === 'function'){
						callback = subState;
						subState = false;
					}
	
					t.jqib.trigger(promptstatechanginge, [t.getCurrentStateName(), state]);
	
					if(!promptstatechanginge.isDefaultPrevented() && $state.length > 0){
						t.jqi.find('.'+ opts.prefix +'parentstate').removeClass(opts.prefix +'parentstate');
	
						if(subState){ // hide any open substates
							// get rid of any substates
							t.jqi.find('.'+ opts.prefix +'substate').not($state)
								.slideUp(jqiopts.promptspeed)
								.removeClass('.'+ opts.prefix +'substate')
								.find('.'+ opts.prefix +'arrow').hide();
	
							// add parent state class so it can be visible, but blocked
							t.jqi.find('.'+ opts.prefix +'state:visible').addClass(opts.prefix +'parentstate');
	
							// add substate class so we know it will be smaller
							$state.addClass(opts.prefix +'substate');
						}
						else{ // hide any open states
							t.jqi.find('.'+ opts.prefix +'state').not($state)
								.slideUp(jqiopts.promptspeed)
								.find('.'+ opts.prefix +'arrow').hide();
						}
						t.currentStateName = stateobj.name;
	
						$state.slideDown(jqiopts.promptspeed,function(){
							var $t = $(this);
							t.enableStateButtons();
							
							// if focus is a selector, find it, else its button index
							if(typeof(stateobj.focus) === 'string'){
								$t.find(stateobj.focus).eq(0).focus();
							}
							else{
								$t.find('.'+ opts.prefix +'defaultbutton').focus();
							}
	
							$t.find('.'+ opts.prefix +'arrow').show(jqiopts.promptspeed);
	
							if (typeof callback === 'function'){
								t.jqib.on('impromptu:statechanged', callback);
							}
							t.jqib.trigger('impromptu:statechanged', [state]);
							if (typeof callback === 'function'){
								t.jqib.off('impromptu:statechanged', callback);
							}
						});
						if(!subState){
							t.position();
						}
					} // end isDefaultPrevented()	
				}// end stateobj !== undefined
	
				return $state;
			},
	
			/**
			* nextState - Transition to the next state
			* @param callback Function - called when the transition is complete
			* @return jQuery - the newly active state
			*/
			nextState: function(callback) {
				var t = this,
					$next = t.getCurrentState().next();
				if($next.length > 0){
					t.goToState( $next.data('jqi-name'), callback );
				}
				return $next;
			},
	
			/**
			* prevState - Transition to the previous state
			* @param callback Function - called when the transition is complete
			* @return jQuery - the newly active state
			*/
			prevState: function(callback) {
				var t = this,
					$prev = t.getCurrentState().prev();
				if($prev.length > 0){
					t.goToState( $prev.data('jqi-name'), callback );
				}
				return $prev;
			}
	
		};
	
		// ########################################################################
		// $.prompt will manage a queue of Impromptu instances
		// ########################################################################
	
		/**
		* $.prompt create a new Impromptu instance and push it on the stack of instances
		* @param message String/Object - String of html or Object of states
		* @param options Object - Options to set the prompt
		* @return jQuery - the jQuery object of the prompt within the modal
		*/
		$.prompt = function(message, options){
			var api = new Imp(message, options);
			return api.jqi;
		};
	
		/**
		* Copy over static methods
		*/
		$.each(Imp, function(k,v){
			$.prompt[k] = v;
		});
	
		/**
		* Create a proxy for accessing all instance methods. The close method pops from queue.
		*/
		$.each(Imp.prototype, function(k,v){
			$.prompt[k] = function(){
				var api = Imp.getLast(); // always use the last instance on the stack
	
				if(api && typeof api[k] === "function"){
					return api[k].apply(api, arguments);
				}
			};
		});
	
		// ########################################################################
		// jQuery Plugin and public access
		// ########################################################################
	
		/**
		* Enable using $('.selector').prompt({});
		* This will grab the html within the prompt as the prompt message
		*/
		$.fn.prompt = function(options){
			if(options === undefined){
				options = {};
			}
			if(options.withDataAndEvents === undefined){
				options.withDataAndEvents = false;
			}
	
			$.prompt($(this).clone(options.withDataAndEvents).html(),options);
		};
	
		/**
		* Export it as Impromptu and $.prompt
		* Can be used from here forth as new Impromptu(states, opts)
		*/
		window.Impromptu = Imp;
	
	}));


/***/ }),
/* 299 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(304);
	
	// reference: https://css-tricks.com/drag-and-drop-file-uploading/
	
	jQuery(function () {
	    // feature detection for drag&drop upload
	    var isAdvancedUpload = (function () {
	        var div = document.createElement('div');
	        return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
	    })();
	
	    module.exports.setDropFile = function ($dropContainer) {
	        // applying the effect for every form
	        $dropContainer.each(function () {
	            var $this = $(this),
	                $input = $this.find('input[type="file"]'),
	                $textContainer = $this.find('.drop-file__text'),
	
	            //$errorMsg	 = $this.find( '.box__error span' ),
	            droppedFiles = false,
	                showFiles = function showFiles(files) {
	                var $fileName = $textContainer.find('.drop-file__filename');
	                if ($fileName.length == 0) {
	                    $textContainer.append('<div class="drop-file__filename" />');
	                    $fileName = $textContainer.find('.drop-file__filename');
	                }
	
	                $fileName.text(files.length > 1 ? ($input.attr('data-multiple-caption') || '').replace('{count}', files.length) : files[0].name);
	            };
	
	            // letting the server side to know we are going to make an Ajax request
	            //$this.append( '<input type="hidden" name="ajax" value="1" />' );
	
	            // automatically submit the form on file select
	            $input.on('change', function (e) {
	                showFiles(e.target.files);
	            });
	
	            // drag&drop files if the feature is available
	            if (isAdvancedUpload) {
	                $this.addClass('has-advanced-upload') // letting the CSS part to know drag&drop is supported by the browser
	                .on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
	                    // preventing the unwanted behaviours
	                    e.preventDefault();
	                    e.stopPropagation();
	                }).on('dragover dragenter', function () //
	                {
	                    $this.addClass('is-dragover');
	                }).on('dragleave dragend drop', function () {
	                    $this.removeClass('is-dragover');
	                }).on('drop', function (e) {
	                    droppedFiles = e.originalEvent.dataTransfer.files; // the files that were dropped
	                    showFiles(droppedFiles);
	                });
	            }
	        });
	    };
	});

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */,
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(307);
	__webpack_require__(309);
	
	var styleSelects = function styleSelects($select) {
	    $select.each(function () {
	        var $this = $(this);
	
	        $this.select2({
	            language: 'ru',
	            minimumResultsForSearch: Infinity,
	            dropdownParent: $this.parent()
	        }).on('select2:open', function () {
	            var $options = $this.parent().find('.select2-container--default .select2-results > .select2-results__options');
	
	            $options.mCustomScrollbar('destroy');
	            $options.mCustomScrollbar('update');
	
	            setTimeout(function () {
	                $options.mCustomScrollbar({
	                    axis: 'y',
	                    scrollbarPosition: 'inside',
	                    advanced: {
	                        updateOnContentResize: true
	                    },
	                    live: true
	                });
	            }, 0);
	        });
	    });
	};
	
	module.exports.styleSelects = styleSelects;

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */,
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(310);

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */,
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(313);
	
	jQuery(function () {
	    var setStars = function setStars($ratingStars) {
	        if ($ratingStars == undefined) $ratingStars = $('.js-rating-stars');
	
	        var $elementRate = $ratingStars.find('.rating-stars__star-yellow');
	        var curSelectedValElementRate = $elementRate.filter('.rating-stars__star-yellow--filled').length;
	
	        $ratingStars.each(function () {
	            var $this = $ratingStars;
	            var $stars = $this.find('.rating-stars__star');
	            var $input = $this.find('.rating-stars__hidden-value');
	
	            var curSelectedVal = $stars.filter('.rating-stars__star--filled').length;
	            if (curSelectedVal >= 1) curSelectedVal -= 1;
	
	            $stars.hover(function () {
	                var $curStar = $(this);
	                $stars.removeClass('rating-stars__star--filled');
	                $curStar.prevAll('.rating-stars__star').andSelf().addClass('rating-stars__star--hover');
	            }, function () {
	                $stars.removeClass('rating-stars__star--hover');
	                $stars.slice(0, curSelectedVal).addClass('rating-stars__star--filled');
	            });
	
	            $stars.click(function () {
	                var $curStar = $(this);
	                $curStar.prevAll('.rating-stars__star').andSelf().addClass('rating-stars__star--filled');
	
	                curSelectedVal = $stars.filter('.rating-stars__star--filled').length;
	                $input.val(curSelectedVal);
	            });
	
	            if (curSelectedValElementRate >= 1) curSelectedValElementRate -= 1;
	
	            $elementRate.hover(function () {
	                var $curStar = $(this);
	                $elementRate.removeClass('rating-stars__star-yellow--filled');
	                $curStar.prevAll('.rating-stars__star-yellow').andSelf().addClass('rating-stars__star-yellow--hover');
	            }, function () {
	                $elementRate.removeClass('rating-stars__star-yellow--hover');
	                $elementRate.slice(0, curSelectedValElementRate).addClass('rating-stars__star-yellow--filled');
	            });
	        });
	    };
	
	    setStars();
	
	    module.exports.setStars = setStars;
	});
	
	/* При клике на звездочку устаналиваем оценку для элемента */
	$('.js-rating-stars').find('.rating-stars__star-yellow').one('click', function () {
	    var $curStar = $(this);
	    $curStar.prevAll('.rating-stars__star-yellow').andSelf().addClass('rating-stars__star-yellow--filled');
	    $.ajax({
	        url: '/ajax/action/element_rate/add/',
	        data: 'rating=' + $('.js-rating-stars').find('.rating-stars__star-yellow').filter('.rating-stars__star-yellow--filled').length + '&element_id=' + $('input[name="rate_element_id"]').val() + '&entity_id=' + $('input[name="rate_entity_id"]').val(),
	        success: function success() {
	            $.ajax({
	                url: '/ajax/component/maximaster:element.rate/element/',
	                data: 'ENTITY_ID=' + $('input[name="rate_entity_id"]').val() + '&ELEMENT_ID=' + $('input[name="rate_element_id"]').val(),
	                success: function success(result) {
	                    $('.product-card__element_rate-container').html(result.html);
	                }
	            });
	        }
	    });
	});
	
	/* Вызываем окно авторизации, если кликает не авторизированный пользователь */
	$(document).on('click', '.js-rating-show-auth', function () {
	    if (!$('.jqi').hasClass('shown')) {
	        $('.js-jqi-show-login').trigger('click');
	    }
	});

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */,
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(316);
	var functions = __webpack_require__(163);
	
	jQuery(function () {
	    module.exports.formValidateDefaults = {
	        errorPlacement: function errorPlacement(error, element) {
	            element.addClass('form__input--error');
	            element.removeClass('form__input--correct');
	            var $elParent = element.parent();
	            $elParent.removeClass('icon-field--correct');
	            error.addClass('form__error-msg');
	
	            if (element.attr('type') == 'checkbox' || element.attr('type') == 'radio' || element.attr('type') == 'file') {
	                var $formField = element.closest('.form__field');
	                var $headlabel = $formField.find('.prompt__head-label').first();
	                error.addClass('form__error-msg--custom');
	
	                if ($headlabel.length > 0) {
	                    error.insertAfter($headlabel);
	                } else {
	                    $formField.prepend(error);
	                }
	            } else {
	                error.insertBefore($elParent);
	            }
	        },
	        focusInvalid: false,
	        onkeyup: false,
	        success: function success(label, element) {
	            label.remove();
	            var $el = $(element).removeClass('form__input--error');
	            $el.addClass('form__input--correct');
	            var $elParent = $el.parent();
	            $elParent.addClass('icon-field--correct');
	        },
	        errorElement: 'div',
	        onclick: false
	    };
	
	    functions.setMaskedPhone($('.js-masked-phone'));
	    functions.setMaskedPhoneCity($('.js-masked-phone-city'));
	    functions.setMaskedPhoneMobile($('.js-masked-phone-mobile'));
	});

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */,
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$assign = __webpack_require__(133)['default'];
	
	var _getIterator = __webpack_require__(319)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var _blocksTrackerEvents = __webpack_require__(131);
	
	var _blocksTrackerEvents2 = _interopRequireDefault(_blocksTrackerEvents);
	
	__webpack_require__(297);
	
	var form = __webpack_require__(315);
	
	var trackers = new _trackerTracker2['default']();
	
	$(function () {
	    var validateParams = _Object$assign({}, form.formValidateDefaults, {
	        rules: {
	            NAME: {
	                required: true
	            },
	            EMAIL: {
	                required: true,
	                email: true,
	                remote: {
	                    url: '/ajax/action/order_oneclick/check_user_person_type/',
	                    type: 'post',
	                    dataType: 'json',
	                    dataFilter: function dataFilter(response) {
	                        var result = false;
	
	                        response = JSON.parse(response);
	                        if (response.data.hasOwnProperty('is_opt')) {
	                            result = !response.data.is_opt;
	                        }
	
	                        return result;
	                    }
	                }
	            },
	            PHONE: {
	                required: true,
	                phoneMask: true
	            }
	        },
	        messages: {
	            NAME: {
	                required: $.validator.messages.NAME.required
	            },
	            EMAIL: {
	                required: $.validator.messages.EMAIL.required,
	                remote: $.validator.messages.EMAIL.remote
	            },
	            PHONE: {
	                required: $.validator.messages.PHONE.required,
	                phoneMask: $.validator.messages.PHONE.phoneMask
	            }
	        },
	        submitHandler: function submitHandler(form) {
	            var params = $(form).serializeObject();
	
	            params.products = [{
	                id: document.querySelector('.js-one-click').dataset.productId,
	                quantity: 1
	            }];
	
	            $(form).find('button[type="submit"]').prop('disabled', true);
	
	            oneClickBuy(params).done(function () {
	                $(form).find('button[type="submit"]').prop('disabled', false);
	            });
	        }
	    });
	
	    function oneClickBuy(params) {
	        return $.post('/ajax/action/order_oneclick/buy/', params, function (response) {
	            if (response.code >= 200 && response.code < 300) {
	                showSuccess(response.data.success);
	                trackers.onOneClickBuyEnd({
	                    fbpixel: {
	                        value: parseInt(document.querySelector('.product-card__price-value').textContent.replace(' ', ''))
	                    }
	                });
	            } else if (response.data.error) {
	                showError(response.data.error);
	            } else {
	                showError('Ошибка создания заказа, пожалуйста перезагрузите страницу!');
	            }
	        }, 'json');
	    }
	
	    function showSuccess(message) {
	        if (popup) {
	            popup.close();
	        }
	        var list = document.getElementsByClassName('breadcrumbs__text');
	        var ierarhy = [];
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = _getIterator(list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var item = _step.value;
	
	                ierarhy.push(item.innerHTML);
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator['return']) {
	                    _iterator['return']();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        var category = ierarhy.slice(2, -1).join('/');
	        var name = ierarhy.slice(-1)[0];
	        trackers.onPMfrm1Click({ param1: category, param2: name });
	        new Impromptu(message, {
	            buttons: {},
	            persistent: false,
	            close: function close(event) {
	                event.preventDefault();
	                document.location.reload('/');
	            }
	        });
	    }
	
	    function showError(error) {
	        error = error.join('<br>');
	        $('.js-oneclick_error').html(error);
	    }
	
	    var popupHtml = '';
	    var popup = null;
	
	    function showPopup(popupHtml) {
	        return new Impromptu(popupHtml, {
	            buttons: {},
	            persistent: false,
	            submit: function submit(event, value, message) {
	                var form = message.closest('form');
	
	                /** revalidate */
	                if (form.data('validator')) {
	                    form.data('validator').destroy();
	                }
	                form.validate(_Object$assign({}, validateParams, {
	                    submitHandler: function submitHandler(form) {
	                        var params = $(form).serializeObject();
	
	                        params.products = [{
	                            id: document.querySelector('.js-one-click').dataset.productId,
	                            quantity: 1
	                        }];
	
	                        $(form).find('button[type="submit"]').prop('disabled', true);
	
	                        oneClickBuy(params).done(function () {
	                            $(form).find('button[type="submit"]').prop('disabled', false);
	                        });
	                    }
	                }));
	
	                event.preventDefault();
	            }
	        });
	    }
	
	    /**
	     * На карточке товара
	     */
	    $('body').on('click', '.js-one-click', function (event) {
	        event.preventDefault();
	        trackers.onOneClickBuyButton();
	        if (popupHtml == '') {
	            $.ajax({
	                url: '/ajax/component/maximaster:order.oneclick/popup/',
	                success: function success(result) {
	                    popupHtml = result.html;
	                    popup = showPopup(popupHtml);
	                    var list = document.getElementsByClassName('breadcrumbs__text');
	                    var ierarhy = [];
	
	                    var _iteratorNormalCompletion2 = true;
	                    var _didIteratorError2 = false;
	                    var _iteratorError2 = undefined;
	
	                    try {
	                        for (var _iterator2 = _getIterator(list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                            var item = _step2.value;
	
	                            ierarhy.push(item.innerHTML);
	                        }
	                    } catch (err) {
	                        _didIteratorError2 = true;
	                        _iteratorError2 = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	                                _iterator2['return']();
	                            }
	                        } finally {
	                            if (_didIteratorError2) {
	                                throw _iteratorError2;
	                            }
	                        }
	                    }
	
	                    var category = ierarhy.slice(2, -1).join('/');
	                    var name = ierarhy.slice(-1)[0];
	                    trackers.onPMbtn1Click({ param1: category, param2: name });
	                }
	            });
	        } else {
	            popup = showPopup(popupHtml);
	        }
	    });
	
	    /**
	     * В оформлении заказа
	     */
	    if ($('div.checkout').length > 0) {
	        $('.js-oneclick-component > form').validate(_Object$assign({}, validateParams, {
	            submitHandler: function submitHandler(form) {
	                var params = $(form).serializeObject();
	                var ev = new _blocksTrackerEvents2['default']();
	
	                $(form).find('button[type="submit"]').prop('disabled', true);
	
	                ev.onShowOrderStep(2);
	                ev.onShowOrderStep(3);
	                trackers.onOneClickBuyEnd({
	                    fbpixel: {
	                        value: parseInt(document.querySelector('.cart-total__line-value--main').textContent.replace(' ', ''))
	                    }
	                });
	
	                oneClickBuy(params).done(function () {
	                    $(form).find('button[type="submit"]').prop('disabled', false);
	                });
	            }
	        }));
	    }
	});

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(320), __esModule: true };

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(259);
	__webpack_require__(238);
	module.exports = __webpack_require__(321);


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(66);
	var get = __webpack_require__(253);
	module.exports = __webpack_require__(61).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */,
/* 348 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/catalog_section.3b5bf5aa7268883bea0e.js